// shirts-carousel-filter.js
// Football Shirts filter — Category → League → Team → Product Type
// Auto-detects if the current collection is in the hierarchy; hides otherwise.

(function() {
  'use strict';

  if (!window.ShirtsHierarchy) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var currentLocation = null;

  function init() {
    var wrapper = document.querySelector('.sf-nav-wrapper');
    if (!wrapper) return;

    var currentHandle = wrapper.dataset.currentHandle;
    if (!currentHandle) return;

    var location = findInHierarchy(currentHandle);
    if (!location) {
      // Not a shirt collection — hide the shirt filter card but keep the
      // catalog switcher visible so customers can navigate away.
      // If the SHOE filter is active, hide our catalog switcher to avoid duplication.
      var shoeWrapper = document.querySelector('.hcf-nav-wrapper');
      var shoeIsActive = shoeWrapper && shoeWrapper.querySelector('.hcf-item') !== null;

      var inner = wrapper.querySelector('.sf-nav-inner');
      if (inner) {
        Array.prototype.forEach.call(inner.children, function(child) {
          if (!child.classList || !child.classList.contains('cs-catalog-tabs')) {
            child.style.display = 'none';
          }
        });
        if (shoeIsActive) {
          var shirtTabs = inner.querySelector('.cs-catalog-tabs');
          if (shirtTabs) shirtTabs.style.display = 'none';
          wrapper.style.display = 'none';
        }
      }
      var stickyBar = document.getElementById('sf-sticky-bar');
      if (stickyBar) stickyBar.remove();
      var fab = document.getElementById('sf-fab');
      if (fab) fab.remove();
      var expandedOverlay = document.getElementById('sf-expanded-overlay');
      if (expandedOverlay) expandedOverlay.remove();
      return;
    }

    // For gender landings, activeGender = the landing gender directly
    if (location.isGenderLanding) {
      location.activeGender = location.landingGender;
    } else {
      location.activeGender = detectGenderFromUrl();
    }
    location.activeType   = detectTypeTagFromUrl(location);
    location.activeSeason = detectSeasonFromUrl(location);

    currentLocation = location;

    renderGenderTabs(wrapper, location);
    renderCategories(wrapper, location);
    renderLeagues(wrapper, location);
    renderTeams(wrapper, location);
    renderTypes(wrapper, location);
    renderSeasons(wrapper, location);
    renderFooterChips(wrapper, location);
    renderBreadcrumb(wrapper, location);

    // Add helper class if the deep rows (teams + types) are both hidden
    var teamsRow = wrapper.querySelector('[data-level="teams"]');
    var typesRow = wrapper.querySelector('[data-level="types"]');
    var teamsHidden = !teamsRow || teamsRow.style.display === 'none';
    var typesHidden = !typesRow || typesRow.style.display === 'none';
    wrapper.classList.toggle('sf-leagues-only', teamsHidden && typesHidden);

    wrapper.querySelectorAll('.sf-carousel').forEach(setupArrows);
    setTimeout(function() {
      wrapper.querySelectorAll('.sf-item.is-active').forEach(scrollIntoView);
    }, 100);

    setupScrollHints(wrapper);
    setupStickyBar(wrapper, location);
    setupExpandedOverlay(wrapper);
    setupFAB(wrapper);
  }

  // ============ HELPERS ============

  // Unwrap league.handle if it's a string OR array of aliases (returns first alias or null)
  function leagueHandleStr(league) {
    if (!league) return null;
    if (Array.isArray(league.handle)) return league.handle[0];
    return league.handle || null;
  }

  // Get the productTypes list for a given category.
  //   - Football/F1: fixed list from cat.productTypes or global fallback
  //   - Casual: season-conditional — pass activeSeason as 2nd arg
  //     Returns [] if season required but not set (guided flow — Type row hidden)
  function getProductTypes(cat, activeSeason) {
    if (cat && cat.typesBySeason) {
      if (!activeSeason) return [];
      return cat.typesBySeason[activeSeason] || [];
    }
    // Explicit empty array means "this category has no product types" — respect it.
    // Only fall through to global if productTypes is completely undefined.
    if (cat && Array.isArray(cat.productTypes)) return cat.productTypes;
    return window.ShirtsHierarchy.productTypes || [];
  }

  // Is this category's team level suppressed (e.g., F1 has no sub-teams)?
  function isTeamLevelSuppressed(cat) {
    return cat && cat.teamRowLabel === null;
  }

  // Returns { url, buttonText } for a clickable row label, or null if not applicable.
  //
  //   cat         — active category object
  //   rowLevel    — 'leagues' | 'teams' | 'types'
  //   location    — current location object
  //   activeTag   — the currently active tag in this row (or null)
  //   displayName — the display title matching activeTag (e.g., "Cap" for tag "F1 caps");
  //                 falls back to activeTag if not provided
  function getLabelClickUrl(cat, rowLevel, location, activeTag, displayName) {
    if (!cat || !cat.labelClicks) return null;
    var cfg = cat.labelClicks[rowLevel];
    if (!cfg || !activeTag) return null;

    var url = null;
    if (cfg.pattern === 'brand-collection') {
      // Lowercase-hyphenate the tag to produce a collection handle
      // (e.g., "Nike" → "nike", "Tommy Hilfiger" → "tommy-hilfiger")
      var handle = activeTag.toLowerCase().replace(/\s+/g, '-');
      url = '/collections/' + handle;
    } else if (cfg.pattern === 'handle-map' && cfg.handleMap && cfg.handleMap[activeTag]) {
      url = '/collections/' + cfg.handleMap[activeTag];
    } else if (cfg.pattern === 'parent-plus-tag') {
      var parent = cat.handle || location.categoryHandle;
      url = '/collections/' + parent + '?filter.p.tag=' + encodeURIComponent(activeTag);
    }

    if (!url) return null;

    // Build button text from format template
    var name = displayName || activeTag;
    var format = cfg.buttonTextFormat || 'Shop {name}';
    var buttonText = format.replace('{name}', name);

    return { url: url, buttonText: buttonText };
  }

  // Apply the "shop X" button to a row label. If clickInfo is null, resets
  // the label to plain text (defaultLabel).
  //
  //   clickInfo   — { url, buttonText } from getLabelClickUrl, or null
  //   defaultLabel — the plain text to show when no filter is active
  function applyLabelClick(row, clickInfo, defaultLabel) {
    var label = row.querySelector('.sf-row-label');
    if (!label) return;

    if (clickInfo && clickInfo.url) {
      // Render as burgundy pill button — impossible to miss
      label.innerHTML = '';
      var btn = document.createElement('a');
      btn.className = 'sf-label-btn';
      btn.href = clickInfo.url;
      btn.textContent = clickInfo.buttonText;
      btn.setAttribute('aria-label', clickInfo.buttonText);
      label.appendChild(btn);
      label.classList.add('sf-label-has-btn');
    } else {
      // Plain text label (no active filter)
      label.textContent = defaultLabel;
      label.classList.remove('sf-label-has-btn');
    }
  }

  // ============ MOBILE SCROLL HINTS (COMBO: fade + peek + delayed arrow) ============
  function setupScrollHints(wrapper) {
    if (window.matchMedia && !window.matchMedia('(max-width: 768px)').matches) return;

    setTimeout(function() {
      var rows = wrapper.querySelectorAll('.sf-row-content');
      var anyOverflowed = false;
      var alreadyPeeked = false;
      try { alreadyPeeked = sessionStorage.getItem('sf_peek_played') === '1'; } catch (e) {}

      rows.forEach(function(rowContent) {
        var carousel = rowContent.querySelector('.sf-carousel');
        if (!carousel) return;

        var overflows = carousel.scrollWidth > carousel.clientWidth + 4;
        if (!overflows) return;

        anyOverflowed = true;
        rowContent.classList.add('sf-has-overflow');

        if (!rowContent.querySelector('.sf-scroll-arrow')) {
          var arrow = document.createElement('div');
          arrow.className = 'sf-scroll-arrow';
          arrow.innerHTML = '<svg width="14" height="14" viewBox="0 0 20 20" fill="none"><path d="M8 4L14 10L8 16" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          rowContent.appendChild(arrow);
        }

        if (!alreadyPeeked) {
          carousel.classList.add('sf-peek');
          setTimeout(function() { carousel.classList.remove('sf-peek'); }, 3000);
        }

        var arrowTimer = setTimeout(function() {
          if (!rowContent.classList.contains('sf-scrolled')) {
            rowContent.classList.add('sf-show-arrow');
            setTimeout(function() {
              rowContent.classList.remove('sf-show-arrow');
            }, 6000);
          }
        }, 2000);

        var onScroll = function() {
          rowContent.classList.add('sf-scrolled');
          rowContent.classList.remove('sf-show-arrow');
          clearTimeout(arrowTimer);
          if (carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4) {
            rowContent.classList.remove('sf-has-overflow');
          }
          carousel.removeEventListener('scroll', onScroll);
          carousel.addEventListener('scroll', function() {
            var atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4;
            rowContent.classList.toggle('sf-has-overflow', !atEnd);
          }, { passive: true });
        };
        carousel.addEventListener('scroll', onScroll, { passive: true });
      });

      if (anyOverflowed && !alreadyPeeked) {
        try { sessionStorage.setItem('sf_peek_played', '1'); } catch (e) {}
      }
    }, 250);
  }

  // ============ STICKY BAR / EXPANDED OVERLAY / FAB ============

  function setupStickyBar(wrapper, location) {
    var stickyBar = document.getElementById('sf-sticky-bar');
    var stickyPath = document.getElementById('sf-sticky-path');
    var stickyBack = document.getElementById('sf-sticky-back');
    var stickyScrollTop = document.getElementById('sf-sticky-scroll-top');
    if (!stickyBar || !wrapper) return;

    var pathTextEl = stickyBar.querySelector('.sf-sticky-path-text');
    if (pathTextEl) pathTextEl.textContent = buildStickyPathText(location);

    var backTarget = getBackTarget(location);
    if (backTarget) {
      stickyBack.disabled = false;
      stickyBack.onclick = function() { window.location.href = backTarget; };
    } else {
      stickyBack.disabled = true;
    }

    if (stickyScrollTop) {
      stickyScrollTop.onclick = function() {
        wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
    }

    if (stickyPath) stickyPath.onclick = openExpandedOverlay;

    var ticking = false;
    function updateVisibility() {
      var wrapperBottom = wrapper.getBoundingClientRect().bottom;
      if (wrapperBottom < 0) {
        stickyBar.classList.add('is-visible');
        stickyBar.setAttribute('aria-hidden', 'false');
      } else {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateVisibility);
        ticking = true;
      }
    }, { passive: true });
    updateVisibility();
  }

  function buildStickyPathText(loc) {
    if (!loc) return 'All Jerseys';
    var parts = [];
    var cat = window.ShirtsHierarchy.categories[loc.categoryHandle];

    // Gender label: only show if category has gender tabs; support Men/Women/Kids
    if (!(cat && cat.hideGenderTabs)) {
      var genderLabel;
      if (cat && cat.genderTabs && cat.genderTabs[loc.activeGender] && cat.genderTabs[loc.activeGender].label) {
        genderLabel = cat.genderTabs[loc.activeGender].label;
      } else if (loc.activeGender === 'women') {
        genderLabel = 'Women';
      } else if (loc.activeGender === 'kids') {
        genderLabel = 'Kids';
      } else {
        genderLabel = 'Men';
      }
      parts.push(genderLabel);
    }

    if (cat) parts.push(cat.title);
    if (loc.leagueHandle) {
      var lg = cat && cat.leagues && cat.leagues[loc.leagueHandle];
      // For F1's synthetic 'f1' league, don't add "F1 Brands" — redundant with category
      if (lg && loc.leagueHandle !== 'f1') parts.push(lg.title);
    }
    if (loc.teamHandle) {
      var lg2 = cat && cat.leagues && cat.leagues[loc.leagueHandle];
      var t = lg2 && lg2.teams && lg2.teams[loc.teamHandle];
      if (t) parts.push(t.title);
    }
    if (loc.activeType) {
      var types = getProductTypes(cat, loc.activeSeason);
      var match = types.filter(function(p) { return p.tag === loc.activeType; })[0];
      if (match) parts.push(match.title);
    }
    return parts.join(' › ');
  }

  function getBackTarget(loc) {
    if (!loc) return null;
    var cat = window.ShirtsHierarchy.categories[loc.categoryHandle];
    var league = cat && cat.leagues && cat.leagues[loc.leagueHandle];
    var team = league && league.teams && league.teams[loc.teamHandle];
    var isTagBasedTeam = team && team.tag && league && league.handle;

    // Type filter active → clear type
    if (loc.activeType && loc.teamHandle) {
      if (isTagBasedTeam) {
        return buildUrl(leagueHandleStr(league), loc.activeGender, null, team.tag);
      }
      return buildUrl(loc.teamHandle, loc.activeGender, null);
    }
    // Team active → go up to league
    if (loc.teamHandle && loc.leagueHandle) {
      if (isTagBasedTeam) {
        return buildUrl(leagueHandleStr(league), loc.activeGender, null);
      }
      return buildUrl(loc.leagueHandle, loc.activeGender, null);
    }
    // League active → go up to category
    if (loc.leagueHandle && loc.categoryHandle) {
      return buildUrl(loc.categoryHandle, loc.activeGender, null);
    }
    return null;
  }

  function setupExpandedOverlay(wrapper) {
    var overlay = document.getElementById('sf-expanded-overlay');
    if (!overlay) return;
    var backdrop = overlay.querySelector('.sf-expanded-backdrop');
    var closeBtn = document.getElementById('sf-expanded-close');
    if (closeBtn) closeBtn.onclick = closeExpandedOverlay;
    if (backdrop) backdrop.onclick = closeExpandedOverlay;
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeExpandedOverlay();
      }
    });
  }

  function openExpandedOverlay() {
    var overlay = document.getElementById('sf-expanded-overlay');
    var content = document.getElementById('sf-expanded-content');
    var wrapper = document.querySelector('.sf-nav-wrapper');
    if (!overlay || !content || !wrapper) return;

    content.innerHTML = '';
    wrapper.querySelectorAll('.sf-row').forEach(function(row) {
      if (row.style.display === 'none') return;
      var clone = row.cloneNode(true);
      content.appendChild(clone);
    });

    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeExpandedOverlay() {
    var overlay = document.getElementById('sf-expanded-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function setupFAB(wrapper) {
    var fab = document.getElementById('sf-fab');
    if (!fab || !wrapper) return;
    fab.onclick = function() {
      wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    var ticking = false;
    function update() {
      var wrapperBottom = wrapper.getBoundingClientRect().bottom;
      if (wrapperBottom < -300) fab.classList.add('is-visible');
      else fab.classList.remove('is-visible');
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  // ============ LOCATION DETECTION ============

  function findInHierarchy(handle) {
    // GENDER LANDING pages: /collections/women, /collections/men, /collections/kids
    // These are top-level gender landings (not tied to a specific category).
    // We return a synthetic location with `isGenderLanding: true` so the renderers
    // show the categories row with the landing gender pre-selected, but no
    // specific category/league/team active.
    if (handle === 'women' || handle === 'men' || handle === 'kids') {
      return {
        categoryHandle: null,
        leagueHandle: null,
        teamHandle: null,
        level: 'landing',
        isGenderLanding: true,
        landingGender: handle
      };
    }

    // Special case: kids-t-shirt is the Kids gender landing page.
    if (handle === 'kids-t-shirt') {
      return { categoryHandle: 'football-jerseys', leagueHandle: null, teamHandle: null, level: 'category' };
    }

    // CATEGORY-LEVEL GENDER HANDLES (Casual):
    // Check for category-level gender handles (e.g., men-casual-out-fit → casual-shirts)
    for (var cCatHandle in window.ShirtsHierarchy.categories) {
      var cCat = window.ShirtsHierarchy.categories[cCatHandle];
      if (!cCat.genderHandles) continue;
      for (var cGender in cCat.genderHandles) {
        if (cCat.genderHandles[cGender] === handle) {
          return {
            categoryHandle: cCatHandle,
            leagueHandle: null,
            teamHandle: null,
            level: 'category'
          };
        }
      }
    }

    // GYM detection: check for gender-specific handles (men-jackets, women-tops, etc.)
    // Uses the gymCatCategory's leagues where each has a genderHandles map.
    var gymCat = window.ShirtsHierarchy.categories['gym-shirts'];
    if (gymCat && gymCat.leagues) {
      for (var gymLgHandle in gymCat.leagues) {
        var gymLg = gymCat.leagues[gymLgHandle];
        if (!gymLg.genderHandles) continue;
        for (var gKey in gymLg.genderHandles) {
          if (gymLg.genderHandles[gKey] === handle) {
            // Matched a men-* or women-* collection → gym category + this league is active
            return {
              categoryHandle: 'gym-shirts',
              leagueHandle: gymLgHandle,
              teamHandle: null,
              level: 'league',
              gymGender: gKey   // remember which gender-specific handle they hit
            };
          }
        }
      }
    }

    var categories = window.ShirtsHierarchy.categories;
    for (var catHandle in categories) {
      var cat = categories[catHandle];
      var leagues = cat.leagues || {};

      // (1) Handle-based team match: /collections/arsenal → team = arsenal
      //     Also matches F1 brands like /collections/f1-ferrari
      for (var lgHandle in leagues) {
        var lg = leagues[lgHandle];
        if (lg.teams && lg.teams[handle]) {
          return { categoryHandle: catHandle, leagueHandle: lgHandle, teamHandle: handle, level: 'team' };
        }
      }

      // (2) League match — supports:
      //     (a) hierarchy key equals collection handle (Premier League, La Liga, etc.)
      //     (b) league.handle is a STRING (tag-based leagues like International Kits)
      //     (c) league.handle is an ARRAY of aliases (multiple collection URLs → same league)
      for (var lgHandle2 in leagues) {
        var lg2 = leagues[lgHandle2];
        var leagueHandles = lg2.handle;
        var isMatch = false;
        if (Array.isArray(leagueHandles)) {
          isMatch = leagueHandles.indexOf(handle) !== -1;
        } else {
          isMatch = ((leagueHandles || lgHandle2) === handle);
        }
        if (isMatch) {
          // For tag-based leagues, check URL for team tag
          var teamHandle = null;
          if (lg2.handle) {
            teamHandle = detectTagBasedTeamFromUrl(lg2);
          }
          return {
            categoryHandle: catHandle,
            leagueHandle: lgHandle2,
            teamHandle: teamHandle,
            level: teamHandle ? 'team' : 'league'
          };
        }
      }

      // (3) Category match: /collections/football-jerseys OR /collections/f1
      var catParent = cat.handle || catHandle;
      if (catParent === handle) {
        return { categoryHandle: catHandle, leagueHandle: null, teamHandle: null, level: 'category' };
      }
    }
    return null;
  }

  function detectTagBasedTeamFromUrl(league) {
    if (!league || !league.teams) return null;
    try {
      var params = new URLSearchParams(window.location.search);
      var urlTags = params.getAll('filter.p.tag');
      for (var teamKey in league.teams) {
        var team = league.teams[teamKey];
        if (!team.tag) continue;
        for (var i = 0; i < urlTags.length; i++) {
          if (urlTags[i] === team.tag) return teamKey;
        }
      }
    } catch (e) {}
    return null;
  }

  function detectGenderFromUrl() {
    try {
      var wrapper = document.querySelector('.sf-nav-wrapper');
      var currentHandle = wrapper && wrapper.dataset.currentHandle;
      if (currentHandle === 'kids-t-shirt') return 'kids';

      // Gym: detect gender from the current collection handle (men-* or women-*)
      // OR from the ?filter.p.tag=Women / ?filter.p.tag=Men URL param
      var gymCat = window.ShirtsHierarchy.categories['gym-shirts'];
      if (gymCat && gymCat.leagues) {
        for (var lg in gymCat.leagues) {
          var gh = gymCat.leagues[lg].genderHandles || {};
          for (var g in gh) {
            if (gh[g] === currentHandle) return g;  // men-jackets → 'men'
          }
        }
      }

      // Casual (and any category with category-level genderHandles):
      // detect gender from the parent handle mapping
      for (var casCatH in window.ShirtsHierarchy.categories) {
        var casCat = window.ShirtsHierarchy.categories[casCatH];
        if (!casCat.genderHandles) continue;
        for (var casG in casCat.genderHandles) {
          if (casCat.genderHandles[casG] === currentHandle) return casG;
        }
      }

      var params = new URLSearchParams(window.location.search);
      var tags = params.getAll('filter.p.tag');
      for (var i = 0; i < tags.length; i++) {
        var t = tags[i].toLowerCase();
        if (t === 'kids') return 'kids';
        if (t === 'women') return 'women';
        // 'men' tag also possible, but 'men' is the default so we only need to detect if explicitly set
      }
      // Check current handle for the gym parent — default to men
      if (currentHandle === (gymCat && gymCat.handle)) return (gymCat.defaultGender || 'men');

      return 'men';
    } catch (e) { return 'men'; }
  }

  function detectTypeTagFromUrl(location) {
    try {
      var cat = location && window.ShirtsHierarchy.categories[location.categoryHandle];
      // For Casual (typesBySeason), scan ALL seasons' types since we don't know the active season yet
      var typesToCheck = [];
      if (cat && cat.typesBySeason) {
        for (var seasonKey in cat.typesBySeason) {
          typesToCheck = typesToCheck.concat(cat.typesBySeason[seasonKey]);
        }
      } else {
        typesToCheck = getProductTypes(cat);
      }
      var params = new URLSearchParams(window.location.search);
      var tags = params.getAll('filter.p.tag');
      for (var i = 0; i < tags.length; i++) {
        for (var j = 0; j < typesToCheck.length; j++) {
          if (tags[i] === typesToCheck[j].tag) return typesToCheck[j].tag;
        }
      }
      return null;
    } catch (e) { return null; }
  }

  // Detects active season TAG in the URL (Gym only — reads cat.seasons)
  function detectSeasonFromUrl(location) {
    try {
      var cat = location && window.ShirtsHierarchy.categories[location.categoryHandle];
      if (!cat || !cat.seasons || !cat.seasons.length) return null;
      var params = new URLSearchParams(window.location.search);
      var tags = params.getAll('filter.p.tag');
      for (var i = 0; i < tags.length; i++) {
        for (var j = 0; j < cat.seasons.length; j++) {
          if (tags[i] === cat.seasons[j].tag) return cat.seasons[j].tag;
        }
      }
      return null;
    } catch (e) { return null; }
  }

  // ============ URL BUILDING ============
  function buildUrl(collectionHandle, gender, typeTag, teamTag, extraTag) {
    var url = '/collections/' + collectionHandle;
    var params = [];
    // Gender tag: only add when the collection ISN'T already gender-specific.
    // Gender-specific gym collections (men-*, women-*) already restrict to that gender
    // via their smart-collection rules, so adding the tag would be redundant.
    var isGenderSpecific = /^(men|women)-/.test(collectionHandle) || collectionHandle === 'kids-t-shirt';
    if (gender === 'kids' && !isGenderSpecific)  params.push('filter.p.tag=' + encodeURIComponent('Kids'));
    if (gender === 'women' && !isGenderSpecific) params.push('filter.p.tag=' + encodeURIComponent('Women'));
    if (teamTag)  params.push('filter.p.tag=' + encodeURIComponent(teamTag));
    if (typeTag)  params.push('filter.p.tag=' + encodeURIComponent(typeTag));
    if (extraTag) params.push('filter.p.tag=' + encodeURIComponent(extraTag));
    if (params.length) url += '?' + params.join('&');
    return url;
  }

  // ============ RENDERERS ============

  function renderGenderTabs(wrapper, location) {
    var row = wrapper.querySelector('[data-level="gender"]');
    if (!row) return;

    var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

    // If the category opts out of gender tabs entirely (e.g., Caps — unisex),
    // hide the whole row. This is different from just hiding individual tabs;
    // it removes the gender row from the layout completely.
    if (cat && cat.hideGenderTabs) {
      row.style.display = 'none';
      return;
    }
    // Make sure the row is visible for other categories (in case a previous
    // Caps navigation left it hidden — reset to default display)
    row.style.display = '';

    // GENDER LANDING pages: no category yet, so pick a tab set based on the landing.
    // - /collections/women or /men → Men | Women (with landing gender pre-active)
    // - /collections/kids → Men | Kids (with kids pre-active)
    if (location.isGenderLanding) {
      var landingG = location.landingGender;
      // Kids landing keeps Men/Kids; women/men landings use Men/Women
      var landingGenders = (landingG === 'kids') ? ['men', 'kids'] : ['men', 'women'];
      var landingLabels = {
        men:   'Men',
        women: 'Women',
        kids:  'Kids'
      };
      ['men', 'kids', 'women'].forEach(function(g) {
        var tab = row.querySelector('[data-gender="' + g + '"]');
        if (!tab) return;
        if (landingGenders.indexOf(g) === -1) {
          tab.style.display = 'none';
          return;
        }
        tab.style.display = '';
        var labelSpan = tab.querySelector('span') || tab;
        labelSpan.textContent = landingLabels[g];
        // Each tab navigates to the corresponding /collections/<gender> landing
        tab.href = '/collections/' + g;
        tab.classList.toggle('is-active', landingG === g);
      });
      return;
    }

    // Use category-specific gender config if defined (e.g., Gym uses Men/Women)
    // Otherwise fall back to Men/Kids defaults (Football, F1)
    var genderConfig = cat && cat.genderTabs;
    var genders = genderConfig ? Object.keys(genderConfig) : ['men', 'kids'];

    // Determine base URL for gender switch
    var league = cat && cat.leagues && cat.leagues[location.leagueHandle];
    var team = league && league.teams && league.teams[location.teamHandle];
    var isTagBasedTeam = team && team.tag && league && league.handle;

    // Hide any tabs not in this category's gender set; show/update the ones that are
    ['men', 'kids', 'women'].forEach(function(g) {
      var tab = row.querySelector('[data-gender="' + g + '"]');
      if (!tab) return;
      if (genders.indexOf(g) === -1) {
        tab.style.display = 'none';
        return;
      }
      tab.style.display = '';

      // Update label if this category has a custom label
      if (genderConfig && genderConfig[g] && genderConfig[g].label) {
        var labelSpan = tab.querySelector('span') || tab;
        labelSpan.textContent = genderConfig[g].label;
      }

      // Build the URL for this gender tab
      var url;
      if (cat && cat.handle && cat.leagues && cat.leagues[location.leagueHandle] && cat.leagues[location.leagueHandle].genderHandles) {
        // Gym: switch to this gender's variant of the current category — preserve brand + season
        var lgh = cat.leagues[location.leagueHandle].genderHandles;
        var gymBrand = null, gymSeason = null;
        try {
          var pp = new URLSearchParams(window.location.search);
          var tt = pp.getAll('filter.p.tag');
          if (cat.brands) {
            for (var bi = 0; bi < cat.brands.length; bi++) {
              if (tt.indexOf(cat.brands[bi].tag) !== -1) { gymBrand = cat.brands[bi].tag; break; }
            }
          }
          if (cat.seasons) {
            for (var si = 0; si < cat.seasons.length; si++) {
              if (tt.indexOf(cat.seasons[si].tag) !== -1) { gymSeason = cat.seasons[si].tag; break; }
            }
          }
        } catch (e) {}
        url = buildUrl(lgh[g] || cat.handle, g, null, gymBrand, gymSeason);
      } else if (cat && cat.casualMode && cat.genderHandles) {
        // CASUAL: category-level gender handles. Switch to gender's parent, preserve brand/season/type
        var casBrand = null, casSeason = null;
        try {
          var ccp = new URLSearchParams(window.location.search);
          var cct = ccp.getAll('filter.p.tag');
          if (cat.brands) {
            for (var cbi = 0; cbi < cat.brands.length; cbi++) {
              if (cct.indexOf(cat.brands[cbi].tag) !== -1) { casBrand = cat.brands[cbi].tag; break; }
            }
          }
          if (cat.seasons) {
            for (var csi = 0; csi < cat.seasons.length; csi++) {
              if (cct.indexOf(cat.seasons[csi].tag) !== -1) { casSeason = cat.seasons[csi].tag; break; }
            }
          }
        } catch (e) {}
        url = buildUrl(cat.genderHandles[g] || cat.handle, g, location.activeType, casBrand, casSeason);
      } else if (cat && cat.genderTabs) {
        // Gym without a category picked yet: go to parent
        url = buildUrl(cat.handle || location.categoryHandle, g, null, null, location.activeSeason);
      } else {
        // Football / F1
        var currentColl;
        var teamTag = null;
        if (location.teamHandle) {
          if (isTagBasedTeam) { currentColl = leagueHandleStr(league); teamTag = team.tag; }
          else { currentColl = location.teamHandle; }
        } else if (location.leagueHandle) {
          currentColl = leagueHandleStr(league) || location.leagueHandle;
        } else {
          currentColl = cat.handle || location.categoryHandle;
        }
        url = buildUrl(currentColl, g, location.activeType, teamTag);
      }
      tab.href = url;
      tab.classList.toggle('is-active', location.activeGender === g);
    });
  }

  function renderCategories(wrapper, location) {
    var row = wrapper.querySelector('[data-level="categories"]');
    var carousel = wrapper.querySelector('[data-carousel="categories"]');
    if (!row || !carousel) return;
    var cats = window.ShirtsHierarchy.categories;
    var handles = Object.keys(cats);

    // Auto-hide if only 1 category exists (no need for a lone pill)
    if (handles.length <= 1) {
      row.style.display = 'none';
      return;
    }

    // On a GENDER LANDING (/collections/women, /men, /kids), reorder categories
    // so gender-supporting ones come first, and build URLs that preserve the gender.
    if (location.isGenderLanding) {
      var g = location.landingGender;
      // Sort handles: supported first, unsupported after (stable within each group)
      var supported = [];
      var unsupported = [];
      handles.forEach(function(h) {
        var supports = cats[h].supportedGenders || ['men', 'kids'];
        if (supports.indexOf(g) !== -1) supported.push(h);
        else unsupported.push(h);
      });
      handles = supported.concat(unsupported);
    }

    var items = handles.map(function(h) {
      var isCurrentCategory = h === location.categoryHandle;
      var isActive = isCurrentCategory;   // false on landings (no cat picked)
      var cat = cats[h];
      var catParent = cat.handle || h;

      // Build URL — preserve gender across category switches
      var url;
      if (location.isGenderLanding) {
        var lg = location.landingGender;
        // Category-level genderHandles (Casual): swap to gender-specific parent
        if (cat.genderHandles && cat.genderHandles[lg]) {
          url = buildUrl(cat.genderHandles[lg], lg, null);
        } else if (cat.hideGenderTabs) {
          // Unisex category (Caps): no gender tag
          url = buildUrl(catParent, 'men', null);
        } else {
          // Default: navigate to parent with gender tag
          url = buildUrl(catParent, lg, null);
        }
      } else {
        url = buildUrl(catParent, location.activeGender, null);
      }

      return {
        handle: h,
        title: cat.title,
        isActive: isActive,
        isCurrent: isCurrentCategory,
        url: url,
        style: 'compact'
      };
    });
    paintCarousel(carousel, items);
    row.style.display = '';
  }

  function renderLeagues(wrapper, location) {
    var row = wrapper.querySelector('[data-level="leagues"]');
    var carousel = wrapper.querySelector('[data-carousel="leagues"]');
    if (!row || !carousel) return;
    var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

    // CASUAL MODE: no traditional leagues — render BRANDS here instead.
    if (cat && cat.casualMode && cat.brands && cat.brands.length) {
      var casualLabel = row.querySelector('.sf-row-label');
      if (casualLabel) casualLabel.textContent = cat.rowLabel || 'Brand';

      // Determine current collection (gender-specific parent)
      var casualColl;
      if (cat.genderHandles && cat.genderHandles[location.activeGender]) {
        casualColl = cat.genderHandles[location.activeGender];
      } else {
        casualColl = cat.handle || location.categoryHandle;
      }

      // Detect active brand tag
      var casActiveBrand = null;
      try {
        var casParams = new URLSearchParams(window.location.search);
        var casUrlTags = casParams.getAll('filter.p.tag');
        for (var cbi = 0; cbi < cat.brands.length; cbi++) {
          if (casUrlTags.indexOf(cat.brands[cbi].tag) !== -1) { casActiveBrand = cat.brands[cbi].tag; break; }
        }
      } catch (e) {}

      // Build pills: "All" + each brand (preserving season + type-if-still-valid)
      var casBrandItems = [{
        handle: '__all_brands__',
        title: 'All',
        isActive: !casActiveBrand,
        url: buildUrl(casualColl, location.activeGender, location.activeType, null, location.activeSeason),
        style: 'compact'
      }];
      cat.brands.forEach(function(b) {
        casBrandItems.push({
          handle: b.tag,
          title: b.title,
          logo: b.logo,
          isActive: casActiveBrand === b.tag,
          url: buildUrl(casualColl, location.activeGender, location.activeType, b.tag, location.activeSeason),
          style: b.logo ? 'with-icon' : 'compact'
        });
      });
      paintCarousel(carousel, casBrandItems);
      row.style.display = '';
      return;
    }

    if (!cat || !cat.leagues) { row.style.display = 'none'; return; }

    // Set row label dynamically (F1 uses "BRAND" instead of "LEAGUE")
    var label = row.querySelector('.sf-row-label');
    if (label) label.textContent = cat.rowLabel || 'League';

    var leagueHandles = Object.keys(cat.leagues);

    // Special: F1 has one synthetic league ('f1') — hide the league row and
    // show only the brands as the primary carousel (in the teams row).
    // This avoids showing a single lonely "F1 Brands" pill.
    if (leagueHandles.length === 1 && cat.f1 !== false) {
      var onlyLeague = cat.leagues[leagueHandles[0]];
      if (onlyLeague && onlyLeague.teams && Object.keys(onlyLeague.teams).length > 1) {
        row.style.display = 'none';
        return;
      }
    }

    var items = leagueHandles.map(function(h) {
      var lg = cat.leagues[h];
      var collectionHandle;

      // GYM: leagues have per-gender handles — pick the one matching active gender
      if (lg.genderHandles) {
        collectionHandle = lg.genderHandles[location.activeGender] || lg.genderHandles.men || h;
      } else if (Array.isArray(lg.handle)) {
        collectionHandle = lg.handle[0];
      } else {
        collectionHandle = lg.handle || h;
      }

      // For gym, detect active brand tag to preserve when switching type
      var preservedBrand = null;
      var preservedSeason = null;
      if (cat.brands || cat.seasons) {
        try {
          var params = new URLSearchParams(window.location.search);
          var urlTags = params.getAll('filter.p.tag');
          if (cat.brands) {
            for (var bi = 0; bi < cat.brands.length; bi++) {
              if (urlTags.indexOf(cat.brands[bi].tag) !== -1) { preservedBrand = cat.brands[bi].tag; break; }
            }
          }
          if (cat.seasons) {
            for (var si = 0; si < cat.seasons.length; si++) {
              if (urlTags.indexOf(cat.seasons[si].tag) !== -1) { preservedSeason = cat.seasons[si].tag; break; }
            }
          }
        } catch (e) {}
      }

      return {
        handle: h,
        title: lg.title,
        logo: lg.logo,
        isActive: h === location.leagueHandle && !location.teamHandle,
        url: buildUrl(collectionHandle, location.activeGender, null, preservedBrand, preservedSeason),
        style: lg.logo ? 'with-icon' : 'compact'
      };
    });
    paintCarousel(carousel, items);
    row.style.display = '';
  }

  function renderTeams(wrapper, location) {
    var row = wrapper.querySelector('[data-level="teams"]');
    var carousel = wrapper.querySelector('[data-carousel="teams"]');
    if (!row || !carousel) return;

    var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

    // GYM MODE: if the category has `brands` and a league is picked,
    // render brand tag filters (Nike, Adidas) instead of teams
    if (cat && cat.brands && cat.brands.length && location.leagueHandle) {
      var league = cat.leagues[location.leagueHandle];
      // Determine the current gym collection (gender-specific)
      var currentColl;
      if (league.genderHandles) {
        currentColl = league.genderHandles[location.activeGender] || league.genderHandles.men;
      } else {
        currentColl = location.leagueHandle;
      }

      // Set row label (BRAND)
      var lbl = row.querySelector('.sf-row-label');
      if (lbl) lbl.textContent = cat.teamRowLabel || 'Brand';

      // Detect which brand tag is currently active
      var activeBrand = null;
      try {
        var params = new URLSearchParams(window.location.search);
        var urlTags = params.getAll('filter.p.tag');
        for (var i = 0; i < cat.brands.length; i++) {
          for (var j = 0; j < urlTags.length; j++) {
            if (urlTags[j] === cat.brands[i].tag) { activeBrand = cat.brands[i].tag; break; }
          }
          if (activeBrand) break;
        }
      } catch (e) {}

      // Make row label clickable if a brand is active (jumps to /collections/nike, etc.)
      // Find the brand's display name (title) for the button label
      var brandDisplayName = null;
      if (activeBrand) {
        for (var bri = 0; bri < cat.brands.length; bri++) {
          if (cat.brands[bri].tag === activeBrand) {
            brandDisplayName = cat.brands[bri].title || activeBrand;
            break;
          }
        }
      }
      applyLabelClick(
        row,
        getLabelClickUrl(cat, 'teams', location, activeBrand, brandDisplayName),
        cat.teamRowLabel || 'Brand'
      );
      // Build pills: "All" + each brand — preserving active season if set
      var brandItems = [{
        handle: '__all_brands__',
        title: 'All',
        isActive: !activeBrand,
        url: buildUrl(currentColl, location.activeGender, null, null, location.activeSeason),
        style: 'type'
      }];
      cat.brands.forEach(function(b) {
        brandItems.push({
          handle: b.tag,
          title: b.title,
          logo: b.logo,
          isActive: activeBrand === b.tag,
          url: buildUrl(currentColl, location.activeGender, null, b.tag, location.activeSeason),
          style: b.logo ? 'with-icon' : 'type'
        });
      });
      paintCarousel(carousel, brandItems);
      row.style.display = '';
      return;
    }

    // If the category suppresses the team level entirely, hide the row.
    if (isTeamLevelSuppressed(cat)) { row.style.display = 'none'; return; }

    // For F1 (single synthetic league), always show the brands row even
    // when no league is explicitly picked — it IS the primary filter dimension.
    var leagueForTeams = null;
    if (location.leagueHandle) {
      leagueForTeams = cat && cat.leagues && cat.leagues[location.leagueHandle];
    } else if (cat && cat.leagues) {
      var leagueKeys = Object.keys(cat.leagues);
      if (leagueKeys.length === 1) {
        leagueForTeams = cat.leagues[leagueKeys[0]];
        location.leagueHandle = leagueKeys[0]; // implicitly select the sole league
      }
    }

    if (!leagueForTeams || !leagueForTeams.teams || !Object.keys(leagueForTeams.teams).length) {
      row.style.display = 'none';
      return;
    }

    // Set row label dynamically (F1 uses "BRAND" instead of "TEAM")
    var label = row.querySelector('.sf-row-label');
    if (label) {
      if (cat.teamRowLabel) label.textContent = cat.teamRowLabel;
      else if (cat.rowLabel === 'BRAND') label.textContent = 'Brand';
      else label.textContent = 'Team';
    }

    var items = Object.keys(leagueForTeams.teams).map(function(h) {
      var t = leagueForTeams.teams[h];
      var isThisTeam = h === location.teamHandle;
      var isActive = isThisTeam && !location.activeType;
      var url;
      // Tag-based team (International Kits countries)
      if (t.tag && leagueForTeams.handle) {
        url = buildUrl(leagueHandleStr(leagueForTeams), location.activeGender, null, t.tag);
      } else {
        // Handle-based team (Arsenal, f1-ferrari, etc.)
        url = buildUrl(h, location.activeGender, null);
      }
      return {
        handle: h,
        title: t.title,
        logo: t.logo,
        isActive: isActive,
        isCurrent: isThisTeam,
        url: url,
        style: 'with-icon'
      };
    });
    paintCarousel(carousel, items);
    row.style.display = '';
  }

  function renderTypes(wrapper, location) {
    var row = wrapper.querySelector('[data-level="types"]');
    var carousel = wrapper.querySelector('[data-carousel="types"]');
    if (!row || !carousel) return;

    var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

    // CASUAL MODE: Season-conditional types (guided flow).
    // Only show Type row when a season is picked.
    if (cat && cat.typesBySeason) {
      if (!location.activeSeason) { row.style.display = 'none'; return; }
      var casualTypes = getProductTypes(cat, location.activeSeason);
      if (!casualTypes.length) { row.style.display = 'none'; return; }

      // Set row label
      var casualLbl = row.querySelector('.sf-row-label');
      if (casualLbl) casualLbl.textContent = 'Type';

      // Determine current collection (gender-specific parent for casual)
      var casualColl;
      if (cat.genderHandles && cat.genderHandles[location.activeGender]) {
        casualColl = cat.genderHandles[location.activeGender];
      } else {
        casualColl = cat.handle || location.categoryHandle;
      }

      // Detect active brand tag (to preserve when switching type)
      var casualBrand = null;
      if (cat.brands) {
        try {
          var params = new URLSearchParams(window.location.search);
          var urlTags = params.getAll('filter.p.tag');
          for (var bi = 0; bi < cat.brands.length; bi++) {
            if (urlTags.indexOf(cat.brands[bi].tag) !== -1) { casualBrand = cat.brands[bi].tag; break; }
          }
        } catch (e) {}
      }

      // Build pills: "All" + each season-specific type (preserving brand + season)
      var casualItems = [{
        handle: '__all_types__',
        title: 'All',
        isActive: !location.activeType,
        url: buildUrl(casualColl, location.activeGender, null, casualBrand, location.activeSeason),
        style: 'type'
      }];
      casualTypes.forEach(function(t) {
        casualItems.push({
          handle: t.tag,
          title: t.title,
          tag: t.tag,
          isActive: location.activeType === t.tag,
          url: buildUrl(casualColl, location.activeGender, t.tag, casualBrand, location.activeSeason),
          style: 'type'
        });
      });
      paintCarousel(carousel, casualItems);
      // Clickable label: for casual with parent-plus-tag pattern, jumps to catch-all filtered by type
      var casualTypeName = null;
      if (location.activeType) {
        for (var cti = 0; cti < casualTypes.length; cti++) {
          if (casualTypes[cti].tag === location.activeType) {
            casualTypeName = casualTypes[cti].title || location.activeType;
            break;
          }
        }
      }
      applyLabelClick(
        row,
        getLabelClickUrl(cat, 'types', location, location.activeType, casualTypeName),
        'Type'
      );
      row.style.display = '';
      return;
    }

    // Standard mode (Football/F1): types show under a team
    var types = getProductTypes(cat, location.activeSeason);
    if (!types.length) { row.style.display = 'none'; return; }

    // Only show types when a team (leaf) is selected
    if (!location.teamHandle) { row.style.display = 'none'; return; }

    var league = cat && cat.leagues && cat.leagues[location.leagueHandle];
    var team = league && league.teams && league.teams[location.teamHandle];
    var isTagBasedTeam = team && team.tag && league && league.handle;
    var teamCollectionHandle = isTagBasedTeam ? leagueHandleStr(league) : location.teamHandle;
    var teamTag = isTagBasedTeam ? team.tag : null;

    var items = [{
      handle: location.teamHandle,
      title: 'All',
      isActive: !location.activeType,
      url: buildUrl(teamCollectionHandle, location.activeGender, null, teamTag),
      style: 'type'
    }];
    types.forEach(function(t) {
      items.push({
        handle: location.teamHandle,
        title: t.title,
        tag: t.tag,
        isActive: location.activeType === t.tag,
        url: buildUrl(teamCollectionHandle, location.activeGender, t.tag, teamTag),
        style: 'type'
      });
    });
    paintCarousel(carousel, items);
    // Clickable KIT label: on F1, jumps to /collections/f1?filter.p.tag=<type>
    // Find the type's display name for the button
    var typeDisplayName = null;
    if (location.activeType) {
      for (var tdi = 0; tdi < types.length; tdi++) {
        if (types[tdi].tag === location.activeType) {
          typeDisplayName = types[tdi].title || location.activeType;
          break;
        }
      }
    }
    applyLabelClick(
      row,
      getLabelClickUrl(cat, 'types', location, location.activeType, typeDisplayName),
      'Kit'
    );
    row.style.display = '';
  }

  // Renders the SEASON row (Gym only). Season is a TAG filter that can be
  // combined with any other active filter (Type, Brand, Gender).
  function renderSeasons(wrapper, location) {
    var row = wrapper.querySelector('[data-level="seasons"]');
    var carousel = wrapper.querySelector('[data-carousel="seasons"]');
    if (!row || !carousel) return;

    var cat = window.ShirtsHierarchy.categories[location.categoryHandle];
    if (!cat || !cat.seasons || !cat.seasons.length) { row.style.display = 'none'; return; }

    // Set row label
    var lbl = row.querySelector('.sf-row-label');
    if (lbl) lbl.textContent = 'Season';

    // Determine current collection (gender-specific for gym at league level, casual at category level)
    var currentColl;
    if (location.leagueHandle && cat.leagues && cat.leagues[location.leagueHandle] && cat.leagues[location.leagueHandle].genderHandles) {
      // Gym: league-level gender handles
      var gh = cat.leagues[location.leagueHandle].genderHandles;
      currentColl = gh[location.activeGender] || gh.men;
    } else if (cat.genderHandles) {
      // Casual: category-level gender handles
      currentColl = cat.genderHandles[location.activeGender] || cat.handle || location.categoryHandle;
    } else {
      currentColl = cat.handle || location.categoryHandle;
    }

    // Determine active brand tag (to preserve when switching season)
    var activeBrandTag = null;
    if (cat.brands) {
      try {
        var params = new URLSearchParams(window.location.search);
        var urlTags = params.getAll('filter.p.tag');
        for (var i = 0; i < cat.brands.length; i++) {
          for (var j = 0; j < urlTags.length; j++) {
            if (urlTags[j] === cat.brands[i].tag) { activeBrandTag = cat.brands[i].tag; break; }
          }
          if (activeBrandTag) break;
        }
      } catch (e) {}
    }

    // Helper: given a target season, check if the currently active type is still valid.
    // For Casual (typesBySeason), a type only belongs to one season, so switching season
    // must drop the type unless it exists in the target season's type list.
    function typeStillValid(targetSeasonTag) {
      if (!location.activeType) return null;
      if (!cat.typesBySeason) return location.activeType; // non-casual: type always compatible
      if (!targetSeasonTag) return null; // moving to "All" seasons — drop type (guided flow needs season)
      var targetTypes = cat.typesBySeason[targetSeasonTag] || [];
      for (var ti = 0; ti < targetTypes.length; ti++) {
        if (targetTypes[ti].tag === location.activeType) return location.activeType;
      }
      return null; // type doesn't exist in target season → drop it
    }

    // Build pills: "All" + each season
    // Note: brand tag goes in teamTag slot, season goes in extraTag slot
    // For casual, we ALSO preserve type IF compatible with the target season.
    var seasonItems = [{
      handle: '__all_seasons__',
      title: 'All',
      isActive: !location.activeSeason,
      url: buildUrl(currentColl, location.activeGender, typeStillValid(null), activeBrandTag, null),
      style: 'type'
    }];
    cat.seasons.forEach(function(s) {
      var title = s.emoji ? (s.emoji + ' ' + s.title) : s.title;
      seasonItems.push({
        handle: s.tag,
        title: title,
        isActive: location.activeSeason === s.tag,
        url: buildUrl(currentColl, location.activeGender, typeStillValid(s.tag), activeBrandTag, s.tag),
        style: 'type'
      });
    });
    paintCarousel(carousel, seasonItems);
    row.style.display = '';
  }

  // Renders the "See all Polo · See all T-Shirt · ..." footer chips.
  // These are cross-brand kit shortcuts that always visible on categories
  // that have flat productTypes or typesBySeason (Football, F1, Casual).
  // Hidden on Gym (types already visible as pills) and Caps (no types) and
  // gender landings (no active category).
  function renderFooterChips(wrapper, location) {
    var footer = wrapper.querySelector('[data-level="footer-chips"]');
    var content = wrapper.querySelector('[data-carousel="footer-chips"]');
    if (!footer || !content) return;

    // Hide on gender landings — no meaningful "See all X" until they pick a category
    if (location.isGenderLanding) { footer.style.display = 'none'; return; }

    var cat = window.ShirtsHierarchy.categories[location.categoryHandle];
    if (!cat) { footer.style.display = 'none'; return; }

    // Gather all kit types for this category.
    // - typesBySeason (Casual): combine Summer + Winter, dedupe by tag
    // - productTypes explicitly [] (Caps): stays empty → footer hides
    // - productTypes undefined (Football): use global default via getProductTypes
    var kitTypes = [];
    if (cat.typesBySeason) {
      var seen = {};
      var seasonKeys = Object.keys(cat.typesBySeason);
      for (var si = 0; si < seasonKeys.length; si++) {
        var arr = cat.typesBySeason[seasonKeys[si]] || [];
        for (var ti = 0; ti < arr.length; ti++) {
          if (!seen[arr[ti].tag]) {
            seen[arr[ti].tag] = true;
            kitTypes.push(arr[ti]);
          }
        }
      }
    } else {
      // getProductTypes: respects empty arrays (Caps hides), falls back to global
      kitTypes = getProductTypes(cat);
    }

    // Hide the footer when there are no kits (Caps has explicit [])
    if (!kitTypes.length) { footer.style.display = 'none'; return; }

    // Hide on Gym Shirts — its "leagues" (Jackets, Hoodies, Tops...) are the
    // type-equivalent pills, so footer chips would duplicate them.
    if (location.categoryHandle === 'gym-shirts') {
      footer.style.display = 'none';
      return;
    }

    var parentHandle = cat.handle || location.categoryHandle;

    // Build chips.
    // By default each links to /collections/{parent}?filter.p.tag=<tag>.
    // When a type defines `collectionHandle` (e.g., Season 2026/27 → "new-season-26-27"),
    // the chip links DIRECTLY to that dedicated collection instead of the parent+tag URL.
    // This gives featured types their own clean landing page with proper SEO.
    content.innerHTML = '';
    kitTypes.forEach(function(t) {
      var a = document.createElement('a');
      a.className = 'sf-footer-chip';
      // Dedicated-collection override takes priority; otherwise fall back to parent+tag
      if (t.collectionHandle) {
        a.href = buildUrl(t.collectionHandle, location.activeGender, null);
      } else {
        // Preserve active gender via existing buildUrl (adds ?filter.p.tag=Women etc. when needed)
        a.href = buildUrl(parentHandle, location.activeGender, t.tag);
      }
      // Highlight if this kit is currently the active filter
      if (location.activeType === t.tag) a.classList.add('is-active');
      // Title text: prefer the display title
      a.textContent = t.title || t.tag;
      content.appendChild(a);
    });
    footer.style.display = '';
  }

  function renderBreadcrumb(wrapper, location) {
    var el = wrapper.querySelector('.sf-breadcrumb');
    if (!el) return;

    // On gender landings, breadcrumb is just the gender label (e.g., "Women")
    if (location.isGenderLanding) {
      var labels = { women: 'Women', men: 'Men', kids: 'Kids' };
      var text = labels[location.landingGender] || location.landingGender;
      el.innerHTML = '<a class="sf-crumb is-current" href="/collections/' + location.landingGender + '">' + escapeHtml(text) + '</a>';
      return;
    }

    var parts = [];
    var cat = window.ShirtsHierarchy.categories[location.categoryHandle];
    var league = cat && cat.leagues && cat.leagues[location.leagueHandle];
    var team = league && league.teams && league.teams[location.teamHandle];
    var isTagBasedTeam = team && team.tag && league && league.handle;

    // 1) Gender — use per-category label if defined, else fall back to defaults
    var currentColl;
    var teamTag = null;
    if (location.teamHandle) {
      if (isTagBasedTeam) { currentColl = leagueHandleStr(league); teamTag = team.tag; }
      else { currentColl = location.teamHandle; }
    } else if (location.leagueHandle) {
      currentColl = leagueHandleStr(league) || location.leagueHandle;
    } else {
      currentColl = cat.handle || location.categoryHandle;
    }

    // Only include the Gender crumb if the category has gender tabs
    if (!(cat && cat.hideGenderTabs)) {
      // Resolve display label for this gender
      var genderLabel;
      if (cat && cat.genderTabs && cat.genderTabs[location.activeGender] && cat.genderTabs[location.activeGender].label) {
        genderLabel = cat.genderTabs[location.activeGender].label;
      } else if (location.activeGender === 'women') {
        genderLabel = 'Women';
      } else if (location.activeGender === 'kids') {
        genderLabel = 'Kids';
      } else {
        genderLabel = 'Men';
      }
      parts.push({
        text: genderLabel,
        url: buildUrl(currentColl, location.activeGender, location.activeType, teamTag)
      });
    }

    // 2) Category
    if (cat) parts.push({
      text: cat.title,
      url: buildUrl(cat.handle || location.categoryHandle, location.activeGender, null)
    });

    // 3) League (skip for F1's synthetic single league — redundant with category)
    var categoryLeagueKeys = cat && cat.leagues ? Object.keys(cat.leagues) : [];
    var isSyntheticSingleLeague = categoryLeagueKeys.length === 1;

    if (location.leagueHandle && league && !isSyntheticSingleLeague) {
      var lgHandle = leagueHandleStr(league) || location.leagueHandle;
      parts.push({
        text: league.title,
        url: buildUrl(lgHandle, location.activeGender, null)
      });
    }

    // 4) Team
    if (location.teamHandle && team) {
      var teamUrl;
      if (isTagBasedTeam) {
        teamUrl = buildUrl(leagueHandleStr(league), location.activeGender, null, team.tag);
      } else {
        teamUrl = buildUrl(location.teamHandle, location.activeGender, null);
      }
      parts.push({ text: team.title, url: teamUrl });
    }

    // 5) Product type
    if (location.activeType) {
      var types = getProductTypes(cat, location.activeSeason);
      var match = types.filter(function(p) { return p.tag === location.activeType; })[0];
      if (match) {
        var typeUrl;
        if (isTagBasedTeam) {
          typeUrl = buildUrl(leagueHandleStr(league), location.activeGender, match.tag, team.tag);
        } else if (location.teamHandle) {
          typeUrl = buildUrl(location.teamHandle, location.activeGender, match.tag);
        } else {
          typeUrl = buildUrl(cat.handle || location.categoryHandle, location.activeGender, match.tag);
        }
        parts.push({ text: match.title, url: typeUrl });
      }
    }

    el.innerHTML = parts.map(function(p, i) {
      var isLast = i === parts.length - 1;
      var sep = i > 0 ? '<span class="sf-crumb-sep"> › </span>' : '';
      return sep + '<a class="sf-crumb' + (isLast ? ' is-current' : '') + '" href="' + p.url + '">' + escapeHtml(p.text) + '</a>';
    }).join('');
  }

  // ============ PAINT & UTILITIES ============

  function paintCarousel(carousel, items) {
    carousel.innerHTML = '';
    items.forEach(function(item) {
      var link = document.createElement('a');
      var cls = 'sf-item';
      if (item.isActive) cls += ' is-active';
      else if (item.isCurrent) cls += ' is-current';
      if (item.style === 'with-icon') {
        cls += ' sf-with-icon';
      } else if (item.style === 'type') {
        cls += ' sf-type';
      } else {
        cls += ' sf-compact';
      }
      link.className = cls;
      link.href = item.url;
      link.setAttribute('data-handle', item.handle);
      if (item.style === 'with-icon') {
        var logoHtml = item.logo
          ? '<img class="sf-item-logo-img" src="' + item.logo + '" alt="' + escapeHtml(item.title) + '" loading="lazy" onerror="this.style.display=\'none\'">'
          : '<span class="sf-item-logo-fallback">' + escapeHtml(item.title.charAt(0)) + '</span>';
        link.innerHTML =
          '<div class="sf-item-logo">' + logoHtml + '</div>' +
          '<div class="sf-item-title">' + escapeHtml(item.title) + '</div>';
      } else {
        link.innerHTML = escapeHtml(item.title);
      }
      attachClickFeedback(link, item.isActive);
      carousel.appendChild(link);
    });
  }

  function setupArrows(carousel) {
    var container = carousel.closest('.sf-carousel-container');
    if (!container) return;
    var prev = container.querySelector('.sf-arrow-prev');
    var next = container.querySelector('.sf-arrow-next');
    if (!prev || !next) return;
    function scroll(delta) { carousel.scrollBy({ left: delta, behavior: 'smooth' }); }
    prev.onclick = function() { scroll(-260); };
    next.onclick = function() { scroll(260); };
    function checkOverflow() {
      var hasOverflow = carousel.scrollWidth > carousel.clientWidth + 4;
      container.classList.toggle('has-overflow', hasOverflow);
    }
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
  }

  function attachClickFeedback(link, alreadyActive) {
    if (alreadyActive) {
      link.addEventListener('click', function(e) { e.preventDefault(); });
      return;
    }
    link.addEventListener('click', function() { link.classList.add('is-loading'); });
  }

  function scrollIntoView(el) {
    try { el.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); }
    catch (e) {}
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function(c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }
})();
// oct-15-start 
// // shirts-carousel-filter.js
// // Football Shirts filter — Category → League → Team → Product Type
// // Auto-detects if the current collection is in the hierarchy; hides otherwise.

// (function() {
//   'use strict';

//   if (!window.ShirtsHierarchy) return;

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   var currentLocation = null;

//   function init() {
//     var wrapper = document.querySelector('.sf-nav-wrapper');
//     if (!wrapper) return;

//     var currentHandle = wrapper.dataset.currentHandle;
//     if (!currentHandle) return;

//     var location = findInHierarchy(currentHandle);
//     if (!location) {
//       // Not a shirt collection — hide the shirt filter card but keep the
//       // catalog switcher visible so customers can navigate away.
//       // If the SHOE filter is active, hide our catalog switcher to avoid duplication.
//       var shoeWrapper = document.querySelector('.hcf-nav-wrapper');
//       var shoeIsActive = shoeWrapper && shoeWrapper.querySelector('.hcf-item') !== null;

//       var inner = wrapper.querySelector('.sf-nav-inner');
//       if (inner) {
//         Array.prototype.forEach.call(inner.children, function(child) {
//           if (!child.classList || !child.classList.contains('cs-catalog-tabs')) {
//             child.style.display = 'none';
//           }
//         });
//         if (shoeIsActive) {
//           var shirtTabs = inner.querySelector('.cs-catalog-tabs');
//           if (shirtTabs) shirtTabs.style.display = 'none';
//           wrapper.style.display = 'none';
//         }
//       }
//       var stickyBar = document.getElementById('sf-sticky-bar');
//       if (stickyBar) stickyBar.remove();
//       var fab = document.getElementById('sf-fab');
//       if (fab) fab.remove();
//       var expandedOverlay = document.getElementById('sf-expanded-overlay');
//       if (expandedOverlay) expandedOverlay.remove();
//       return;
//     }

//     // For gender landings, activeGender = the landing gender directly
//     if (location.isGenderLanding) {
//       location.activeGender = location.landingGender;
//     } else {
//       location.activeGender = detectGenderFromUrl();
//     }
//     location.activeType   = detectTypeTagFromUrl(location);
//     location.activeSeason = detectSeasonFromUrl(location);

//     currentLocation = location;

//     renderGenderTabs(wrapper, location);
//     renderCategories(wrapper, location);
//     renderLeagues(wrapper, location);
//     renderTeams(wrapper, location);
//     renderTypes(wrapper, location);
//     renderSeasons(wrapper, location);
//     renderFooterChips(wrapper, location);
//     renderBreadcrumb(wrapper, location);

//     // Add helper class if the deep rows (teams + types) are both hidden
//     var teamsRow = wrapper.querySelector('[data-level="teams"]');
//     var typesRow = wrapper.querySelector('[data-level="types"]');
//     var teamsHidden = !teamsRow || teamsRow.style.display === 'none';
//     var typesHidden = !typesRow || typesRow.style.display === 'none';
//     wrapper.classList.toggle('sf-leagues-only', teamsHidden && typesHidden);

//     wrapper.querySelectorAll('.sf-carousel').forEach(setupArrows);
//     setTimeout(function() {
//       wrapper.querySelectorAll('.sf-item.is-active').forEach(scrollIntoView);
//     }, 100);

//     setupScrollHints(wrapper);
//     setupStickyBar(wrapper, location);
//     setupExpandedOverlay(wrapper);
//     setupFAB(wrapper);
//   }

//   // ============ HELPERS ============

//   // Unwrap league.handle if it's a string OR array of aliases (returns first alias or null)
//   function leagueHandleStr(league) {
//     if (!league) return null;
//     if (Array.isArray(league.handle)) return league.handle[0];
//     return league.handle || null;
//   }

//   // Get the productTypes list for a given category.
//   //   - Football/F1: fixed list from cat.productTypes or global fallback
//   //   - Casual: season-conditional — pass activeSeason as 2nd arg
//   //     Returns [] if season required but not set (guided flow — Type row hidden)
//   function getProductTypes(cat, activeSeason) {
//     if (cat && cat.typesBySeason) {
//       if (!activeSeason) return [];
//       return cat.typesBySeason[activeSeason] || [];
//     }
//     // Explicit empty array means "this category has no product types" — respect it.
//     // Only fall through to global if productTypes is completely undefined.
//     if (cat && Array.isArray(cat.productTypes)) return cat.productTypes;
//     return window.ShirtsHierarchy.productTypes || [];
//   }

//   // Is this category's team level suppressed (e.g., F1 has no sub-teams)?
//   function isTeamLevelSuppressed(cat) {
//     return cat && cat.teamRowLabel === null;
//   }

//   // Returns { url, buttonText } for a clickable row label, or null if not applicable.
//   //
//   //   cat         — active category object
//   //   rowLevel    — 'leagues' | 'teams' | 'types'
//   //   location    — current location object
//   //   activeTag   — the currently active tag in this row (or null)
//   //   displayName — the display title matching activeTag (e.g., "Cap" for tag "F1 caps");
//   //                 falls back to activeTag if not provided
//   function getLabelClickUrl(cat, rowLevel, location, activeTag, displayName) {
//     if (!cat || !cat.labelClicks) return null;
//     var cfg = cat.labelClicks[rowLevel];
//     if (!cfg || !activeTag) return null;

//     var url = null;
//     if (cfg.pattern === 'brand-collection') {
//       // Lowercase-hyphenate the tag to produce a collection handle
//       // (e.g., "Nike" → "nike", "Tommy Hilfiger" → "tommy-hilfiger")
//       var handle = activeTag.toLowerCase().replace(/\s+/g, '-');
//       url = '/collections/' + handle;
//     } else if (cfg.pattern === 'handle-map' && cfg.handleMap && cfg.handleMap[activeTag]) {
//       url = '/collections/' + cfg.handleMap[activeTag];
//     } else if (cfg.pattern === 'parent-plus-tag') {
//       var parent = cat.handle || location.categoryHandle;
//       url = '/collections/' + parent + '?filter.p.tag=' + encodeURIComponent(activeTag);
//     }

//     if (!url) return null;

//     // Build button text from format template
//     var name = displayName || activeTag;
//     var format = cfg.buttonTextFormat || 'Shop {name}';
//     var buttonText = format.replace('{name}', name);

//     return { url: url, buttonText: buttonText };
//   }

//   // Apply the "shop X" button to a row label. If clickInfo is null, resets
//   // the label to plain text (defaultLabel).
//   //
//   //   clickInfo   — { url, buttonText } from getLabelClickUrl, or null
//   //   defaultLabel — the plain text to show when no filter is active
//   function applyLabelClick(row, clickInfo, defaultLabel) {
//     var label = row.querySelector('.sf-row-label');
//     if (!label) return;

//     if (clickInfo && clickInfo.url) {
//       // Render as burgundy pill button — impossible to miss
//       label.innerHTML = '';
//       var btn = document.createElement('a');
//       btn.className = 'sf-label-btn';
//       btn.href = clickInfo.url;
//       btn.textContent = clickInfo.buttonText;
//       btn.setAttribute('aria-label', clickInfo.buttonText);
//       label.appendChild(btn);
//       label.classList.add('sf-label-has-btn');
//     } else {
//       // Plain text label (no active filter)
//       label.textContent = defaultLabel;
//       label.classList.remove('sf-label-has-btn');
//     }
//   }

//   // ============ MOBILE SCROLL HINTS (COMBO: fade + peek + delayed arrow) ============
//   function setupScrollHints(wrapper) {
//     if (window.matchMedia && !window.matchMedia('(max-width: 768px)').matches) return;

//     setTimeout(function() {
//       var rows = wrapper.querySelectorAll('.sf-row-content');
//       var anyOverflowed = false;
//       var alreadyPeeked = false;
//       try { alreadyPeeked = sessionStorage.getItem('sf_peek_played') === '1'; } catch (e) {}

//       rows.forEach(function(rowContent) {
//         var carousel = rowContent.querySelector('.sf-carousel');
//         if (!carousel) return;

//         var overflows = carousel.scrollWidth > carousel.clientWidth + 4;
//         if (!overflows) return;

//         anyOverflowed = true;
//         rowContent.classList.add('sf-has-overflow');

//         if (!rowContent.querySelector('.sf-scroll-arrow')) {
//           var arrow = document.createElement('div');
//           arrow.className = 'sf-scroll-arrow';
//           arrow.innerHTML = '<svg width="14" height="14" viewBox="0 0 20 20" fill="none"><path d="M8 4L14 10L8 16" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
//           rowContent.appendChild(arrow);
//         }

//         if (!alreadyPeeked) {
//           carousel.classList.add('sf-peek');
//           setTimeout(function() { carousel.classList.remove('sf-peek'); }, 3000);
//         }

//         var arrowTimer = setTimeout(function() {
//           if (!rowContent.classList.contains('sf-scrolled')) {
//             rowContent.classList.add('sf-show-arrow');
//             setTimeout(function() {
//               rowContent.classList.remove('sf-show-arrow');
//             }, 6000);
//           }
//         }, 2000);

//         var onScroll = function() {
//           rowContent.classList.add('sf-scrolled');
//           rowContent.classList.remove('sf-show-arrow');
//           clearTimeout(arrowTimer);
//           if (carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4) {
//             rowContent.classList.remove('sf-has-overflow');
//           }
//           carousel.removeEventListener('scroll', onScroll);
//           carousel.addEventListener('scroll', function() {
//             var atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4;
//             rowContent.classList.toggle('sf-has-overflow', !atEnd);
//           }, { passive: true });
//         };
//         carousel.addEventListener('scroll', onScroll, { passive: true });
//       });

//       if (anyOverflowed && !alreadyPeeked) {
//         try { sessionStorage.setItem('sf_peek_played', '1'); } catch (e) {}
//       }
//     }, 250);
//   }

//   // ============ STICKY BAR / EXPANDED OVERLAY / FAB ============

//   function setupStickyBar(wrapper, location) {
//     var stickyBar = document.getElementById('sf-sticky-bar');
//     var stickyPath = document.getElementById('sf-sticky-path');
//     var stickyBack = document.getElementById('sf-sticky-back');
//     var stickyScrollTop = document.getElementById('sf-sticky-scroll-top');
//     if (!stickyBar || !wrapper) return;

//     var pathTextEl = stickyBar.querySelector('.sf-sticky-path-text');
//     if (pathTextEl) pathTextEl.textContent = buildStickyPathText(location);

//     var backTarget = getBackTarget(location);
//     if (backTarget) {
//       stickyBack.disabled = false;
//       stickyBack.onclick = function() { window.location.href = backTarget; };
//     } else {
//       stickyBack.disabled = true;
//     }

//     if (stickyScrollTop) {
//       stickyScrollTop.onclick = function() {
//         wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
//       };
//     }

//     if (stickyPath) stickyPath.onclick = openExpandedOverlay;

//     var ticking = false;
//     function updateVisibility() {
//       var wrapperBottom = wrapper.getBoundingClientRect().bottom;
//       if (wrapperBottom < 0) {
//         stickyBar.classList.add('is-visible');
//         stickyBar.setAttribute('aria-hidden', 'false');
//       } else {
//         stickyBar.classList.remove('is-visible');
//         stickyBar.setAttribute('aria-hidden', 'true');
//       }
//       ticking = false;
//     }
//     window.addEventListener('scroll', function() {
//       if (!ticking) {
//         window.requestAnimationFrame(updateVisibility);
//         ticking = true;
//       }
//     }, { passive: true });
//     updateVisibility();
//   }

//   function buildStickyPathText(loc) {
//     if (!loc) return 'All Jerseys';
//     var parts = [];
//     var cat = window.ShirtsHierarchy.categories[loc.categoryHandle];

//     // Gender label: only show if category has gender tabs; support Men/Women/Kids
//     if (!(cat && cat.hideGenderTabs)) {
//       var genderLabel;
//       if (cat && cat.genderTabs && cat.genderTabs[loc.activeGender] && cat.genderTabs[loc.activeGender].label) {
//         genderLabel = cat.genderTabs[loc.activeGender].label;
//       } else if (loc.activeGender === 'women') {
//         genderLabel = 'Women';
//       } else if (loc.activeGender === 'kids') {
//         genderLabel = 'Kids';
//       } else {
//         genderLabel = 'Men';
//       }
//       parts.push(genderLabel);
//     }

//     if (cat) parts.push(cat.title);
//     if (loc.leagueHandle) {
//       var lg = cat && cat.leagues && cat.leagues[loc.leagueHandle];
//       // For F1's synthetic 'f1' league, don't add "F1 Brands" — redundant with category
//       if (lg && loc.leagueHandle !== 'f1') parts.push(lg.title);
//     }
//     if (loc.teamHandle) {
//       var lg2 = cat && cat.leagues && cat.leagues[loc.leagueHandle];
//       var t = lg2 && lg2.teams && lg2.teams[loc.teamHandle];
//       if (t) parts.push(t.title);
//     }
//     if (loc.activeType) {
//       var types = getProductTypes(cat, loc.activeSeason);
//       var match = types.filter(function(p) { return p.tag === loc.activeType; })[0];
//       if (match) parts.push(match.title);
//     }
//     return parts.join(' › ');
//   }

//   function getBackTarget(loc) {
//     if (!loc) return null;
//     var cat = window.ShirtsHierarchy.categories[loc.categoryHandle];
//     var league = cat && cat.leagues && cat.leagues[loc.leagueHandle];
//     var team = league && league.teams && league.teams[loc.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;

//     // Type filter active → clear type
//     if (loc.activeType && loc.teamHandle) {
//       if (isTagBasedTeam) {
//         return buildUrl(leagueHandleStr(league), loc.activeGender, null, team.tag);
//       }
//       return buildUrl(loc.teamHandle, loc.activeGender, null);
//     }
//     // Team active → go up to league
//     if (loc.teamHandle && loc.leagueHandle) {
//       if (isTagBasedTeam) {
//         return buildUrl(leagueHandleStr(league), loc.activeGender, null);
//       }
//       return buildUrl(loc.leagueHandle, loc.activeGender, null);
//     }
//     // League active → go up to category
//     if (loc.leagueHandle && loc.categoryHandle) {
//       return buildUrl(loc.categoryHandle, loc.activeGender, null);
//     }
//     return null;
//   }

//   function setupExpandedOverlay(wrapper) {
//     var overlay = document.getElementById('sf-expanded-overlay');
//     if (!overlay) return;
//     var backdrop = overlay.querySelector('.sf-expanded-backdrop');
//     var closeBtn = document.getElementById('sf-expanded-close');
//     if (closeBtn) closeBtn.onclick = closeExpandedOverlay;
//     if (backdrop) backdrop.onclick = closeExpandedOverlay;
//     document.addEventListener('keydown', function(e) {
//       if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
//         closeExpandedOverlay();
//       }
//     });
//   }

//   function openExpandedOverlay() {
//     var overlay = document.getElementById('sf-expanded-overlay');
//     var content = document.getElementById('sf-expanded-content');
//     var wrapper = document.querySelector('.sf-nav-wrapper');
//     if (!overlay || !content || !wrapper) return;

//     content.innerHTML = '';
//     wrapper.querySelectorAll('.sf-row').forEach(function(row) {
//       if (row.style.display === 'none') return;
//       var clone = row.cloneNode(true);
//       content.appendChild(clone);
//     });

//     overlay.classList.add('is-open');
//     overlay.setAttribute('aria-hidden', 'false');
//     document.body.style.overflow = 'hidden';
//   }

//   function closeExpandedOverlay() {
//     var overlay = document.getElementById('sf-expanded-overlay');
//     if (!overlay) return;
//     overlay.classList.remove('is-open');
//     overlay.setAttribute('aria-hidden', 'true');
//     document.body.style.overflow = '';
//   }

//   function setupFAB(wrapper) {
//     var fab = document.getElementById('sf-fab');
//     if (!fab || !wrapper) return;
//     fab.onclick = function() {
//       wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     };
//     var ticking = false;
//     function update() {
//       var wrapperBottom = wrapper.getBoundingClientRect().bottom;
//       if (wrapperBottom < -300) fab.classList.add('is-visible');
//       else fab.classList.remove('is-visible');
//       ticking = false;
//     }
//     window.addEventListener('scroll', function() {
//       if (!ticking) {
//         window.requestAnimationFrame(update);
//         ticking = true;
//       }
//     }, { passive: true });
//     update();
//   }

//   // ============ LOCATION DETECTION ============

//   function findInHierarchy(handle) {
//     // GENDER LANDING pages: /collections/women, /collections/men, /collections/kids
//     // These are top-level gender landings (not tied to a specific category).
//     // We return a synthetic location with `isGenderLanding: true` so the renderers
//     // show the categories row with the landing gender pre-selected, but no
//     // specific category/league/team active.
//     if (handle === 'women' || handle === 'men' || handle === 'kids') {
//       return {
//         categoryHandle: null,
//         leagueHandle: null,
//         teamHandle: null,
//         level: 'landing',
//         isGenderLanding: true,
//         landingGender: handle
//       };
//     }

//     // Special case: kids-t-shirt is the Kids gender landing page.
//     if (handle === 'kids-t-shirt') {
//       return { categoryHandle: 'football-jerseys', leagueHandle: null, teamHandle: null, level: 'category' };
//     }

//     // CATEGORY-LEVEL GENDER HANDLES (Casual):
//     // Check for category-level gender handles (e.g., men-casual-out-fit → casual-shirts)
//     for (var cCatHandle in window.ShirtsHierarchy.categories) {
//       var cCat = window.ShirtsHierarchy.categories[cCatHandle];
//       if (!cCat.genderHandles) continue;
//       for (var cGender in cCat.genderHandles) {
//         if (cCat.genderHandles[cGender] === handle) {
//           return {
//             categoryHandle: cCatHandle,
//             leagueHandle: null,
//             teamHandle: null,
//             level: 'category'
//           };
//         }
//       }
//     }

//     // GYM detection: check for gender-specific handles (men-jackets, women-tops, etc.)
//     // Uses the gymCatCategory's leagues where each has a genderHandles map.
//     var gymCat = window.ShirtsHierarchy.categories['gym-shirts'];
//     if (gymCat && gymCat.leagues) {
//       for (var gymLgHandle in gymCat.leagues) {
//         var gymLg = gymCat.leagues[gymLgHandle];
//         if (!gymLg.genderHandles) continue;
//         for (var gKey in gymLg.genderHandles) {
//           if (gymLg.genderHandles[gKey] === handle) {
//             // Matched a men-* or women-* collection → gym category + this league is active
//             return {
//               categoryHandle: 'gym-shirts',
//               leagueHandle: gymLgHandle,
//               teamHandle: null,
//               level: 'league',
//               gymGender: gKey   // remember which gender-specific handle they hit
//             };
//           }
//         }
//       }
//     }

//     var categories = window.ShirtsHierarchy.categories;
//     for (var catHandle in categories) {
//       var cat = categories[catHandle];
//       var leagues = cat.leagues || {};

//       // (1) Handle-based team match: /collections/arsenal → team = arsenal
//       //     Also matches F1 brands like /collections/f1-ferrari
//       for (var lgHandle in leagues) {
//         var lg = leagues[lgHandle];
//         if (lg.teams && lg.teams[handle]) {
//           return { categoryHandle: catHandle, leagueHandle: lgHandle, teamHandle: handle, level: 'team' };
//         }
//       }

//       // (2) League match — supports:
//       //     (a) hierarchy key equals collection handle (Premier League, La Liga, etc.)
//       //     (b) league.handle is a STRING (tag-based leagues like International Kits)
//       //     (c) league.handle is an ARRAY of aliases (multiple collection URLs → same league)
//       for (var lgHandle2 in leagues) {
//         var lg2 = leagues[lgHandle2];
//         var leagueHandles = lg2.handle;
//         var isMatch = false;
//         if (Array.isArray(leagueHandles)) {
//           isMatch = leagueHandles.indexOf(handle) !== -1;
//         } else {
//           isMatch = ((leagueHandles || lgHandle2) === handle);
//         }
//         if (isMatch) {
//           // For tag-based leagues, check URL for team tag
//           var teamHandle = null;
//           if (lg2.handle) {
//             teamHandle = detectTagBasedTeamFromUrl(lg2);
//           }
//           return {
//             categoryHandle: catHandle,
//             leagueHandle: lgHandle2,
//             teamHandle: teamHandle,
//             level: teamHandle ? 'team' : 'league'
//           };
//         }
//       }

//       // (3) Category match: /collections/football-jerseys OR /collections/f1
//       var catParent = cat.handle || catHandle;
//       if (catParent === handle) {
//         return { categoryHandle: catHandle, leagueHandle: null, teamHandle: null, level: 'category' };
//       }
//     }
//     return null;
//   }

//   function detectTagBasedTeamFromUrl(league) {
//     if (!league || !league.teams) return null;
//     try {
//       var params = new URLSearchParams(window.location.search);
//       var urlTags = params.getAll('filter.p.tag');
//       for (var teamKey in league.teams) {
//         var team = league.teams[teamKey];
//         if (!team.tag) continue;
//         for (var i = 0; i < urlTags.length; i++) {
//           if (urlTags[i] === team.tag) return teamKey;
//         }
//       }
//     } catch (e) {}
//     return null;
//   }

//   function detectGenderFromUrl() {
//     try {
//       var wrapper = document.querySelector('.sf-nav-wrapper');
//       var currentHandle = wrapper && wrapper.dataset.currentHandle;
//       if (currentHandle === 'kids-t-shirt') return 'kids';

//       // Gym: detect gender from the current collection handle (men-* or women-*)
//       // OR from the ?filter.p.tag=Women / ?filter.p.tag=Men URL param
//       var gymCat = window.ShirtsHierarchy.categories['gym-shirts'];
//       if (gymCat && gymCat.leagues) {
//         for (var lg in gymCat.leagues) {
//           var gh = gymCat.leagues[lg].genderHandles || {};
//           for (var g in gh) {
//             if (gh[g] === currentHandle) return g;  // men-jackets → 'men'
//           }
//         }
//       }

//       // Casual (and any category with category-level genderHandles):
//       // detect gender from the parent handle mapping
//       for (var casCatH in window.ShirtsHierarchy.categories) {
//         var casCat = window.ShirtsHierarchy.categories[casCatH];
//         if (!casCat.genderHandles) continue;
//         for (var casG in casCat.genderHandles) {
//           if (casCat.genderHandles[casG] === currentHandle) return casG;
//         }
//       }

//       var params = new URLSearchParams(window.location.search);
//       var tags = params.getAll('filter.p.tag');
//       for (var i = 0; i < tags.length; i++) {
//         var t = tags[i].toLowerCase();
//         if (t === 'kids') return 'kids';
//         if (t === 'women') return 'women';
//         // 'men' tag also possible, but 'men' is the default so we only need to detect if explicitly set
//       }
//       // Check current handle for the gym parent — default to men
//       if (currentHandle === (gymCat && gymCat.handle)) return (gymCat.defaultGender || 'men');

//       return 'men';
//     } catch (e) { return 'men'; }
//   }

//   function detectTypeTagFromUrl(location) {
//     try {
//       var cat = location && window.ShirtsHierarchy.categories[location.categoryHandle];
//       // For Casual (typesBySeason), scan ALL seasons' types since we don't know the active season yet
//       var typesToCheck = [];
//       if (cat && cat.typesBySeason) {
//         for (var seasonKey in cat.typesBySeason) {
//           typesToCheck = typesToCheck.concat(cat.typesBySeason[seasonKey]);
//         }
//       } else {
//         typesToCheck = getProductTypes(cat);
//       }
//       var params = new URLSearchParams(window.location.search);
//       var tags = params.getAll('filter.p.tag');
//       for (var i = 0; i < tags.length; i++) {
//         for (var j = 0; j < typesToCheck.length; j++) {
//           if (tags[i] === typesToCheck[j].tag) return typesToCheck[j].tag;
//         }
//       }
//       return null;
//     } catch (e) { return null; }
//   }

//   // Detects active season TAG in the URL (Gym only — reads cat.seasons)
//   function detectSeasonFromUrl(location) {
//     try {
//       var cat = location && window.ShirtsHierarchy.categories[location.categoryHandle];
//       if (!cat || !cat.seasons || !cat.seasons.length) return null;
//       var params = new URLSearchParams(window.location.search);
//       var tags = params.getAll('filter.p.tag');
//       for (var i = 0; i < tags.length; i++) {
//         for (var j = 0; j < cat.seasons.length; j++) {
//           if (tags[i] === cat.seasons[j].tag) return cat.seasons[j].tag;
//         }
//       }
//       return null;
//     } catch (e) { return null; }
//   }

//   // ============ URL BUILDING ============
//   function buildUrl(collectionHandle, gender, typeTag, teamTag, extraTag) {
//     var url = '/collections/' + collectionHandle;
//     var params = [];
//     // Gender tag: only add when the collection ISN'T already gender-specific.
//     // Gender-specific gym collections (men-*, women-*) already restrict to that gender
//     // via their smart-collection rules, so adding the tag would be redundant.
//     var isGenderSpecific = /^(men|women)-/.test(collectionHandle) || collectionHandle === 'kids-t-shirt';
//     if (gender === 'kids' && !isGenderSpecific)  params.push('filter.p.tag=' + encodeURIComponent('Kids'));
//     if (gender === 'women' && !isGenderSpecific) params.push('filter.p.tag=' + encodeURIComponent('Women'));
//     if (teamTag)  params.push('filter.p.tag=' + encodeURIComponent(teamTag));
//     if (typeTag)  params.push('filter.p.tag=' + encodeURIComponent(typeTag));
//     if (extraTag) params.push('filter.p.tag=' + encodeURIComponent(extraTag));
//     if (params.length) url += '?' + params.join('&');
//     return url;
//   }

//   // ============ RENDERERS ============

//   function renderGenderTabs(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="gender"]');
//     if (!row) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // If the category opts out of gender tabs entirely (e.g., Caps — unisex),
//     // hide the whole row. This is different from just hiding individual tabs;
//     // it removes the gender row from the layout completely.
//     if (cat && cat.hideGenderTabs) {
//       row.style.display = 'none';
//       return;
//     }
//     // Make sure the row is visible for other categories (in case a previous
//     // Caps navigation left it hidden — reset to default display)
//     row.style.display = '';

//     // GENDER LANDING pages: no category yet, so pick a tab set based on the landing.
//     // - /collections/women or /men → Men | Women (with landing gender pre-active)
//     // - /collections/kids → Men | Kids (with kids pre-active)
//     if (location.isGenderLanding) {
//       var landingG = location.landingGender;
//       // Kids landing keeps Men/Kids; women/men landings use Men/Women
//       var landingGenders = (landingG === 'kids') ? ['men', 'kids'] : ['men', 'women'];
//       var landingLabels = {
//         men:   'Men',
//         women: 'Women',
//         kids:  'Kids'
//       };
//       ['men', 'kids', 'women'].forEach(function(g) {
//         var tab = row.querySelector('[data-gender="' + g + '"]');
//         if (!tab) return;
//         if (landingGenders.indexOf(g) === -1) {
//           tab.style.display = 'none';
//           return;
//         }
//         tab.style.display = '';
//         var labelSpan = tab.querySelector('span') || tab;
//         labelSpan.textContent = landingLabels[g];
//         // Each tab navigates to the corresponding /collections/<gender> landing
//         tab.href = '/collections/' + g;
//         tab.classList.toggle('is-active', landingG === g);
//       });
//       return;
//     }

//     // Use category-specific gender config if defined (e.g., Gym uses Men/Women)
//     // Otherwise fall back to Men/Kids defaults (Football, F1)
//     var genderConfig = cat && cat.genderTabs;
//     var genders = genderConfig ? Object.keys(genderConfig) : ['men', 'kids'];

//     // Determine base URL for gender switch
//     var league = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     var team = league && league.teams && league.teams[location.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;

//     // Hide any tabs not in this category's gender set; show/update the ones that are
//     ['men', 'kids', 'women'].forEach(function(g) {
//       var tab = row.querySelector('[data-gender="' + g + '"]');
//       if (!tab) return;
//       if (genders.indexOf(g) === -1) {
//         tab.style.display = 'none';
//         return;
//       }
//       tab.style.display = '';

//       // Update label if this category has a custom label
//       if (genderConfig && genderConfig[g] && genderConfig[g].label) {
//         var labelSpan = tab.querySelector('span') || tab;
//         labelSpan.textContent = genderConfig[g].label;
//       }

//       // Build the URL for this gender tab
//       var url;
//       if (cat && cat.handle && cat.leagues && cat.leagues[location.leagueHandle] && cat.leagues[location.leagueHandle].genderHandles) {
//         // Gym: switch to this gender's variant of the current category — preserve brand + season
//         var lgh = cat.leagues[location.leagueHandle].genderHandles;
//         var gymBrand = null, gymSeason = null;
//         try {
//           var pp = new URLSearchParams(window.location.search);
//           var tt = pp.getAll('filter.p.tag');
//           if (cat.brands) {
//             for (var bi = 0; bi < cat.brands.length; bi++) {
//               if (tt.indexOf(cat.brands[bi].tag) !== -1) { gymBrand = cat.brands[bi].tag; break; }
//             }
//           }
//           if (cat.seasons) {
//             for (var si = 0; si < cat.seasons.length; si++) {
//               if (tt.indexOf(cat.seasons[si].tag) !== -1) { gymSeason = cat.seasons[si].tag; break; }
//             }
//           }
//         } catch (e) {}
//         url = buildUrl(lgh[g] || cat.handle, g, null, gymBrand, gymSeason);
//       } else if (cat && cat.casualMode && cat.genderHandles) {
//         // CASUAL: category-level gender handles. Switch to gender's parent, preserve brand/season/type
//         var casBrand = null, casSeason = null;
//         try {
//           var ccp = new URLSearchParams(window.location.search);
//           var cct = ccp.getAll('filter.p.tag');
//           if (cat.brands) {
//             for (var cbi = 0; cbi < cat.brands.length; cbi++) {
//               if (cct.indexOf(cat.brands[cbi].tag) !== -1) { casBrand = cat.brands[cbi].tag; break; }
//             }
//           }
//           if (cat.seasons) {
//             for (var csi = 0; csi < cat.seasons.length; csi++) {
//               if (cct.indexOf(cat.seasons[csi].tag) !== -1) { casSeason = cat.seasons[csi].tag; break; }
//             }
//           }
//         } catch (e) {}
//         url = buildUrl(cat.genderHandles[g] || cat.handle, g, location.activeType, casBrand, casSeason);
//       } else if (cat && cat.genderTabs) {
//         // Gym without a category picked yet: go to parent
//         url = buildUrl(cat.handle || location.categoryHandle, g, null, null, location.activeSeason);
//       } else {
//         // Football / F1
//         var currentColl;
//         var teamTag = null;
//         if (location.teamHandle) {
//           if (isTagBasedTeam) { currentColl = leagueHandleStr(league); teamTag = team.tag; }
//           else { currentColl = location.teamHandle; }
//         } else if (location.leagueHandle) {
//           currentColl = leagueHandleStr(league) || location.leagueHandle;
//         } else {
//           currentColl = cat.handle || location.categoryHandle;
//         }
//         url = buildUrl(currentColl, g, location.activeType, teamTag);
//       }
//       tab.href = url;
//       tab.classList.toggle('is-active', location.activeGender === g);
//     });
//   }

//   function renderCategories(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="categories"]');
//     var carousel = wrapper.querySelector('[data-carousel="categories"]');
//     if (!row || !carousel) return;
//     var cats = window.ShirtsHierarchy.categories;
//     var handles = Object.keys(cats);

//     // Auto-hide if only 1 category exists (no need for a lone pill)
//     if (handles.length <= 1) {
//       row.style.display = 'none';
//       return;
//     }

//     // On a GENDER LANDING (/collections/women, /men, /kids), reorder categories
//     // so gender-supporting ones come first, and build URLs that preserve the gender.
//     if (location.isGenderLanding) {
//       var g = location.landingGender;
//       // Sort handles: supported first, unsupported after (stable within each group)
//       var supported = [];
//       var unsupported = [];
//       handles.forEach(function(h) {
//         var supports = cats[h].supportedGenders || ['men', 'kids'];
//         if (supports.indexOf(g) !== -1) supported.push(h);
//         else unsupported.push(h);
//       });
//       handles = supported.concat(unsupported);
//     }

//     var items = handles.map(function(h) {
//       var isCurrentCategory = h === location.categoryHandle;
//       var isActive = isCurrentCategory;   // false on landings (no cat picked)
//       var cat = cats[h];
//       var catParent = cat.handle || h;

//       // Build URL — preserve gender across category switches
//       var url;
//       if (location.isGenderLanding) {
//         var lg = location.landingGender;
//         // Category-level genderHandles (Casual): swap to gender-specific parent
//         if (cat.genderHandles && cat.genderHandles[lg]) {
//           url = buildUrl(cat.genderHandles[lg], lg, null);
//         } else if (cat.hideGenderTabs) {
//           // Unisex category (Caps): no gender tag
//           url = buildUrl(catParent, 'men', null);
//         } else {
//           // Default: navigate to parent with gender tag
//           url = buildUrl(catParent, lg, null);
//         }
//       } else {
//         url = buildUrl(catParent, location.activeGender, null);
//       }

//       return {
//         handle: h,
//         title: cat.title,
//         isActive: isActive,
//         isCurrent: isCurrentCategory,
//         url: url,
//         style: 'compact'
//       };
//     });
//     paintCarousel(carousel, items);
//     row.style.display = '';
//   }

//   function renderLeagues(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="leagues"]');
//     var carousel = wrapper.querySelector('[data-carousel="leagues"]');
//     if (!row || !carousel) return;
//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // CASUAL MODE: no traditional leagues — render BRANDS here instead.
//     if (cat && cat.casualMode && cat.brands && cat.brands.length) {
//       var casualLabel = row.querySelector('.sf-row-label');
//       if (casualLabel) casualLabel.textContent = cat.rowLabel || 'Brand';

//       // Determine current collection (gender-specific parent)
//       var casualColl;
//       if (cat.genderHandles && cat.genderHandles[location.activeGender]) {
//         casualColl = cat.genderHandles[location.activeGender];
//       } else {
//         casualColl = cat.handle || location.categoryHandle;
//       }

//       // Detect active brand tag
//       var casActiveBrand = null;
//       try {
//         var casParams = new URLSearchParams(window.location.search);
//         var casUrlTags = casParams.getAll('filter.p.tag');
//         for (var cbi = 0; cbi < cat.brands.length; cbi++) {
//           if (casUrlTags.indexOf(cat.brands[cbi].tag) !== -1) { casActiveBrand = cat.brands[cbi].tag; break; }
//         }
//       } catch (e) {}

//       // Build pills: "All" + each brand (preserving season + type-if-still-valid)
//       var casBrandItems = [{
//         handle: '__all_brands__',
//         title: 'All',
//         isActive: !casActiveBrand,
//         url: buildUrl(casualColl, location.activeGender, location.activeType, null, location.activeSeason),
//         style: 'compact'
//       }];
//       cat.brands.forEach(function(b) {
//         casBrandItems.push({
//           handle: b.tag,
//           title: b.title,
//           logo: b.logo,
//           isActive: casActiveBrand === b.tag,
//           url: buildUrl(casualColl, location.activeGender, location.activeType, b.tag, location.activeSeason),
//           style: b.logo ? 'with-icon' : 'compact'
//         });
//       });
//       paintCarousel(carousel, casBrandItems);
//       row.style.display = '';
//       return;
//     }

//     if (!cat || !cat.leagues) { row.style.display = 'none'; return; }

//     // Set row label dynamically (F1 uses "BRAND" instead of "LEAGUE")
//     var label = row.querySelector('.sf-row-label');
//     if (label) label.textContent = cat.rowLabel || 'League';

//     var leagueHandles = Object.keys(cat.leagues);

//     // Special: F1 has one synthetic league ('f1') — hide the league row and
//     // show only the brands as the primary carousel (in the teams row).
//     // This avoids showing a single lonely "F1 Brands" pill.
//     if (leagueHandles.length === 1 && cat.f1 !== false) {
//       var onlyLeague = cat.leagues[leagueHandles[0]];
//       if (onlyLeague && onlyLeague.teams && Object.keys(onlyLeague.teams).length > 1) {
//         row.style.display = 'none';
//         return;
//       }
//     }

//     var items = leagueHandles.map(function(h) {
//       var lg = cat.leagues[h];
//       var collectionHandle;

//       // GYM: leagues have per-gender handles — pick the one matching active gender
//       if (lg.genderHandles) {
//         collectionHandle = lg.genderHandles[location.activeGender] || lg.genderHandles.men || h;
//       } else if (Array.isArray(lg.handle)) {
//         collectionHandle = lg.handle[0];
//       } else {
//         collectionHandle = lg.handle || h;
//       }

//       // For gym, detect active brand tag to preserve when switching type
//       var preservedBrand = null;
//       var preservedSeason = null;
//       if (cat.brands || cat.seasons) {
//         try {
//           var params = new URLSearchParams(window.location.search);
//           var urlTags = params.getAll('filter.p.tag');
//           if (cat.brands) {
//             for (var bi = 0; bi < cat.brands.length; bi++) {
//               if (urlTags.indexOf(cat.brands[bi].tag) !== -1) { preservedBrand = cat.brands[bi].tag; break; }
//             }
//           }
//           if (cat.seasons) {
//             for (var si = 0; si < cat.seasons.length; si++) {
//               if (urlTags.indexOf(cat.seasons[si].tag) !== -1) { preservedSeason = cat.seasons[si].tag; break; }
//             }
//           }
//         } catch (e) {}
//       }

//       return {
//         handle: h,
//         title: lg.title,
//         logo: lg.logo,
//         isActive: h === location.leagueHandle && !location.teamHandle,
//         url: buildUrl(collectionHandle, location.activeGender, null, preservedBrand, preservedSeason),
//         style: lg.logo ? 'with-icon' : 'compact'
//       };
//     });
//     paintCarousel(carousel, items);
//     row.style.display = '';
//   }

//   function renderTeams(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="teams"]');
//     var carousel = wrapper.querySelector('[data-carousel="teams"]');
//     if (!row || !carousel) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // GYM MODE: if the category has `brands` and a league is picked,
//     // render brand tag filters (Nike, Adidas) instead of teams
//     if (cat && cat.brands && cat.brands.length && location.leagueHandle) {
//       var league = cat.leagues[location.leagueHandle];
//       // Determine the current gym collection (gender-specific)
//       var currentColl;
//       if (league.genderHandles) {
//         currentColl = league.genderHandles[location.activeGender] || league.genderHandles.men;
//       } else {
//         currentColl = location.leagueHandle;
//       }

//       // Set row label (BRAND)
//       var lbl = row.querySelector('.sf-row-label');
//       if (lbl) lbl.textContent = cat.teamRowLabel || 'Brand';

//       // Detect which brand tag is currently active
//       var activeBrand = null;
//       try {
//         var params = new URLSearchParams(window.location.search);
//         var urlTags = params.getAll('filter.p.tag');
//         for (var i = 0; i < cat.brands.length; i++) {
//           for (var j = 0; j < urlTags.length; j++) {
//             if (urlTags[j] === cat.brands[i].tag) { activeBrand = cat.brands[i].tag; break; }
//           }
//           if (activeBrand) break;
//         }
//       } catch (e) {}

//       // Make row label clickable if a brand is active (jumps to /collections/nike, etc.)
//       // Find the brand's display name (title) for the button label
//       var brandDisplayName = null;
//       if (activeBrand) {
//         for (var bri = 0; bri < cat.brands.length; bri++) {
//           if (cat.brands[bri].tag === activeBrand) {
//             brandDisplayName = cat.brands[bri].title || activeBrand;
//             break;
//           }
//         }
//       }
//       applyLabelClick(
//         row,
//         getLabelClickUrl(cat, 'teams', location, activeBrand, brandDisplayName),
//         cat.teamRowLabel || 'Brand'
//       );
//       // Build pills: "All" + each brand — preserving active season if set
//       var brandItems = [{
//         handle: '__all_brands__',
//         title: 'All',
//         isActive: !activeBrand,
//         url: buildUrl(currentColl, location.activeGender, null, null, location.activeSeason),
//         style: 'type'
//       }];
//       cat.brands.forEach(function(b) {
//         brandItems.push({
//           handle: b.tag,
//           title: b.title,
//           logo: b.logo,
//           isActive: activeBrand === b.tag,
//           url: buildUrl(currentColl, location.activeGender, null, b.tag, location.activeSeason),
//           style: b.logo ? 'with-icon' : 'type'
//         });
//       });
//       paintCarousel(carousel, brandItems);
//       row.style.display = '';
//       return;
//     }

//     // If the category suppresses the team level entirely, hide the row.
//     if (isTeamLevelSuppressed(cat)) { row.style.display = 'none'; return; }

//     // For F1 (single synthetic league), always show the brands row even
//     // when no league is explicitly picked — it IS the primary filter dimension.
//     var leagueForTeams = null;
//     if (location.leagueHandle) {
//       leagueForTeams = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     } else if (cat && cat.leagues) {
//       var leagueKeys = Object.keys(cat.leagues);
//       if (leagueKeys.length === 1) {
//         leagueForTeams = cat.leagues[leagueKeys[0]];
//         location.leagueHandle = leagueKeys[0]; // implicitly select the sole league
//       }
//     }

//     if (!leagueForTeams || !leagueForTeams.teams || !Object.keys(leagueForTeams.teams).length) {
//       row.style.display = 'none';
//       return;
//     }

//     // Set row label dynamically (F1 uses "BRAND" instead of "TEAM")
//     var label = row.querySelector('.sf-row-label');
//     if (label) {
//       if (cat.teamRowLabel) label.textContent = cat.teamRowLabel;
//       else if (cat.rowLabel === 'BRAND') label.textContent = 'Brand';
//       else label.textContent = 'Team';
//     }

//     var items = Object.keys(leagueForTeams.teams).map(function(h) {
//       var t = leagueForTeams.teams[h];
//       var isThisTeam = h === location.teamHandle;
//       var isActive = isThisTeam && !location.activeType;
//       var url;
//       // Tag-based team (International Kits countries)
//       if (t.tag && leagueForTeams.handle) {
//         url = buildUrl(leagueHandleStr(leagueForTeams), location.activeGender, null, t.tag);
//       } else {
//         // Handle-based team (Arsenal, f1-ferrari, etc.)
//         url = buildUrl(h, location.activeGender, null);
//       }
//       return {
//         handle: h,
//         title: t.title,
//         logo: t.logo,
//         isActive: isActive,
//         isCurrent: isThisTeam,
//         url: url,
//         style: 'with-icon'
//       };
//     });
//     paintCarousel(carousel, items);
//     row.style.display = '';
//   }

//   function renderTypes(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="types"]');
//     var carousel = wrapper.querySelector('[data-carousel="types"]');
//     if (!row || !carousel) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // CASUAL MODE: Season-conditional types (guided flow).
//     // Only show Type row when a season is picked.
//     if (cat && cat.typesBySeason) {
//       if (!location.activeSeason) { row.style.display = 'none'; return; }
//       var casualTypes = getProductTypes(cat, location.activeSeason);
//       if (!casualTypes.length) { row.style.display = 'none'; return; }

//       // Set row label
//       var casualLbl = row.querySelector('.sf-row-label');
//       if (casualLbl) casualLbl.textContent = 'Type';

//       // Determine current collection (gender-specific parent for casual)
//       var casualColl;
//       if (cat.genderHandles && cat.genderHandles[location.activeGender]) {
//         casualColl = cat.genderHandles[location.activeGender];
//       } else {
//         casualColl = cat.handle || location.categoryHandle;
//       }

//       // Detect active brand tag (to preserve when switching type)
//       var casualBrand = null;
//       if (cat.brands) {
//         try {
//           var params = new URLSearchParams(window.location.search);
//           var urlTags = params.getAll('filter.p.tag');
//           for (var bi = 0; bi < cat.brands.length; bi++) {
//             if (urlTags.indexOf(cat.brands[bi].tag) !== -1) { casualBrand = cat.brands[bi].tag; break; }
//           }
//         } catch (e) {}
//       }

//       // Build pills: "All" + each season-specific type (preserving brand + season)
//       var casualItems = [{
//         handle: '__all_types__',
//         title: 'All',
//         isActive: !location.activeType,
//         url: buildUrl(casualColl, location.activeGender, null, casualBrand, location.activeSeason),
//         style: 'type'
//       }];
//       casualTypes.forEach(function(t) {
//         casualItems.push({
//           handle: t.tag,
//           title: t.title,
//           tag: t.tag,
//           isActive: location.activeType === t.tag,
//           url: buildUrl(casualColl, location.activeGender, t.tag, casualBrand, location.activeSeason),
//           style: 'type'
//         });
//       });
//       paintCarousel(carousel, casualItems);
//       // Clickable label: for casual with parent-plus-tag pattern, jumps to catch-all filtered by type
//       var casualTypeName = null;
//       if (location.activeType) {
//         for (var cti = 0; cti < casualTypes.length; cti++) {
//           if (casualTypes[cti].tag === location.activeType) {
//             casualTypeName = casualTypes[cti].title || location.activeType;
//             break;
//           }
//         }
//       }
//       applyLabelClick(
//         row,
//         getLabelClickUrl(cat, 'types', location, location.activeType, casualTypeName),
//         'Type'
//       );
//       row.style.display = '';
//       return;
//     }

//     // Standard mode (Football/F1): types show under a team
//     var types = getProductTypes(cat, location.activeSeason);
//     if (!types.length) { row.style.display = 'none'; return; }

//     // Only show types when a team (leaf) is selected
//     if (!location.teamHandle) { row.style.display = 'none'; return; }

//     var league = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     var team = league && league.teams && league.teams[location.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;
//     var teamCollectionHandle = isTagBasedTeam ? leagueHandleStr(league) : location.teamHandle;
//     var teamTag = isTagBasedTeam ? team.tag : null;

//     var items = [{
//       handle: location.teamHandle,
//       title: 'All',
//       isActive: !location.activeType,
//       url: buildUrl(teamCollectionHandle, location.activeGender, null, teamTag),
//       style: 'type'
//     }];
//     types.forEach(function(t) {
//       items.push({
//         handle: location.teamHandle,
//         title: t.title,
//         tag: t.tag,
//         isActive: location.activeType === t.tag,
//         url: buildUrl(teamCollectionHandle, location.activeGender, t.tag, teamTag),
//         style: 'type'
//       });
//     });
//     paintCarousel(carousel, items);
//     // Clickable KIT label: on F1, jumps to /collections/f1?filter.p.tag=<type>
//     // Find the type's display name for the button
//     var typeDisplayName = null;
//     if (location.activeType) {
//       for (var tdi = 0; tdi < types.length; tdi++) {
//         if (types[tdi].tag === location.activeType) {
//           typeDisplayName = types[tdi].title || location.activeType;
//           break;
//         }
//       }
//     }
//     applyLabelClick(
//       row,
//       getLabelClickUrl(cat, 'types', location, location.activeType, typeDisplayName),
//       'Kit'
//     );
//     row.style.display = '';
//   }

//   // Renders the SEASON row (Gym only). Season is a TAG filter that can be
//   // combined with any other active filter (Type, Brand, Gender).
//   function renderSeasons(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="seasons"]');
//     var carousel = wrapper.querySelector('[data-carousel="seasons"]');
//     if (!row || !carousel) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];
//     if (!cat || !cat.seasons || !cat.seasons.length) { row.style.display = 'none'; return; }

//     // Set row label
//     var lbl = row.querySelector('.sf-row-label');
//     if (lbl) lbl.textContent = 'Season';

//     // Determine current collection (gender-specific for gym at league level, casual at category level)
//     var currentColl;
//     if (location.leagueHandle && cat.leagues && cat.leagues[location.leagueHandle] && cat.leagues[location.leagueHandle].genderHandles) {
//       // Gym: league-level gender handles
//       var gh = cat.leagues[location.leagueHandle].genderHandles;
//       currentColl = gh[location.activeGender] || gh.men;
//     } else if (cat.genderHandles) {
//       // Casual: category-level gender handles
//       currentColl = cat.genderHandles[location.activeGender] || cat.handle || location.categoryHandle;
//     } else {
//       currentColl = cat.handle || location.categoryHandle;
//     }

//     // Determine active brand tag (to preserve when switching season)
//     var activeBrandTag = null;
//     if (cat.brands) {
//       try {
//         var params = new URLSearchParams(window.location.search);
//         var urlTags = params.getAll('filter.p.tag');
//         for (var i = 0; i < cat.brands.length; i++) {
//           for (var j = 0; j < urlTags.length; j++) {
//             if (urlTags[j] === cat.brands[i].tag) { activeBrandTag = cat.brands[i].tag; break; }
//           }
//           if (activeBrandTag) break;
//         }
//       } catch (e) {}
//     }

//     // Helper: given a target season, check if the currently active type is still valid.
//     // For Casual (typesBySeason), a type only belongs to one season, so switching season
//     // must drop the type unless it exists in the target season's type list.
//     function typeStillValid(targetSeasonTag) {
//       if (!location.activeType) return null;
//       if (!cat.typesBySeason) return location.activeType; // non-casual: type always compatible
//       if (!targetSeasonTag) return null; // moving to "All" seasons — drop type (guided flow needs season)
//       var targetTypes = cat.typesBySeason[targetSeasonTag] || [];
//       for (var ti = 0; ti < targetTypes.length; ti++) {
//         if (targetTypes[ti].tag === location.activeType) return location.activeType;
//       }
//       return null; // type doesn't exist in target season → drop it
//     }

//     // Build pills: "All" + each season
//     // Note: brand tag goes in teamTag slot, season goes in extraTag slot
//     // For casual, we ALSO preserve type IF compatible with the target season.
//     var seasonItems = [{
//       handle: '__all_seasons__',
//       title: 'All',
//       isActive: !location.activeSeason,
//       url: buildUrl(currentColl, location.activeGender, typeStillValid(null), activeBrandTag, null),
//       style: 'type'
//     }];
//     cat.seasons.forEach(function(s) {
//       var title = s.emoji ? (s.emoji + ' ' + s.title) : s.title;
//       seasonItems.push({
//         handle: s.tag,
//         title: title,
//         isActive: location.activeSeason === s.tag,
//         url: buildUrl(currentColl, location.activeGender, typeStillValid(s.tag), activeBrandTag, s.tag),
//         style: 'type'
//       });
//     });
//     paintCarousel(carousel, seasonItems);
//     row.style.display = '';
//   }

//   // Renders the "See all Polo · See all T-Shirt · ..." footer chips.
//   // These are cross-brand kit shortcuts that always visible on categories
//   // that have flat productTypes or typesBySeason (Football, F1, Casual).
//   // Hidden on Gym (types already visible as pills) and Caps (no types) and
//   // gender landings (no active category).
//   function renderFooterChips(wrapper, location) {
//     var footer = wrapper.querySelector('[data-level="footer-chips"]');
//     var content = wrapper.querySelector('[data-carousel="footer-chips"]');
//     if (!footer || !content) return;

//     // Hide on gender landings — no meaningful "See all X" until they pick a category
//     if (location.isGenderLanding) { footer.style.display = 'none'; return; }

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];
//     if (!cat) { footer.style.display = 'none'; return; }

//     // Gather all kit types for this category.
//     // - typesBySeason (Casual): combine Summer + Winter, dedupe by tag
//     // - productTypes explicitly [] (Caps): stays empty → footer hides
//     // - productTypes undefined (Football): use global default via getProductTypes
//     var kitTypes = [];
//     if (cat.typesBySeason) {
//       var seen = {};
//       var seasonKeys = Object.keys(cat.typesBySeason);
//       for (var si = 0; si < seasonKeys.length; si++) {
//         var arr = cat.typesBySeason[seasonKeys[si]] || [];
//         for (var ti = 0; ti < arr.length; ti++) {
//           if (!seen[arr[ti].tag]) {
//             seen[arr[ti].tag] = true;
//             kitTypes.push(arr[ti]);
//           }
//         }
//       }
//     } else {
//       // getProductTypes: respects empty arrays (Caps hides), falls back to global
//       kitTypes = getProductTypes(cat);
//     }

//     // Hide the footer when there are no kits (Caps has explicit [])
//     if (!kitTypes.length) { footer.style.display = 'none'; return; }

//     // Hide on Gym Shirts — its "leagues" (Jackets, Hoodies, Tops...) are the
//     // type-equivalent pills, so footer chips would duplicate them.
//     if (location.categoryHandle === 'gym-shirts') {
//       footer.style.display = 'none';
//       return;
//     }

//     var parentHandle = cat.handle || location.categoryHandle;

//     // Build chips — each links to /collections/{parent}?filter.p.tag=<tag>
//     content.innerHTML = '';
//     kitTypes.forEach(function(t) {
//       var a = document.createElement('a');
//       a.className = 'sf-footer-chip';
//       // Preserve active gender via existing buildUrl (adds ?filter.p.tag=Women etc. when needed)
//       a.href = buildUrl(parentHandle, location.activeGender, t.tag);
//       // Highlight if this kit is currently the active filter
//       if (location.activeType === t.tag) a.classList.add('is-active');
//       // Title text: prefer the display title
//       a.textContent = t.title || t.tag;
//       content.appendChild(a);
//     });
//     footer.style.display = '';
//   }

//   function renderBreadcrumb(wrapper, location) {
//     var el = wrapper.querySelector('.sf-breadcrumb');
//     if (!el) return;

//     // On gender landings, breadcrumb is just the gender label (e.g., "Women")
//     if (location.isGenderLanding) {
//       var labels = { women: 'Women', men: 'Men', kids: 'Kids' };
//       var text = labels[location.landingGender] || location.landingGender;
//       el.innerHTML = '<a class="sf-crumb is-current" href="/collections/' + location.landingGender + '">' + escapeHtml(text) + '</a>';
//       return;
//     }

//     var parts = [];
//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];
//     var league = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     var team = league && league.teams && league.teams[location.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;

//     // 1) Gender — use per-category label if defined, else fall back to defaults
//     var currentColl;
//     var teamTag = null;
//     if (location.teamHandle) {
//       if (isTagBasedTeam) { currentColl = leagueHandleStr(league); teamTag = team.tag; }
//       else { currentColl = location.teamHandle; }
//     } else if (location.leagueHandle) {
//       currentColl = leagueHandleStr(league) || location.leagueHandle;
//     } else {
//       currentColl = cat.handle || location.categoryHandle;
//     }

//     // Only include the Gender crumb if the category has gender tabs
//     if (!(cat && cat.hideGenderTabs)) {
//       // Resolve display label for this gender
//       var genderLabel;
//       if (cat && cat.genderTabs && cat.genderTabs[location.activeGender] && cat.genderTabs[location.activeGender].label) {
//         genderLabel = cat.genderTabs[location.activeGender].label;
//       } else if (location.activeGender === 'women') {
//         genderLabel = 'Women';
//       } else if (location.activeGender === 'kids') {
//         genderLabel = 'Kids';
//       } else {
//         genderLabel = 'Men';
//       }
//       parts.push({
//         text: genderLabel,
//         url: buildUrl(currentColl, location.activeGender, location.activeType, teamTag)
//       });
//     }

//     // 2) Category
//     if (cat) parts.push({
//       text: cat.title,
//       url: buildUrl(cat.handle || location.categoryHandle, location.activeGender, null)
//     });

//     // 3) League (skip for F1's synthetic single league — redundant with category)
//     var categoryLeagueKeys = cat && cat.leagues ? Object.keys(cat.leagues) : [];
//     var isSyntheticSingleLeague = categoryLeagueKeys.length === 1;

//     if (location.leagueHandle && league && !isSyntheticSingleLeague) {
//       var lgHandle = leagueHandleStr(league) || location.leagueHandle;
//       parts.push({
//         text: league.title,
//         url: buildUrl(lgHandle, location.activeGender, null)
//       });
//     }

//     // 4) Team
//     if (location.teamHandle && team) {
//       var teamUrl;
//       if (isTagBasedTeam) {
//         teamUrl = buildUrl(leagueHandleStr(league), location.activeGender, null, team.tag);
//       } else {
//         teamUrl = buildUrl(location.teamHandle, location.activeGender, null);
//       }
//       parts.push({ text: team.title, url: teamUrl });
//     }

//     // 5) Product type
//     if (location.activeType) {
//       var types = getProductTypes(cat, location.activeSeason);
//       var match = types.filter(function(p) { return p.tag === location.activeType; })[0];
//       if (match) {
//         var typeUrl;
//         if (isTagBasedTeam) {
//           typeUrl = buildUrl(leagueHandleStr(league), location.activeGender, match.tag, team.tag);
//         } else if (location.teamHandle) {
//           typeUrl = buildUrl(location.teamHandle, location.activeGender, match.tag);
//         } else {
//           typeUrl = buildUrl(cat.handle || location.categoryHandle, location.activeGender, match.tag);
//         }
//         parts.push({ text: match.title, url: typeUrl });
//       }
//     }

//     el.innerHTML = parts.map(function(p, i) {
//       var isLast = i === parts.length - 1;
//       var sep = i > 0 ? '<span class="sf-crumb-sep"> › </span>' : '';
//       return sep + '<a class="sf-crumb' + (isLast ? ' is-current' : '') + '" href="' + p.url + '">' + escapeHtml(p.text) + '</a>';
//     }).join('');
//   }

//   // ============ PAINT & UTILITIES ============

//   function paintCarousel(carousel, items) {
//     carousel.innerHTML = '';
//     items.forEach(function(item) {
//       var link = document.createElement('a');
//       var cls = 'sf-item';
//       if (item.isActive) cls += ' is-active';
//       else if (item.isCurrent) cls += ' is-current';
//       if (item.style === 'with-icon') {
//         cls += ' sf-with-icon';
//       } else if (item.style === 'type') {
//         cls += ' sf-type';
//       } else {
//         cls += ' sf-compact';
//       }
//       link.className = cls;
//       link.href = item.url;
//       link.setAttribute('data-handle', item.handle);
//       if (item.style === 'with-icon') {
//         var logoHtml = item.logo
//           ? '<img class="sf-item-logo-img" src="' + item.logo + '" alt="' + escapeHtml(item.title) + '" loading="lazy" onerror="this.style.display=\'none\'">'
//           : '<span class="sf-item-logo-fallback">' + escapeHtml(item.title.charAt(0)) + '</span>';
//         link.innerHTML =
//           '<div class="sf-item-logo">' + logoHtml + '</div>' +
//           '<div class="sf-item-title">' + escapeHtml(item.title) + '</div>';
//       } else {
//         link.innerHTML = escapeHtml(item.title);
//       }
//       attachClickFeedback(link, item.isActive);
//       carousel.appendChild(link);
//     });
//   }

//   function setupArrows(carousel) {
//     var container = carousel.closest('.sf-carousel-container');
//     if (!container) return;
//     var prev = container.querySelector('.sf-arrow-prev');
//     var next = container.querySelector('.sf-arrow-next');
//     if (!prev || !next) return;
//     function scroll(delta) { carousel.scrollBy({ left: delta, behavior: 'smooth' }); }
//     prev.onclick = function() { scroll(-260); };
//     next.onclick = function() { scroll(260); };
//     function checkOverflow() {
//       var hasOverflow = carousel.scrollWidth > carousel.clientWidth + 4;
//       container.classList.toggle('has-overflow', hasOverflow);
//     }
//     checkOverflow();
//     window.addEventListener('resize', checkOverflow);
//   }

//   function attachClickFeedback(link, alreadyActive) {
//     if (alreadyActive) {
//       link.addEventListener('click', function(e) { e.preventDefault(); });
//       return;
//     }
//     link.addEventListener('click', function() { link.classList.add('is-loading'); });
//   }

//   function scrollIntoView(el) {
//     try { el.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); }
//     catch (e) {}
//   }

//   function escapeHtml(s) {
//     return String(s).replace(/[&<>"']/g, function(c) {
//       return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
//     });
//   }
// })();
// oct-15-ends 
// -----------------------------------------------------------------------------------------------------------
// // shirts-carousel-filter.js
// // Football Shirts filter — Category → League → Team → Product Type
// // Auto-detects if the current collection is in the hierarchy; hides otherwise.

// (function() {
//   'use strict';

//   if (!window.ShirtsHierarchy) return;

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   var currentLocation = null;

//   function init() {
//     var wrapper = document.querySelector('.sf-nav-wrapper');
//     if (!wrapper) return;

//     var currentHandle = wrapper.dataset.currentHandle;
//     if (!currentHandle) return;

//     var location = findInHierarchy(currentHandle);
//     if (!location) {
//       // Not a shirt collection — hide the shirt filter card but keep the
//       // catalog switcher visible so customers can navigate away.
//       // If the SHOE filter is active, hide our catalog switcher to avoid duplication.
//       var shoeWrapper = document.querySelector('.hcf-nav-wrapper');
//       var shoeIsActive = shoeWrapper && shoeWrapper.querySelector('.hcf-item') !== null;

//       var inner = wrapper.querySelector('.sf-nav-inner');
//       if (inner) {
//         Array.prototype.forEach.call(inner.children, function(child) {
//           if (!child.classList || !child.classList.contains('cs-catalog-tabs')) {
//             child.style.display = 'none';
//           }
//         });
//         if (shoeIsActive) {
//           var shirtTabs = inner.querySelector('.cs-catalog-tabs');
//           if (shirtTabs) shirtTabs.style.display = 'none';
//           wrapper.style.display = 'none';
//         }
//       }
//       var stickyBar = document.getElementById('sf-sticky-bar');
//       if (stickyBar) stickyBar.remove();
//       var fab = document.getElementById('sf-fab');
//       if (fab) fab.remove();
//       var expandedOverlay = document.getElementById('sf-expanded-overlay');
//       if (expandedOverlay) expandedOverlay.remove();
//       return;
//     }

//     // For gender landings, activeGender = the landing gender directly
//     if (location.isGenderLanding) {
//       location.activeGender = location.landingGender;
//     } else {
//       location.activeGender = detectGenderFromUrl();
//     }
//     location.activeType   = detectTypeTagFromUrl(location);
//     location.activeSeason = detectSeasonFromUrl(location);

//     currentLocation = location;

//     renderGenderTabs(wrapper, location);
//     renderCategories(wrapper, location);
//     renderLeagues(wrapper, location);
//     renderTeams(wrapper, location);
//     renderTypes(wrapper, location);
//     renderSeasons(wrapper, location);
//     renderBreadcrumb(wrapper, location);

//     // Add helper class if the deep rows (teams + types) are both hidden
//     var teamsRow = wrapper.querySelector('[data-level="teams"]');
//     var typesRow = wrapper.querySelector('[data-level="types"]');
//     var teamsHidden = !teamsRow || teamsRow.style.display === 'none';
//     var typesHidden = !typesRow || typesRow.style.display === 'none';
//     wrapper.classList.toggle('sf-leagues-only', teamsHidden && typesHidden);

//     wrapper.querySelectorAll('.sf-carousel').forEach(setupArrows);
//     setTimeout(function() {
//       wrapper.querySelectorAll('.sf-item.is-active').forEach(scrollIntoView);
//     }, 100);

//     setupScrollHints(wrapper);
//     setupStickyBar(wrapper, location);
//     setupExpandedOverlay(wrapper);
//     setupFAB(wrapper);
//   }

//   // ============ HELPERS ============

//   // Unwrap league.handle if it's a string OR array of aliases (returns first alias or null)
//   function leagueHandleStr(league) {
//     if (!league) return null;
//     if (Array.isArray(league.handle)) return league.handle[0];
//     return league.handle || null;
//   }

//   // Get the productTypes list for a given category.
//   //   - Football/F1: fixed list from cat.productTypes or global fallback
//   //   - Casual: season-conditional — pass activeSeason as 2nd arg
//   //     Returns [] if season required but not set (guided flow — Type row hidden)
//   function getProductTypes(cat, activeSeason) {
//     if (cat && cat.typesBySeason) {
//       if (!activeSeason) return [];
//       return cat.typesBySeason[activeSeason] || [];
//     }
//     // Explicit empty array means "this category has no product types" — respect it.
//     // Only fall through to global if productTypes is completely undefined.
//     if (cat && Array.isArray(cat.productTypes)) return cat.productTypes;
//     return window.ShirtsHierarchy.productTypes || [];
//   }

//   // Is this category's team level suppressed (e.g., F1 has no sub-teams)?
//   function isTeamLevelSuppressed(cat) {
//     return cat && cat.teamRowLabel === null;
//   }

//   // Returns { url, buttonText } for a clickable row label, or null if not applicable.
//   //
//   //   cat         — active category object
//   //   rowLevel    — 'leagues' | 'teams' | 'types'
//   //   location    — current location object
//   //   activeTag   — the currently active tag in this row (or null)
//   //   displayName — the display title matching activeTag (e.g., "Cap" for tag "F1 caps");
//   //                 falls back to activeTag if not provided
//   function getLabelClickUrl(cat, rowLevel, location, activeTag, displayName) {
//     if (!cat || !cat.labelClicks) return null;
//     var cfg = cat.labelClicks[rowLevel];
//     if (!cfg || !activeTag) return null;

//     var url = null;
//     if (cfg.pattern === 'brand-collection') {
//       // Lowercase-hyphenate the tag to produce a collection handle
//       // (e.g., "Nike" → "nike", "Tommy Hilfiger" → "tommy-hilfiger")
//       var handle = activeTag.toLowerCase().replace(/\s+/g, '-');
//       url = '/collections/' + handle;
//     } else if (cfg.pattern === 'handle-map' && cfg.handleMap && cfg.handleMap[activeTag]) {
//       url = '/collections/' + cfg.handleMap[activeTag];
//     } else if (cfg.pattern === 'parent-plus-tag') {
//       var parent = cat.handle || location.categoryHandle;
//       url = '/collections/' + parent + '?filter.p.tag=' + encodeURIComponent(activeTag);
//     }

//     if (!url) return null;

//     // Build button text from format template
//     var name = displayName || activeTag;
//     var format = cfg.buttonTextFormat || 'Shop {name}';
//     var buttonText = format.replace('{name}', name);

//     return { url: url, buttonText: buttonText };
//   }

//   // Apply the "shop X" button to a row label. If clickInfo is null, resets
//   // the label to plain text (defaultLabel).
//   //
//   //   clickInfo   — { url, buttonText } from getLabelClickUrl, or null
//   //   defaultLabel — the plain text to show when no filter is active
//   function applyLabelClick(row, clickInfo, defaultLabel) {
//     var label = row.querySelector('.sf-row-label');
//     if (!label) return;

//     if (clickInfo && clickInfo.url) {
//       // Render as burgundy pill button — impossible to miss
//       label.innerHTML = '';
//       var btn = document.createElement('a');
//       btn.className = 'sf-label-btn';
//       btn.href = clickInfo.url;
//       btn.textContent = clickInfo.buttonText;
//       btn.setAttribute('aria-label', clickInfo.buttonText);
//       label.appendChild(btn);
//       label.classList.add('sf-label-has-btn');
//     } else {
//       // Plain text label (no active filter)
//       label.textContent = defaultLabel;
//       label.classList.remove('sf-label-has-btn');
//     }
//   }

//   // ============ MOBILE SCROLL HINTS (COMBO: fade + peek + delayed arrow) ============
//   function setupScrollHints(wrapper) {
//     if (window.matchMedia && !window.matchMedia('(max-width: 768px)').matches) return;

//     setTimeout(function() {
//       var rows = wrapper.querySelectorAll('.sf-row-content');
//       var anyOverflowed = false;
//       var alreadyPeeked = false;
//       try { alreadyPeeked = sessionStorage.getItem('sf_peek_played') === '1'; } catch (e) {}

//       rows.forEach(function(rowContent) {
//         var carousel = rowContent.querySelector('.sf-carousel');
//         if (!carousel) return;

//         var overflows = carousel.scrollWidth > carousel.clientWidth + 4;
//         if (!overflows) return;

//         anyOverflowed = true;
//         rowContent.classList.add('sf-has-overflow');

//         if (!rowContent.querySelector('.sf-scroll-arrow')) {
//           var arrow = document.createElement('div');
//           arrow.className = 'sf-scroll-arrow';
//           arrow.innerHTML = '<svg width="14" height="14" viewBox="0 0 20 20" fill="none"><path d="M8 4L14 10L8 16" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
//           rowContent.appendChild(arrow);
//         }

//         if (!alreadyPeeked) {
//           carousel.classList.add('sf-peek');
//           setTimeout(function() { carousel.classList.remove('sf-peek'); }, 3000);
//         }

//         var arrowTimer = setTimeout(function() {
//           if (!rowContent.classList.contains('sf-scrolled')) {
//             rowContent.classList.add('sf-show-arrow');
//             setTimeout(function() {
//               rowContent.classList.remove('sf-show-arrow');
//             }, 6000);
//           }
//         }, 2000);

//         var onScroll = function() {
//           rowContent.classList.add('sf-scrolled');
//           rowContent.classList.remove('sf-show-arrow');
//           clearTimeout(arrowTimer);
//           if (carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4) {
//             rowContent.classList.remove('sf-has-overflow');
//           }
//           carousel.removeEventListener('scroll', onScroll);
//           carousel.addEventListener('scroll', function() {
//             var atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4;
//             rowContent.classList.toggle('sf-has-overflow', !atEnd);
//           }, { passive: true });
//         };
//         carousel.addEventListener('scroll', onScroll, { passive: true });
//       });

//       if (anyOverflowed && !alreadyPeeked) {
//         try { sessionStorage.setItem('sf_peek_played', '1'); } catch (e) {}
//       }
//     }, 250);
//   }

//   // ============ STICKY BAR / EXPANDED OVERLAY / FAB ============

//   function setupStickyBar(wrapper, location) {
//     var stickyBar = document.getElementById('sf-sticky-bar');
//     var stickyPath = document.getElementById('sf-sticky-path');
//     var stickyBack = document.getElementById('sf-sticky-back');
//     var stickyScrollTop = document.getElementById('sf-sticky-scroll-top');
//     if (!stickyBar || !wrapper) return;

//     var pathTextEl = stickyBar.querySelector('.sf-sticky-path-text');
//     if (pathTextEl) pathTextEl.textContent = buildStickyPathText(location);

//     var backTarget = getBackTarget(location);
//     if (backTarget) {
//       stickyBack.disabled = false;
//       stickyBack.onclick = function() { window.location.href = backTarget; };
//     } else {
//       stickyBack.disabled = true;
//     }

//     if (stickyScrollTop) {
//       stickyScrollTop.onclick = function() {
//         wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
//       };
//     }

//     if (stickyPath) stickyPath.onclick = openExpandedOverlay;

//     var ticking = false;
//     function updateVisibility() {
//       var wrapperBottom = wrapper.getBoundingClientRect().bottom;
//       if (wrapperBottom < 0) {
//         stickyBar.classList.add('is-visible');
//         stickyBar.setAttribute('aria-hidden', 'false');
//       } else {
//         stickyBar.classList.remove('is-visible');
//         stickyBar.setAttribute('aria-hidden', 'true');
//       }
//       ticking = false;
//     }
//     window.addEventListener('scroll', function() {
//       if (!ticking) {
//         window.requestAnimationFrame(updateVisibility);
//         ticking = true;
//       }
//     }, { passive: true });
//     updateVisibility();
//   }

//   function buildStickyPathText(loc) {
//     if (!loc) return 'All Jerseys';
//     var parts = [];
//     var cat = window.ShirtsHierarchy.categories[loc.categoryHandle];

//     // Gender label: only show if category has gender tabs; support Men/Women/Kids
//     if (!(cat && cat.hideGenderTabs)) {
//       var genderLabel;
//       if (cat && cat.genderTabs && cat.genderTabs[loc.activeGender] && cat.genderTabs[loc.activeGender].label) {
//         genderLabel = cat.genderTabs[loc.activeGender].label;
//       } else if (loc.activeGender === 'women') {
//         genderLabel = 'Women';
//       } else if (loc.activeGender === 'kids') {
//         genderLabel = 'Kids';
//       } else {
//         genderLabel = 'Men';
//       }
//       parts.push(genderLabel);
//     }

//     if (cat) parts.push(cat.title);
//     if (loc.leagueHandle) {
//       var lg = cat && cat.leagues && cat.leagues[loc.leagueHandle];
//       // For F1's synthetic 'f1' league, don't add "F1 Brands" — redundant with category
//       if (lg && loc.leagueHandle !== 'f1') parts.push(lg.title);
//     }
//     if (loc.teamHandle) {
//       var lg2 = cat && cat.leagues && cat.leagues[loc.leagueHandle];
//       var t = lg2 && lg2.teams && lg2.teams[loc.teamHandle];
//       if (t) parts.push(t.title);
//     }
//     if (loc.activeType) {
//       var types = getProductTypes(cat, loc.activeSeason);
//       var match = types.filter(function(p) { return p.tag === loc.activeType; })[0];
//       if (match) parts.push(match.title);
//     }
//     return parts.join(' › ');
//   }

//   function getBackTarget(loc) {
//     if (!loc) return null;
//     var cat = window.ShirtsHierarchy.categories[loc.categoryHandle];
//     var league = cat && cat.leagues && cat.leagues[loc.leagueHandle];
//     var team = league && league.teams && league.teams[loc.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;

//     // Type filter active → clear type
//     if (loc.activeType && loc.teamHandle) {
//       if (isTagBasedTeam) {
//         return buildUrl(leagueHandleStr(league), loc.activeGender, null, team.tag);
//       }
//       return buildUrl(loc.teamHandle, loc.activeGender, null);
//     }
//     // Team active → go up to league
//     if (loc.teamHandle && loc.leagueHandle) {
//       if (isTagBasedTeam) {
//         return buildUrl(leagueHandleStr(league), loc.activeGender, null);
//       }
//       return buildUrl(loc.leagueHandle, loc.activeGender, null);
//     }
//     // League active → go up to category
//     if (loc.leagueHandle && loc.categoryHandle) {
//       return buildUrl(loc.categoryHandle, loc.activeGender, null);
//     }
//     return null;
//   }

//   function setupExpandedOverlay(wrapper) {
//     var overlay = document.getElementById('sf-expanded-overlay');
//     if (!overlay) return;
//     var backdrop = overlay.querySelector('.sf-expanded-backdrop');
//     var closeBtn = document.getElementById('sf-expanded-close');
//     if (closeBtn) closeBtn.onclick = closeExpandedOverlay;
//     if (backdrop) backdrop.onclick = closeExpandedOverlay;
//     document.addEventListener('keydown', function(e) {
//       if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
//         closeExpandedOverlay();
//       }
//     });
//   }

//   function openExpandedOverlay() {
//     var overlay = document.getElementById('sf-expanded-overlay');
//     var content = document.getElementById('sf-expanded-content');
//     var wrapper = document.querySelector('.sf-nav-wrapper');
//     if (!overlay || !content || !wrapper) return;

//     content.innerHTML = '';
//     wrapper.querySelectorAll('.sf-row').forEach(function(row) {
//       if (row.style.display === 'none') return;
//       var clone = row.cloneNode(true);
//       content.appendChild(clone);
//     });

//     overlay.classList.add('is-open');
//     overlay.setAttribute('aria-hidden', 'false');
//     document.body.style.overflow = 'hidden';
//   }

//   function closeExpandedOverlay() {
//     var overlay = document.getElementById('sf-expanded-overlay');
//     if (!overlay) return;
//     overlay.classList.remove('is-open');
//     overlay.setAttribute('aria-hidden', 'true');
//     document.body.style.overflow = '';
//   }

//   function setupFAB(wrapper) {
//     var fab = document.getElementById('sf-fab');
//     if (!fab || !wrapper) return;
//     fab.onclick = function() {
//       wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     };
//     var ticking = false;
//     function update() {
//       var wrapperBottom = wrapper.getBoundingClientRect().bottom;
//       if (wrapperBottom < -300) fab.classList.add('is-visible');
//       else fab.classList.remove('is-visible');
//       ticking = false;
//     }
//     window.addEventListener('scroll', function() {
//       if (!ticking) {
//         window.requestAnimationFrame(update);
//         ticking = true;
//       }
//     }, { passive: true });
//     update();
//   }

//   // ============ LOCATION DETECTION ============

//   function findInHierarchy(handle) {
//     // GENDER LANDING pages: /collections/women, /collections/men, /collections/kids
//     // These are top-level gender landings (not tied to a specific category).
//     // We return a synthetic location with `isGenderLanding: true` so the renderers
//     // show the categories row with the landing gender pre-selected, but no
//     // specific category/league/team active.
//     if (handle === 'women' || handle === 'men' || handle === 'kids') {
//       return {
//         categoryHandle: null,
//         leagueHandle: null,
//         teamHandle: null,
//         level: 'landing',
//         isGenderLanding: true,
//         landingGender: handle
//       };
//     }

//     // Special case: kids-t-shirt is the Kids gender landing page.
//     if (handle === 'kids-t-shirt') {
//       return { categoryHandle: 'football-jerseys', leagueHandle: null, teamHandle: null, level: 'category' };
//     }

//     // CATEGORY-LEVEL GENDER HANDLES (Casual):
//     // Check for category-level gender handles (e.g., men-casual-out-fit → casual-shirts)
//     for (var cCatHandle in window.ShirtsHierarchy.categories) {
//       var cCat = window.ShirtsHierarchy.categories[cCatHandle];
//       if (!cCat.genderHandles) continue;
//       for (var cGender in cCat.genderHandles) {
//         if (cCat.genderHandles[cGender] === handle) {
//           return {
//             categoryHandle: cCatHandle,
//             leagueHandle: null,
//             teamHandle: null,
//             level: 'category'
//           };
//         }
//       }
//     }

//     // GYM detection: check for gender-specific handles (men-jackets, women-tops, etc.)
//     // Uses the gymCatCategory's leagues where each has a genderHandles map.
//     var gymCat = window.ShirtsHierarchy.categories['gym-shirts'];
//     if (gymCat && gymCat.leagues) {
//       for (var gymLgHandle in gymCat.leagues) {
//         var gymLg = gymCat.leagues[gymLgHandle];
//         if (!gymLg.genderHandles) continue;
//         for (var gKey in gymLg.genderHandles) {
//           if (gymLg.genderHandles[gKey] === handle) {
//             // Matched a men-* or women-* collection → gym category + this league is active
//             return {
//               categoryHandle: 'gym-shirts',
//               leagueHandle: gymLgHandle,
//               teamHandle: null,
//               level: 'league',
//               gymGender: gKey   // remember which gender-specific handle they hit
//             };
//           }
//         }
//       }
//     }

//     var categories = window.ShirtsHierarchy.categories;
//     for (var catHandle in categories) {
//       var cat = categories[catHandle];
//       var leagues = cat.leagues || {};

//       // (1) Handle-based team match: /collections/arsenal → team = arsenal
//       //     Also matches F1 brands like /collections/f1-ferrari
//       for (var lgHandle in leagues) {
//         var lg = leagues[lgHandle];
//         if (lg.teams && lg.teams[handle]) {
//           return { categoryHandle: catHandle, leagueHandle: lgHandle, teamHandle: handle, level: 'team' };
//         }
//       }

//       // (2) League match — supports:
//       //     (a) hierarchy key equals collection handle (Premier League, La Liga, etc.)
//       //     (b) league.handle is a STRING (tag-based leagues like International Kits)
//       //     (c) league.handle is an ARRAY of aliases (multiple collection URLs → same league)
//       for (var lgHandle2 in leagues) {
//         var lg2 = leagues[lgHandle2];
//         var leagueHandles = lg2.handle;
//         var isMatch = false;
//         if (Array.isArray(leagueHandles)) {
//           isMatch = leagueHandles.indexOf(handle) !== -1;
//         } else {
//           isMatch = ((leagueHandles || lgHandle2) === handle);
//         }
//         if (isMatch) {
//           // For tag-based leagues, check URL for team tag
//           var teamHandle = null;
//           if (lg2.handle) {
//             teamHandle = detectTagBasedTeamFromUrl(lg2);
//           }
//           return {
//             categoryHandle: catHandle,
//             leagueHandle: lgHandle2,
//             teamHandle: teamHandle,
//             level: teamHandle ? 'team' : 'league'
//           };
//         }
//       }

//       // (3) Category match: /collections/football-jerseys OR /collections/f1
//       var catParent = cat.handle || catHandle;
//       if (catParent === handle) {
//         return { categoryHandle: catHandle, leagueHandle: null, teamHandle: null, level: 'category' };
//       }
//     }
//     return null;
//   }

//   function detectTagBasedTeamFromUrl(league) {
//     if (!league || !league.teams) return null;
//     try {
//       var params = new URLSearchParams(window.location.search);
//       var urlTags = params.getAll('filter.p.tag');
//       for (var teamKey in league.teams) {
//         var team = league.teams[teamKey];
//         if (!team.tag) continue;
//         for (var i = 0; i < urlTags.length; i++) {
//           if (urlTags[i] === team.tag) return teamKey;
//         }
//       }
//     } catch (e) {}
//     return null;
//   }

//   function detectGenderFromUrl() {
//     try {
//       var wrapper = document.querySelector('.sf-nav-wrapper');
//       var currentHandle = wrapper && wrapper.dataset.currentHandle;
//       if (currentHandle === 'kids-t-shirt') return 'kids';

//       // Gym: detect gender from the current collection handle (men-* or women-*)
//       // OR from the ?filter.p.tag=Women / ?filter.p.tag=Men URL param
//       var gymCat = window.ShirtsHierarchy.categories['gym-shirts'];
//       if (gymCat && gymCat.leagues) {
//         for (var lg in gymCat.leagues) {
//           var gh = gymCat.leagues[lg].genderHandles || {};
//           for (var g in gh) {
//             if (gh[g] === currentHandle) return g;  // men-jackets → 'men'
//           }
//         }
//       }

//       // Casual (and any category with category-level genderHandles):
//       // detect gender from the parent handle mapping
//       for (var casCatH in window.ShirtsHierarchy.categories) {
//         var casCat = window.ShirtsHierarchy.categories[casCatH];
//         if (!casCat.genderHandles) continue;
//         for (var casG in casCat.genderHandles) {
//           if (casCat.genderHandles[casG] === currentHandle) return casG;
//         }
//       }

//       var params = new URLSearchParams(window.location.search);
//       var tags = params.getAll('filter.p.tag');
//       for (var i = 0; i < tags.length; i++) {
//         var t = tags[i].toLowerCase();
//         if (t === 'kids') return 'kids';
//         if (t === 'women') return 'women';
//         // 'men' tag also possible, but 'men' is the default so we only need to detect if explicitly set
//       }
//       // Check current handle for the gym parent — default to men
//       if (currentHandle === (gymCat && gymCat.handle)) return (gymCat.defaultGender || 'men');

//       return 'men';
//     } catch (e) { return 'men'; }
//   }

//   function detectTypeTagFromUrl(location) {
//     try {
//       var cat = location && window.ShirtsHierarchy.categories[location.categoryHandle];
//       // For Casual (typesBySeason), scan ALL seasons' types since we don't know the active season yet
//       var typesToCheck = [];
//       if (cat && cat.typesBySeason) {
//         for (var seasonKey in cat.typesBySeason) {
//           typesToCheck = typesToCheck.concat(cat.typesBySeason[seasonKey]);
//         }
//       } else {
//         typesToCheck = getProductTypes(cat);
//       }
//       var params = new URLSearchParams(window.location.search);
//       var tags = params.getAll('filter.p.tag');
//       for (var i = 0; i < tags.length; i++) {
//         for (var j = 0; j < typesToCheck.length; j++) {
//           if (tags[i] === typesToCheck[j].tag) return typesToCheck[j].tag;
//         }
//       }
//       return null;
//     } catch (e) { return null; }
//   }

//   // Detects active season TAG in the URL (Gym only — reads cat.seasons)
//   function detectSeasonFromUrl(location) {
//     try {
//       var cat = location && window.ShirtsHierarchy.categories[location.categoryHandle];
//       if (!cat || !cat.seasons || !cat.seasons.length) return null;
//       var params = new URLSearchParams(window.location.search);
//       var tags = params.getAll('filter.p.tag');
//       for (var i = 0; i < tags.length; i++) {
//         for (var j = 0; j < cat.seasons.length; j++) {
//           if (tags[i] === cat.seasons[j].tag) return cat.seasons[j].tag;
//         }
//       }
//       return null;
//     } catch (e) { return null; }
//   }

//   // ============ URL BUILDING ============
//   function buildUrl(collectionHandle, gender, typeTag, teamTag, extraTag) {
//     var url = '/collections/' + collectionHandle;
//     var params = [];
//     // Gender tag: only add when the collection ISN'T already gender-specific.
//     // Gender-specific gym collections (men-*, women-*) already restrict to that gender
//     // via their smart-collection rules, so adding the tag would be redundant.
//     var isGenderSpecific = /^(men|women)-/.test(collectionHandle) || collectionHandle === 'kids-t-shirt';
//     if (gender === 'kids' && !isGenderSpecific)  params.push('filter.p.tag=' + encodeURIComponent('Kids'));
//     if (gender === 'women' && !isGenderSpecific) params.push('filter.p.tag=' + encodeURIComponent('Women'));
//     if (teamTag)  params.push('filter.p.tag=' + encodeURIComponent(teamTag));
//     if (typeTag)  params.push('filter.p.tag=' + encodeURIComponent(typeTag));
//     if (extraTag) params.push('filter.p.tag=' + encodeURIComponent(extraTag));
//     if (params.length) url += '?' + params.join('&');
//     return url;
//   }

//   // ============ RENDERERS ============

//   function renderGenderTabs(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="gender"]');
//     if (!row) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // If the category opts out of gender tabs entirely (e.g., Caps — unisex),
//     // hide the whole row. This is different from just hiding individual tabs;
//     // it removes the gender row from the layout completely.
//     if (cat && cat.hideGenderTabs) {
//       row.style.display = 'none';
//       return;
//     }
//     // Make sure the row is visible for other categories (in case a previous
//     // Caps navigation left it hidden — reset to default display)
//     row.style.display = '';

//     // GENDER LANDING pages: no category yet, so pick a tab set based on the landing.
//     // - /collections/women or /men → Men | Women (with landing gender pre-active)
//     // - /collections/kids → Men | Kids (with kids pre-active)
//     if (location.isGenderLanding) {
//       var landingG = location.landingGender;
//       // Kids landing keeps Men/Kids; women/men landings use Men/Women
//       var landingGenders = (landingG === 'kids') ? ['men', 'kids'] : ['men', 'women'];
//       var landingLabels = {
//         men:   'Men',
//         women: 'Women',
//         kids:  'Kids'
//       };
//       ['men', 'kids', 'women'].forEach(function(g) {
//         var tab = row.querySelector('[data-gender="' + g + '"]');
//         if (!tab) return;
//         if (landingGenders.indexOf(g) === -1) {
//           tab.style.display = 'none';
//           return;
//         }
//         tab.style.display = '';
//         var labelSpan = tab.querySelector('span') || tab;
//         labelSpan.textContent = landingLabels[g];
//         // Each tab navigates to the corresponding /collections/<gender> landing
//         tab.href = '/collections/' + g;
//         tab.classList.toggle('is-active', landingG === g);
//       });
//       return;
//     }

//     // Use category-specific gender config if defined (e.g., Gym uses Men/Women)
//     // Otherwise fall back to Men/Kids defaults (Football, F1)
//     var genderConfig = cat && cat.genderTabs;
//     var genders = genderConfig ? Object.keys(genderConfig) : ['men', 'kids'];

//     // Determine base URL for gender switch
//     var league = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     var team = league && league.teams && league.teams[location.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;

//     // Hide any tabs not in this category's gender set; show/update the ones that are
//     ['men', 'kids', 'women'].forEach(function(g) {
//       var tab = row.querySelector('[data-gender="' + g + '"]');
//       if (!tab) return;
//       if (genders.indexOf(g) === -1) {
//         tab.style.display = 'none';
//         return;
//       }
//       tab.style.display = '';

//       // Update label if this category has a custom label
//       if (genderConfig && genderConfig[g] && genderConfig[g].label) {
//         var labelSpan = tab.querySelector('span') || tab;
//         labelSpan.textContent = genderConfig[g].label;
//       }

//       // Build the URL for this gender tab
//       var url;
//       if (cat && cat.handle && cat.leagues && cat.leagues[location.leagueHandle] && cat.leagues[location.leagueHandle].genderHandles) {
//         // Gym: switch to this gender's variant of the current category — preserve brand + season
//         var lgh = cat.leagues[location.leagueHandle].genderHandles;
//         var gymBrand = null, gymSeason = null;
//         try {
//           var pp = new URLSearchParams(window.location.search);
//           var tt = pp.getAll('filter.p.tag');
//           if (cat.brands) {
//             for (var bi = 0; bi < cat.brands.length; bi++) {
//               if (tt.indexOf(cat.brands[bi].tag) !== -1) { gymBrand = cat.brands[bi].tag; break; }
//             }
//           }
//           if (cat.seasons) {
//             for (var si = 0; si < cat.seasons.length; si++) {
//               if (tt.indexOf(cat.seasons[si].tag) !== -1) { gymSeason = cat.seasons[si].tag; break; }
//             }
//           }
//         } catch (e) {}
//         url = buildUrl(lgh[g] || cat.handle, g, null, gymBrand, gymSeason);
//       } else if (cat && cat.casualMode && cat.genderHandles) {
//         // CASUAL: category-level gender handles. Switch to gender's parent, preserve brand/season/type
//         var casBrand = null, casSeason = null;
//         try {
//           var ccp = new URLSearchParams(window.location.search);
//           var cct = ccp.getAll('filter.p.tag');
//           if (cat.brands) {
//             for (var cbi = 0; cbi < cat.brands.length; cbi++) {
//               if (cct.indexOf(cat.brands[cbi].tag) !== -1) { casBrand = cat.brands[cbi].tag; break; }
//             }
//           }
//           if (cat.seasons) {
//             for (var csi = 0; csi < cat.seasons.length; csi++) {
//               if (cct.indexOf(cat.seasons[csi].tag) !== -1) { casSeason = cat.seasons[csi].tag; break; }
//             }
//           }
//         } catch (e) {}
//         url = buildUrl(cat.genderHandles[g] || cat.handle, g, location.activeType, casBrand, casSeason);
//       } else if (cat && cat.genderTabs) {
//         // Gym without a category picked yet: go to parent
//         url = buildUrl(cat.handle || location.categoryHandle, g, null, null, location.activeSeason);
//       } else {
//         // Football / F1
//         var currentColl;
//         var teamTag = null;
//         if (location.teamHandle) {
//           if (isTagBasedTeam) { currentColl = leagueHandleStr(league); teamTag = team.tag; }
//           else { currentColl = location.teamHandle; }
//         } else if (location.leagueHandle) {
//           currentColl = leagueHandleStr(league) || location.leagueHandle;
//         } else {
//           currentColl = cat.handle || location.categoryHandle;
//         }
//         url = buildUrl(currentColl, g, location.activeType, teamTag);
//       }
//       tab.href = url;
//       tab.classList.toggle('is-active', location.activeGender === g);
//     });
//   }

//   function renderCategories(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="categories"]');
//     var carousel = wrapper.querySelector('[data-carousel="categories"]');
//     if (!row || !carousel) return;
//     var cats = window.ShirtsHierarchy.categories;
//     var handles = Object.keys(cats);

//     // Auto-hide if only 1 category exists (no need for a lone pill)
//     if (handles.length <= 1) {
//       row.style.display = 'none';
//       return;
//     }

//     // On a GENDER LANDING (/collections/women, /men, /kids), reorder categories
//     // so gender-supporting ones come first, and build URLs that preserve the gender.
//     if (location.isGenderLanding) {
//       var g = location.landingGender;
//       // Sort handles: supported first, unsupported after (stable within each group)
//       var supported = [];
//       var unsupported = [];
//       handles.forEach(function(h) {
//         var supports = cats[h].supportedGenders || ['men', 'kids'];
//         if (supports.indexOf(g) !== -1) supported.push(h);
//         else unsupported.push(h);
//       });
//       handles = supported.concat(unsupported);
//     }

//     var items = handles.map(function(h) {
//       var isCurrentCategory = h === location.categoryHandle;
//       var isActive = isCurrentCategory;   // false on landings (no cat picked)
//       var cat = cats[h];
//       var catParent = cat.handle || h;

//       // Build URL — preserve gender across category switches
//       var url;
//       if (location.isGenderLanding) {
//         var lg = location.landingGender;
//         // Category-level genderHandles (Casual): swap to gender-specific parent
//         if (cat.genderHandles && cat.genderHandles[lg]) {
//           url = buildUrl(cat.genderHandles[lg], lg, null);
//         } else if (cat.hideGenderTabs) {
//           // Unisex category (Caps): no gender tag
//           url = buildUrl(catParent, 'men', null);
//         } else {
//           // Default: navigate to parent with gender tag
//           url = buildUrl(catParent, lg, null);
//         }
//       } else {
//         url = buildUrl(catParent, location.activeGender, null);
//       }

//       return {
//         handle: h,
//         title: cat.title,
//         isActive: isActive,
//         isCurrent: isCurrentCategory,
//         url: url,
//         style: 'compact'
//       };
//     });
//     paintCarousel(carousel, items);
//     row.style.display = '';
//   }

//   function renderLeagues(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="leagues"]');
//     var carousel = wrapper.querySelector('[data-carousel="leagues"]');
//     if (!row || !carousel) return;
//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // CASUAL MODE: no traditional leagues — render BRANDS here instead.
//     if (cat && cat.casualMode && cat.brands && cat.brands.length) {
//       var casualLabel = row.querySelector('.sf-row-label');
//       if (casualLabel) casualLabel.textContent = cat.rowLabel || 'Brand';

//       // Determine current collection (gender-specific parent)
//       var casualColl;
//       if (cat.genderHandles && cat.genderHandles[location.activeGender]) {
//         casualColl = cat.genderHandles[location.activeGender];
//       } else {
//         casualColl = cat.handle || location.categoryHandle;
//       }

//       // Detect active brand tag
//       var casActiveBrand = null;
//       try {
//         var casParams = new URLSearchParams(window.location.search);
//         var casUrlTags = casParams.getAll('filter.p.tag');
//         for (var cbi = 0; cbi < cat.brands.length; cbi++) {
//           if (casUrlTags.indexOf(cat.brands[cbi].tag) !== -1) { casActiveBrand = cat.brands[cbi].tag; break; }
//         }
//       } catch (e) {}

//       // Build pills: "All" + each brand (preserving season + type-if-still-valid)
//       var casBrandItems = [{
//         handle: '__all_brands__',
//         title: 'All',
//         isActive: !casActiveBrand,
//         url: buildUrl(casualColl, location.activeGender, location.activeType, null, location.activeSeason),
//         style: 'compact'
//       }];
//       cat.brands.forEach(function(b) {
//         casBrandItems.push({
//           handle: b.tag,
//           title: b.title,
//           logo: b.logo,
//           isActive: casActiveBrand === b.tag,
//           url: buildUrl(casualColl, location.activeGender, location.activeType, b.tag, location.activeSeason),
//           style: b.logo ? 'with-icon' : 'compact'
//         });
//       });
//       paintCarousel(carousel, casBrandItems);
//       row.style.display = '';
//       return;
//     }

//     if (!cat || !cat.leagues) { row.style.display = 'none'; return; }

//     // Set row label dynamically (F1 uses "BRAND" instead of "LEAGUE")
//     var label = row.querySelector('.sf-row-label');
//     if (label) label.textContent = cat.rowLabel || 'League';

//     var leagueHandles = Object.keys(cat.leagues);

//     // Special: F1 has one synthetic league ('f1') — hide the league row and
//     // show only the brands as the primary carousel (in the teams row).
//     // This avoids showing a single lonely "F1 Brands" pill.
//     if (leagueHandles.length === 1 && cat.f1 !== false) {
//       var onlyLeague = cat.leagues[leagueHandles[0]];
//       if (onlyLeague && onlyLeague.teams && Object.keys(onlyLeague.teams).length > 1) {
//         row.style.display = 'none';
//         return;
//       }
//     }

//     var items = leagueHandles.map(function(h) {
//       var lg = cat.leagues[h];
//       var collectionHandle;

//       // GYM: leagues have per-gender handles — pick the one matching active gender
//       if (lg.genderHandles) {
//         collectionHandle = lg.genderHandles[location.activeGender] || lg.genderHandles.men || h;
//       } else if (Array.isArray(lg.handle)) {
//         collectionHandle = lg.handle[0];
//       } else {
//         collectionHandle = lg.handle || h;
//       }

//       // For gym, detect active brand tag to preserve when switching type
//       var preservedBrand = null;
//       var preservedSeason = null;
//       if (cat.brands || cat.seasons) {
//         try {
//           var params = new URLSearchParams(window.location.search);
//           var urlTags = params.getAll('filter.p.tag');
//           if (cat.brands) {
//             for (var bi = 0; bi < cat.brands.length; bi++) {
//               if (urlTags.indexOf(cat.brands[bi].tag) !== -1) { preservedBrand = cat.brands[bi].tag; break; }
//             }
//           }
//           if (cat.seasons) {
//             for (var si = 0; si < cat.seasons.length; si++) {
//               if (urlTags.indexOf(cat.seasons[si].tag) !== -1) { preservedSeason = cat.seasons[si].tag; break; }
//             }
//           }
//         } catch (e) {}
//       }

//       return {
//         handle: h,
//         title: lg.title,
//         logo: lg.logo,
//         isActive: h === location.leagueHandle && !location.teamHandle,
//         url: buildUrl(collectionHandle, location.activeGender, null, preservedBrand, preservedSeason),
//         style: lg.logo ? 'with-icon' : 'compact'
//       };
//     });
//     paintCarousel(carousel, items);
//     row.style.display = '';
//   }

//   function renderTeams(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="teams"]');
//     var carousel = wrapper.querySelector('[data-carousel="teams"]');
//     if (!row || !carousel) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // GYM MODE: if the category has `brands` and a league is picked,
//     // render brand tag filters (Nike, Adidas) instead of teams
//     if (cat && cat.brands && cat.brands.length && location.leagueHandle) {
//       var league = cat.leagues[location.leagueHandle];
//       // Determine the current gym collection (gender-specific)
//       var currentColl;
//       if (league.genderHandles) {
//         currentColl = league.genderHandles[location.activeGender] || league.genderHandles.men;
//       } else {
//         currentColl = location.leagueHandle;
//       }

//       // Set row label (BRAND)
//       var lbl = row.querySelector('.sf-row-label');
//       if (lbl) lbl.textContent = cat.teamRowLabel || 'Brand';

//       // Detect which brand tag is currently active
//       var activeBrand = null;
//       try {
//         var params = new URLSearchParams(window.location.search);
//         var urlTags = params.getAll('filter.p.tag');
//         for (var i = 0; i < cat.brands.length; i++) {
//           for (var j = 0; j < urlTags.length; j++) {
//             if (urlTags[j] === cat.brands[i].tag) { activeBrand = cat.brands[i].tag; break; }
//           }
//           if (activeBrand) break;
//         }
//       } catch (e) {}

//       // Make row label clickable if a brand is active (jumps to /collections/nike, etc.)
//       // Find the brand's display name (title) for the button label
//       var brandDisplayName = null;
//       if (activeBrand) {
//         for (var bri = 0; bri < cat.brands.length; bri++) {
//           if (cat.brands[bri].tag === activeBrand) {
//             brandDisplayName = cat.brands[bri].title || activeBrand;
//             break;
//           }
//         }
//       }
//       applyLabelClick(
//         row,
//         getLabelClickUrl(cat, 'teams', location, activeBrand, brandDisplayName),
//         cat.teamRowLabel || 'Brand'
//       );
//       // Build pills: "All" + each brand — preserving active season if set
//       var brandItems = [{
//         handle: '__all_brands__',
//         title: 'All',
//         isActive: !activeBrand,
//         url: buildUrl(currentColl, location.activeGender, null, null, location.activeSeason),
//         style: 'type'
//       }];
//       cat.brands.forEach(function(b) {
//         brandItems.push({
//           handle: b.tag,
//           title: b.title,
//           logo: b.logo,
//           isActive: activeBrand === b.tag,
//           url: buildUrl(currentColl, location.activeGender, null, b.tag, location.activeSeason),
//           style: b.logo ? 'with-icon' : 'type'
//         });
//       });
//       paintCarousel(carousel, brandItems);
//       row.style.display = '';
//       return;
//     }

//     // If the category suppresses the team level entirely, hide the row.
//     if (isTeamLevelSuppressed(cat)) { row.style.display = 'none'; return; }

//     // For F1 (single synthetic league), always show the brands row even
//     // when no league is explicitly picked — it IS the primary filter dimension.
//     var leagueForTeams = null;
//     if (location.leagueHandle) {
//       leagueForTeams = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     } else if (cat && cat.leagues) {
//       var leagueKeys = Object.keys(cat.leagues);
//       if (leagueKeys.length === 1) {
//         leagueForTeams = cat.leagues[leagueKeys[0]];
//         location.leagueHandle = leagueKeys[0]; // implicitly select the sole league
//       }
//     }

//     if (!leagueForTeams || !leagueForTeams.teams || !Object.keys(leagueForTeams.teams).length) {
//       row.style.display = 'none';
//       return;
//     }

//     // Set row label dynamically (F1 uses "BRAND" instead of "TEAM")
//     var label = row.querySelector('.sf-row-label');
//     if (label) {
//       if (cat.teamRowLabel) label.textContent = cat.teamRowLabel;
//       else if (cat.rowLabel === 'BRAND') label.textContent = 'Brand';
//       else label.textContent = 'Team';
//     }

//     var items = Object.keys(leagueForTeams.teams).map(function(h) {
//       var t = leagueForTeams.teams[h];
//       var isThisTeam = h === location.teamHandle;
//       var isActive = isThisTeam && !location.activeType;
//       var url;
//       // Tag-based team (International Kits countries)
//       if (t.tag && leagueForTeams.handle) {
//         url = buildUrl(leagueHandleStr(leagueForTeams), location.activeGender, null, t.tag);
//       } else {
//         // Handle-based team (Arsenal, f1-ferrari, etc.)
//         url = buildUrl(h, location.activeGender, null);
//       }
//       return {
//         handle: h,
//         title: t.title,
//         logo: t.logo,
//         isActive: isActive,
//         isCurrent: isThisTeam,
//         url: url,
//         style: 'with-icon'
//       };
//     });
//     paintCarousel(carousel, items);
//     row.style.display = '';
//   }

//   function renderTypes(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="types"]');
//     var carousel = wrapper.querySelector('[data-carousel="types"]');
//     if (!row || !carousel) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // CASUAL MODE: Season-conditional types (guided flow).
//     // Only show Type row when a season is picked.
//     if (cat && cat.typesBySeason) {
//       if (!location.activeSeason) { row.style.display = 'none'; return; }
//       var casualTypes = getProductTypes(cat, location.activeSeason);
//       if (!casualTypes.length) { row.style.display = 'none'; return; }

//       // Set row label
//       var casualLbl = row.querySelector('.sf-row-label');
//       if (casualLbl) casualLbl.textContent = 'Type';

//       // Determine current collection (gender-specific parent for casual)
//       var casualColl;
//       if (cat.genderHandles && cat.genderHandles[location.activeGender]) {
//         casualColl = cat.genderHandles[location.activeGender];
//       } else {
//         casualColl = cat.handle || location.categoryHandle;
//       }

//       // Detect active brand tag (to preserve when switching type)
//       var casualBrand = null;
//       if (cat.brands) {
//         try {
//           var params = new URLSearchParams(window.location.search);
//           var urlTags = params.getAll('filter.p.tag');
//           for (var bi = 0; bi < cat.brands.length; bi++) {
//             if (urlTags.indexOf(cat.brands[bi].tag) !== -1) { casualBrand = cat.brands[bi].tag; break; }
//           }
//         } catch (e) {}
//       }

//       // Build pills: "All" + each season-specific type (preserving brand + season)
//       var casualItems = [{
//         handle: '__all_types__',
//         title: 'All',
//         isActive: !location.activeType,
//         url: buildUrl(casualColl, location.activeGender, null, casualBrand, location.activeSeason),
//         style: 'type'
//       }];
//       casualTypes.forEach(function(t) {
//         casualItems.push({
//           handle: t.tag,
//           title: t.title,
//           tag: t.tag,
//           isActive: location.activeType === t.tag,
//           url: buildUrl(casualColl, location.activeGender, t.tag, casualBrand, location.activeSeason),
//           style: 'type'
//         });
//       });
//       paintCarousel(carousel, casualItems);
//       // Clickable label: for casual with parent-plus-tag pattern, jumps to catch-all filtered by type
//       var casualTypeName = null;
//       if (location.activeType) {
//         for (var cti = 0; cti < casualTypes.length; cti++) {
//           if (casualTypes[cti].tag === location.activeType) {
//             casualTypeName = casualTypes[cti].title || location.activeType;
//             break;
//           }
//         }
//       }
//       applyLabelClick(
//         row,
//         getLabelClickUrl(cat, 'types', location, location.activeType, casualTypeName),
//         'Type'
//       );
//       row.style.display = '';
//       return;
//     }

//     // Standard mode (Football/F1): types show under a team
//     var types = getProductTypes(cat, location.activeSeason);
//     if (!types.length) { row.style.display = 'none'; return; }

//     // Only show types when a team (leaf) is selected
//     if (!location.teamHandle) { row.style.display = 'none'; return; }

//     var league = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     var team = league && league.teams && league.teams[location.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;
//     var teamCollectionHandle = isTagBasedTeam ? leagueHandleStr(league) : location.teamHandle;
//     var teamTag = isTagBasedTeam ? team.tag : null;

//     var items = [{
//       handle: location.teamHandle,
//       title: 'All',
//       isActive: !location.activeType,
//       url: buildUrl(teamCollectionHandle, location.activeGender, null, teamTag),
//       style: 'type'
//     }];
//     types.forEach(function(t) {
//       items.push({
//         handle: location.teamHandle,
//         title: t.title,
//         tag: t.tag,
//         isActive: location.activeType === t.tag,
//         url: buildUrl(teamCollectionHandle, location.activeGender, t.tag, teamTag),
//         style: 'type'
//       });
//     });
//     paintCarousel(carousel, items);
//     // Clickable KIT label: on F1, jumps to /collections/f1?filter.p.tag=<type>
//     // Find the type's display name for the button
//     var typeDisplayName = null;
//     if (location.activeType) {
//       for (var tdi = 0; tdi < types.length; tdi++) {
//         if (types[tdi].tag === location.activeType) {
//           typeDisplayName = types[tdi].title || location.activeType;
//           break;
//         }
//       }
//     }
//     applyLabelClick(
//       row,
//       getLabelClickUrl(cat, 'types', location, location.activeType, typeDisplayName),
//       'Kit'
//     );
//     row.style.display = '';
//   }

//   // Renders the SEASON row (Gym only). Season is a TAG filter that can be
//   // combined with any other active filter (Type, Brand, Gender).
//   function renderSeasons(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="seasons"]');
//     var carousel = wrapper.querySelector('[data-carousel="seasons"]');
//     if (!row || !carousel) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];
//     if (!cat || !cat.seasons || !cat.seasons.length) { row.style.display = 'none'; return; }

//     // Set row label
//     var lbl = row.querySelector('.sf-row-label');
//     if (lbl) lbl.textContent = 'Season';

//     // Determine current collection (gender-specific for gym at league level, casual at category level)
//     var currentColl;
//     if (location.leagueHandle && cat.leagues && cat.leagues[location.leagueHandle] && cat.leagues[location.leagueHandle].genderHandles) {
//       // Gym: league-level gender handles
//       var gh = cat.leagues[location.leagueHandle].genderHandles;
//       currentColl = gh[location.activeGender] || gh.men;
//     } else if (cat.genderHandles) {
//       // Casual: category-level gender handles
//       currentColl = cat.genderHandles[location.activeGender] || cat.handle || location.categoryHandle;
//     } else {
//       currentColl = cat.handle || location.categoryHandle;
//     }

//     // Determine active brand tag (to preserve when switching season)
//     var activeBrandTag = null;
//     if (cat.brands) {
//       try {
//         var params = new URLSearchParams(window.location.search);
//         var urlTags = params.getAll('filter.p.tag');
//         for (var i = 0; i < cat.brands.length; i++) {
//           for (var j = 0; j < urlTags.length; j++) {
//             if (urlTags[j] === cat.brands[i].tag) { activeBrandTag = cat.brands[i].tag; break; }
//           }
//           if (activeBrandTag) break;
//         }
//       } catch (e) {}
//     }

//     // Helper: given a target season, check if the currently active type is still valid.
//     // For Casual (typesBySeason), a type only belongs to one season, so switching season
//     // must drop the type unless it exists in the target season's type list.
//     function typeStillValid(targetSeasonTag) {
//       if (!location.activeType) return null;
//       if (!cat.typesBySeason) return location.activeType; // non-casual: type always compatible
//       if (!targetSeasonTag) return null; // moving to "All" seasons — drop type (guided flow needs season)
//       var targetTypes = cat.typesBySeason[targetSeasonTag] || [];
//       for (var ti = 0; ti < targetTypes.length; ti++) {
//         if (targetTypes[ti].tag === location.activeType) return location.activeType;
//       }
//       return null; // type doesn't exist in target season → drop it
//     }

//     // Build pills: "All" + each season
//     // Note: brand tag goes in teamTag slot, season goes in extraTag slot
//     // For casual, we ALSO preserve type IF compatible with the target season.
//     var seasonItems = [{
//       handle: '__all_seasons__',
//       title: 'All',
//       isActive: !location.activeSeason,
//       url: buildUrl(currentColl, location.activeGender, typeStillValid(null), activeBrandTag, null),
//       style: 'type'
//     }];
//     cat.seasons.forEach(function(s) {
//       var title = s.emoji ? (s.emoji + ' ' + s.title) : s.title;
//       seasonItems.push({
//         handle: s.tag,
//         title: title,
//         isActive: location.activeSeason === s.tag,
//         url: buildUrl(currentColl, location.activeGender, typeStillValid(s.tag), activeBrandTag, s.tag),
//         style: 'type'
//       });
//     });
//     paintCarousel(carousel, seasonItems);
//     row.style.display = '';
//   }

//   function renderBreadcrumb(wrapper, location) {
//     var el = wrapper.querySelector('.sf-breadcrumb');
//     if (!el) return;

//     // On gender landings, breadcrumb is just the gender label (e.g., "Women")
//     if (location.isGenderLanding) {
//       var labels = { women: 'Women', men: 'Men', kids: 'Kids' };
//       var text = labels[location.landingGender] || location.landingGender;
//       el.innerHTML = '<a class="sf-crumb is-current" href="/collections/' + location.landingGender + '">' + escapeHtml(text) + '</a>';
//       return;
//     }

//     var parts = [];
//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];
//     var league = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     var team = league && league.teams && league.teams[location.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;

//     // 1) Gender — use per-category label if defined, else fall back to defaults
//     var currentColl;
//     var teamTag = null;
//     if (location.teamHandle) {
//       if (isTagBasedTeam) { currentColl = leagueHandleStr(league); teamTag = team.tag; }
//       else { currentColl = location.teamHandle; }
//     } else if (location.leagueHandle) {
//       currentColl = leagueHandleStr(league) || location.leagueHandle;
//     } else {
//       currentColl = cat.handle || location.categoryHandle;
//     }

//     // Only include the Gender crumb if the category has gender tabs
//     if (!(cat && cat.hideGenderTabs)) {
//       // Resolve display label for this gender
//       var genderLabel;
//       if (cat && cat.genderTabs && cat.genderTabs[location.activeGender] && cat.genderTabs[location.activeGender].label) {
//         genderLabel = cat.genderTabs[location.activeGender].label;
//       } else if (location.activeGender === 'women') {
//         genderLabel = 'Women';
//       } else if (location.activeGender === 'kids') {
//         genderLabel = 'Kids';
//       } else {
//         genderLabel = 'Men';
//       }
//       parts.push({
//         text: genderLabel,
//         url: buildUrl(currentColl, location.activeGender, location.activeType, teamTag)
//       });
//     }

//     // 2) Category
//     if (cat) parts.push({
//       text: cat.title,
//       url: buildUrl(cat.handle || location.categoryHandle, location.activeGender, null)
//     });

//     // 3) League (skip for F1's synthetic single league — redundant with category)
//     var categoryLeagueKeys = cat && cat.leagues ? Object.keys(cat.leagues) : [];
//     var isSyntheticSingleLeague = categoryLeagueKeys.length === 1;

//     if (location.leagueHandle && league && !isSyntheticSingleLeague) {
//       var lgHandle = leagueHandleStr(league) || location.leagueHandle;
//       parts.push({
//         text: league.title,
//         url: buildUrl(lgHandle, location.activeGender, null)
//       });
//     }

//     // 4) Team
//     if (location.teamHandle && team) {
//       var teamUrl;
//       if (isTagBasedTeam) {
//         teamUrl = buildUrl(leagueHandleStr(league), location.activeGender, null, team.tag);
//       } else {
//         teamUrl = buildUrl(location.teamHandle, location.activeGender, null);
//       }
//       parts.push({ text: team.title, url: teamUrl });
//     }

//     // 5) Product type
//     if (location.activeType) {
//       var types = getProductTypes(cat, location.activeSeason);
//       var match = types.filter(function(p) { return p.tag === location.activeType; })[0];
//       if (match) {
//         var typeUrl;
//         if (isTagBasedTeam) {
//           typeUrl = buildUrl(leagueHandleStr(league), location.activeGender, match.tag, team.tag);
//         } else if (location.teamHandle) {
//           typeUrl = buildUrl(location.teamHandle, location.activeGender, match.tag);
//         } else {
//           typeUrl = buildUrl(cat.handle || location.categoryHandle, location.activeGender, match.tag);
//         }
//         parts.push({ text: match.title, url: typeUrl });
//       }
//     }

//     el.innerHTML = parts.map(function(p, i) {
//       var isLast = i === parts.length - 1;
//       var sep = i > 0 ? '<span class="sf-crumb-sep"> › </span>' : '';
//       return sep + '<a class="sf-crumb' + (isLast ? ' is-current' : '') + '" href="' + p.url + '">' + escapeHtml(p.text) + '</a>';
//     }).join('');
//   }

//   // ============ PAINT & UTILITIES ============

//   function paintCarousel(carousel, items) {
//     carousel.innerHTML = '';
//     items.forEach(function(item) {
//       var link = document.createElement('a');
//       var cls = 'sf-item';
//       if (item.isActive) cls += ' is-active';
//       else if (item.isCurrent) cls += ' is-current';
//       if (item.style === 'with-icon') {
//         cls += ' sf-with-icon';
//       } else if (item.style === 'type') {
//         cls += ' sf-type';
//       } else {
//         cls += ' sf-compact';
//       }
//       link.className = cls;
//       link.href = item.url;
//       link.setAttribute('data-handle', item.handle);
//       if (item.style === 'with-icon') {
//         var logoHtml = item.logo
//           ? '<img class="sf-item-logo-img" src="' + item.logo + '" alt="' + escapeHtml(item.title) + '" loading="lazy" onerror="this.style.display=\'none\'">'
//           : '<span class="sf-item-logo-fallback">' + escapeHtml(item.title.charAt(0)) + '</span>';
//         link.innerHTML =
//           '<div class="sf-item-logo">' + logoHtml + '</div>' +
//           '<div class="sf-item-title">' + escapeHtml(item.title) + '</div>';
//       } else {
//         link.innerHTML = escapeHtml(item.title);
//       }
//       attachClickFeedback(link, item.isActive);
//       carousel.appendChild(link);
//     });
//   }

//   function setupArrows(carousel) {
//     var container = carousel.closest('.sf-carousel-container');
//     if (!container) return;
//     var prev = container.querySelector('.sf-arrow-prev');
//     var next = container.querySelector('.sf-arrow-next');
//     if (!prev || !next) return;
//     function scroll(delta) { carousel.scrollBy({ left: delta, behavior: 'smooth' }); }
//     prev.onclick = function() { scroll(-260); };
//     next.onclick = function() { scroll(260); };
//     function checkOverflow() {
//       var hasOverflow = carousel.scrollWidth > carousel.clientWidth + 4;
//       container.classList.toggle('has-overflow', hasOverflow);
//     }
//     checkOverflow();
//     window.addEventListener('resize', checkOverflow);
//   }

//   function attachClickFeedback(link, alreadyActive) {
//   if (alreadyActive) {
//       link.addEventListener('click', function(e) { e.preventDefault(); });
//       return;
//     }
//     link.addEventListener('click', function() { link.classList.add('is-loading'); });
//   }

//   function scrollIntoView(el) {
//     try { el.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); }
//     catch (e) {}
//   }

//   function escapeHtml(s) {
//     return String(s).replace(/[&<>"']/g, function(c) {
//       return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
//     });
//   }
// })();

// ----------------------------------------------------------------------------------------------------
// // shirts-carousel-filter.js
// // Football Shirts filter — Category → League → Team → Product Type
// // Auto-detects if the current collection is in the hierarchy; hides otherwise.

// (function() {
//   'use strict';

//   if (!window.ShirtsHierarchy) return;

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   var currentLocation = null;

//   function init() {
//     var wrapper = document.querySelector('.sf-nav-wrapper');
//     if (!wrapper) return;

//     var currentHandle = wrapper.dataset.currentHandle;
//     if (!currentHandle) return;

//     var location = findInHierarchy(currentHandle);
//     if (!location) {
//       // Not a shirt collection — hide the shirt filter card but keep the
//       // catalog switcher visible so customers can navigate away.
//       // If the SHOE filter is active, hide our catalog switcher to avoid duplication.
//       var shoeWrapper = document.querySelector('.hcf-nav-wrapper');
//       var shoeIsActive = shoeWrapper && shoeWrapper.querySelector('.hcf-item') !== null;

//       var inner = wrapper.querySelector('.sf-nav-inner');
//       if (inner) {
//         Array.prototype.forEach.call(inner.children, function(child) {
//           if (!child.classList || !child.classList.contains('cs-catalog-tabs')) {
//             child.style.display = 'none';
//           }
//         });
//         if (shoeIsActive) {
//           var shirtTabs = inner.querySelector('.cs-catalog-tabs');
//           if (shirtTabs) shirtTabs.style.display = 'none';
//           wrapper.style.display = 'none';
//         }
//       }
//       var stickyBar = document.getElementById('sf-sticky-bar');
//       if (stickyBar) stickyBar.remove();
//       var fab = document.getElementById('sf-fab');
//       if (fab) fab.remove();
//       var expandedOverlay = document.getElementById('sf-expanded-overlay');
//       if (expandedOverlay) expandedOverlay.remove();
//       return;
//     }

//     location.activeGender = detectGenderFromUrl();
//     location.activeType   = detectTypeTagFromUrl(location);
//     location.activeSeason = detectSeasonFromUrl(location);

//     currentLocation = location;

//     renderGenderTabs(wrapper, location);
//     renderCategories(wrapper, location);
//     renderLeagues(wrapper, location);
//     renderTeams(wrapper, location);
//     renderTypes(wrapper, location);
//     renderSeasons(wrapper, location);
//     renderBreadcrumb(wrapper, location);

//     // Add helper class if the deep rows (teams + types) are both hidden
//     var teamsRow = wrapper.querySelector('[data-level="teams"]');
//     var typesRow = wrapper.querySelector('[data-level="types"]');
//     var teamsHidden = !teamsRow || teamsRow.style.display === 'none';
//     var typesHidden = !typesRow || typesRow.style.display === 'none';
//     wrapper.classList.toggle('sf-leagues-only', teamsHidden && typesHidden);

//     wrapper.querySelectorAll('.sf-carousel').forEach(setupArrows);
//     setTimeout(function() {
//       wrapper.querySelectorAll('.sf-item.is-active').forEach(scrollIntoView);
//     }, 100);

//     setupScrollHints(wrapper);
//     setupStickyBar(wrapper, location);
//     setupExpandedOverlay(wrapper);
//     setupFAB(wrapper);
//   }

//   // ============ HELPERS ============

//   // Unwrap league.handle if it's a string OR array of aliases (returns first alias or null)
//   function leagueHandleStr(league) {
//     if (!league) return null;
//     if (Array.isArray(league.handle)) return league.handle[0];
//     return league.handle || null;
//   }

//   // Get the productTypes list for a given category.
//   //   - Football/F1: fixed list from cat.productTypes or global fallback
//   //   - Casual: season-conditional — pass activeSeason as 2nd arg
//   //     Returns [] if season required but not set (guided flow — Type row hidden)
//   function getProductTypes(cat, activeSeason) {
//     if (cat && cat.typesBySeason) {
//       if (!activeSeason) return [];
//       return cat.typesBySeason[activeSeason] || [];
//     }
//     // Explicit empty array means "this category has no product types" — respect it.
//     // Only fall through to global if productTypes is completely undefined.
//     if (cat && Array.isArray(cat.productTypes)) return cat.productTypes;
//     return window.ShirtsHierarchy.productTypes || [];
//   }

//   // Is this category's team level suppressed (e.g., F1 has no sub-teams)?
//   function isTeamLevelSuppressed(cat) {
//     return cat && cat.teamRowLabel === null;
//   }

//   // Returns { url, buttonText } for a clickable row label, or null if not applicable.
//   //
//   //   cat         — active category object
//   //   rowLevel    — 'leagues' | 'teams' | 'types'
//   //   location    — current location object
//   //   activeTag   — the currently active tag in this row (or null)
//   //   displayName — the display title matching activeTag (e.g., "Cap" for tag "F1 caps");
//   //                 falls back to activeTag if not provided
//   function getLabelClickUrl(cat, rowLevel, location, activeTag, displayName) {
//     if (!cat || !cat.labelClicks) return null;
//     var cfg = cat.labelClicks[rowLevel];
//     if (!cfg || !activeTag) return null;

//     var url = null;
//     if (cfg.pattern === 'brand-collection') {
//       // Lowercase-hyphenate the tag to produce a collection handle
//       // (e.g., "Nike" → "nike", "Tommy Hilfiger" → "tommy-hilfiger")
//       var handle = activeTag.toLowerCase().replace(/\s+/g, '-');
//       url = '/collections/' + handle;
//     } else if (cfg.pattern === 'handle-map' && cfg.handleMap && cfg.handleMap[activeTag]) {
//       url = '/collections/' + cfg.handleMap[activeTag];
//     } else if (cfg.pattern === 'parent-plus-tag') {
//       var parent = cat.handle || location.categoryHandle;
//       url = '/collections/' + parent + '?filter.p.tag=' + encodeURIComponent(activeTag);
//     }

//     if (!url) return null;

//     // Build button text from format template
//     var name = displayName || activeTag;
//     var format = cfg.buttonTextFormat || 'Shop {name}';
//     var buttonText = format.replace('{name}', name);

//     return { url: url, buttonText: buttonText };
//   }

//   // Apply the "shop X" button to a row label. If clickInfo is null, resets
//   // the label to plain text (defaultLabel).
//   //
//   //   clickInfo   — { url, buttonText } from getLabelClickUrl, or null
//   //   defaultLabel — the plain text to show when no filter is active
//   function applyLabelClick(row, clickInfo, defaultLabel) {
//     var label = row.querySelector('.sf-row-label');
//     if (!label) return;

//     if (clickInfo && clickInfo.url) {
//       // Render as burgundy pill button — impossible to miss
//       label.innerHTML = '';
//       var btn = document.createElement('a');
//       btn.className = 'sf-label-btn';
//       btn.href = clickInfo.url;
//       btn.textContent = clickInfo.buttonText;
//       btn.setAttribute('aria-label', clickInfo.buttonText);
//       label.appendChild(btn);
//       label.classList.add('sf-label-has-btn');
//     } else {
//       // Plain text label (no active filter)
//       label.textContent = defaultLabel;
//       label.classList.remove('sf-label-has-btn');
//     }
//   }

//   // ============ MOBILE SCROLL HINTS (COMBO: fade + peek + delayed arrow) ============
//   function setupScrollHints(wrapper) {
//     if (window.matchMedia && !window.matchMedia('(max-width: 768px)').matches) return;

//     setTimeout(function() {
//       var rows = wrapper.querySelectorAll('.sf-row-content');
//       var anyOverflowed = false;
//       var alreadyPeeked = false;
//       try { alreadyPeeked = sessionStorage.getItem('sf_peek_played') === '1'; } catch (e) {}

//       rows.forEach(function(rowContent) {
//         var carousel = rowContent.querySelector('.sf-carousel');
//         if (!carousel) return;

//         var overflows = carousel.scrollWidth > carousel.clientWidth + 4;
//         if (!overflows) return;

//         anyOverflowed = true;
//         rowContent.classList.add('sf-has-overflow');

//         if (!rowContent.querySelector('.sf-scroll-arrow')) {
//           var arrow = document.createElement('div');
//           arrow.className = 'sf-scroll-arrow';
//           arrow.innerHTML = '<svg width="14" height="14" viewBox="0 0 20 20" fill="none"><path d="M8 4L14 10L8 16" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
//           rowContent.appendChild(arrow);
//         }

//         if (!alreadyPeeked) {
//           carousel.classList.add('sf-peek');
//           setTimeout(function() { carousel.classList.remove('sf-peek'); }, 3000);
//         }

//         var arrowTimer = setTimeout(function() {
//           if (!rowContent.classList.contains('sf-scrolled')) {
//             rowContent.classList.add('sf-show-arrow');
//             setTimeout(function() {
//               rowContent.classList.remove('sf-show-arrow');
//             }, 6000);
//           }
//         }, 2000);

//         var onScroll = function() {
//           rowContent.classList.add('sf-scrolled');
//           rowContent.classList.remove('sf-show-arrow');
//           clearTimeout(arrowTimer);
//           if (carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4) {
//             rowContent.classList.remove('sf-has-overflow');
//           }
//           carousel.removeEventListener('scroll', onScroll);
//           carousel.addEventListener('scroll', function() {
//             var atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4;
//             rowContent.classList.toggle('sf-has-overflow', !atEnd);
//           }, { passive: true });
//         };
//         carousel.addEventListener('scroll', onScroll, { passive: true });
//       });

//       if (anyOverflowed && !alreadyPeeked) {
//         try { sessionStorage.setItem('sf_peek_played', '1'); } catch (e) {}
//       }
//     }, 250);
//   }

//   // ============ STICKY BAR / EXPANDED OVERLAY / FAB ============

//   function setupStickyBar(wrapper, location) {
//     var stickyBar = document.getElementById('sf-sticky-bar');
//     var stickyPath = document.getElementById('sf-sticky-path');
//     var stickyBack = document.getElementById('sf-sticky-back');
//     var stickyScrollTop = document.getElementById('sf-sticky-scroll-top');
//     if (!stickyBar || !wrapper) return;

//     var pathTextEl = stickyBar.querySelector('.sf-sticky-path-text');
//     if (pathTextEl) pathTextEl.textContent = buildStickyPathText(location);

//     var backTarget = getBackTarget(location);
//     if (backTarget) {
//       stickyBack.disabled = false;
//       stickyBack.onclick = function() { window.location.href = backTarget; };
//     } else {
//       stickyBack.disabled = true;
//     }

//     if (stickyScrollTop) {
//       stickyScrollTop.onclick = function() {
//         wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
//       };
//     }

//     if (stickyPath) stickyPath.onclick = openExpandedOverlay;

//     var ticking = false;
//     function updateVisibility() {
//       var wrapperBottom = wrapper.getBoundingClientRect().bottom;
//       if (wrapperBottom < 0) {
//         stickyBar.classList.add('is-visible');
//         stickyBar.setAttribute('aria-hidden', 'false');
//       } else {
//         stickyBar.classList.remove('is-visible');
//         stickyBar.setAttribute('aria-hidden', 'true');
//       }
//       ticking = false;
//     }
//     window.addEventListener('scroll', function() {
//       if (!ticking) {
//         window.requestAnimationFrame(updateVisibility);
//         ticking = true;
//       }
//     }, { passive: true });
//     updateVisibility();
//   }

//   function buildStickyPathText(loc) {
//     if (!loc) return 'All Jerseys';
//     var parts = [];
//     var cat = window.ShirtsHierarchy.categories[loc.categoryHandle];

//     // Gender label: only show if category has gender tabs; support Men/Women/Kids
//     if (!(cat && cat.hideGenderTabs)) {
//       var genderLabel;
//       if (cat && cat.genderTabs && cat.genderTabs[loc.activeGender] && cat.genderTabs[loc.activeGender].label) {
//         genderLabel = cat.genderTabs[loc.activeGender].label;
//       } else if (loc.activeGender === 'women') {
//         genderLabel = 'Women';
//       } else if (loc.activeGender === 'kids') {
//         genderLabel = 'Kids';
//       } else {
//         genderLabel = 'Men';
//       }
//       parts.push(genderLabel);
//     }

//     if (cat) parts.push(cat.title);
//     if (loc.leagueHandle) {
//       var lg = cat && cat.leagues && cat.leagues[loc.leagueHandle];
//       // For F1's synthetic 'f1' league, don't add "F1 Brands" — redundant with category
//       if (lg && loc.leagueHandle !== 'f1') parts.push(lg.title);
//     }
//     if (loc.teamHandle) {
//       var lg2 = cat && cat.leagues && cat.leagues[loc.leagueHandle];
//       var t = lg2 && lg2.teams && lg2.teams[loc.teamHandle];
//       if (t) parts.push(t.title);
//     }
//     if (loc.activeType) {
//       var types = getProductTypes(cat, loc.activeSeason);
//       var match = types.filter(function(p) { return p.tag === loc.activeType; })[0];
//       if (match) parts.push(match.title);
//     }
//     return parts.join(' › ');
//   }

//   function getBackTarget(loc) {
//     if (!loc) return null;
//     var cat = window.ShirtsHierarchy.categories[loc.categoryHandle];
//     var league = cat && cat.leagues && cat.leagues[loc.leagueHandle];
//     var team = league && league.teams && league.teams[loc.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;

//     // Type filter active → clear type
//     if (loc.activeType && loc.teamHandle) {
//       if (isTagBasedTeam) {
//         return buildUrl(leagueHandleStr(league), loc.activeGender, null, team.tag);
//       }
//       return buildUrl(loc.teamHandle, loc.activeGender, null);
//     }
//     // Team active → go up to league
//     if (loc.teamHandle && loc.leagueHandle) {
//       if (isTagBasedTeam) {
//         return buildUrl(leagueHandleStr(league), loc.activeGender, null);
//       }
//       return buildUrl(loc.leagueHandle, loc.activeGender, null);
//     }
//     // League active → go up to category
//     if (loc.leagueHandle && loc.categoryHandle) {
//       return buildUrl(loc.categoryHandle, loc.activeGender, null);
//     }
//     return null;
//   }

//   function setupExpandedOverlay(wrapper) {
//     var overlay = document.getElementById('sf-expanded-overlay');
//     if (!overlay) return;
//     var backdrop = overlay.querySelector('.sf-expanded-backdrop');
//     var closeBtn = document.getElementById('sf-expanded-close');
//     if (closeBtn) closeBtn.onclick = closeExpandedOverlay;
//     if (backdrop) backdrop.onclick = closeExpandedOverlay;
//     document.addEventListener('keydown', function(e) {
//       if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
//         closeExpandedOverlay();
//       }
//     });
//   }

//   function openExpandedOverlay() {
//     var overlay = document.getElementById('sf-expanded-overlay');
//     var content = document.getElementById('sf-expanded-content');
//     var wrapper = document.querySelector('.sf-nav-wrapper');
//     if (!overlay || !content || !wrapper) return;

//     content.innerHTML = '';
//     wrapper.querySelectorAll('.sf-row').forEach(function(row) {
//       if (row.style.display === 'none') return;
//       var clone = row.cloneNode(true);
//       content.appendChild(clone);
//     });

//     overlay.classList.add('is-open');
//     overlay.setAttribute('aria-hidden', 'false');
//     document.body.style.overflow = 'hidden';
//   }

//   function closeExpandedOverlay() {
//     var overlay = document.getElementById('sf-expanded-overlay');
//     if (!overlay) return;
//     overlay.classList.remove('is-open');
//     overlay.setAttribute('aria-hidden', 'true');
//     document.body.style.overflow = '';
//   }

//   function setupFAB(wrapper) {
//     var fab = document.getElementById('sf-fab');
//     if (!fab || !wrapper) return;
//     fab.onclick = function() {
//       wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     };
//     var ticking = false;
//     function update() {
//       var wrapperBottom = wrapper.getBoundingClientRect().bottom;
//       if (wrapperBottom < -300) fab.classList.add('is-visible');
//       else fab.classList.remove('is-visible');
//       ticking = false;
//     }
//     window.addEventListener('scroll', function() {
//       if (!ticking) {
//         window.requestAnimationFrame(update);
//         ticking = true;
//       }
//     }, { passive: true });
//     update();
//   }

//   // ============ LOCATION DETECTION ============

//   function findInHierarchy(handle) {
//     // Special case: kids-t-shirt is the Kids gender landing page.
//     if (handle === 'kids-t-shirt') {
//       return { categoryHandle: 'football-jerseys', leagueHandle: null, teamHandle: null, level: 'category' };
//     }

//     // CATEGORY-LEVEL GENDER HANDLES (Casual):
//     // Check for category-level gender handles (e.g., men-casual-out-fit → casual-shirts)
//     for (var cCatHandle in window.ShirtsHierarchy.categories) {
//       var cCat = window.ShirtsHierarchy.categories[cCatHandle];
//       if (!cCat.genderHandles) continue;
//       for (var cGender in cCat.genderHandles) {
//         if (cCat.genderHandles[cGender] === handle) {
//           return {
//             categoryHandle: cCatHandle,
//             leagueHandle: null,
//             teamHandle: null,
//             level: 'category'
//           };
//         }
//       }
//     }

//     // GYM detection: check for gender-specific handles (men-jackets, women-tops, etc.)
//     // Uses the gymCatCategory's leagues where each has a genderHandles map.
//     var gymCat = window.ShirtsHierarchy.categories['gym-shirts'];
//     if (gymCat && gymCat.leagues) {
//       for (var gymLgHandle in gymCat.leagues) {
//         var gymLg = gymCat.leagues[gymLgHandle];
//         if (!gymLg.genderHandles) continue;
//         for (var gKey in gymLg.genderHandles) {
//           if (gymLg.genderHandles[gKey] === handle) {
//             // Matched a men-* or women-* collection → gym category + this league is active
//             return {
//               categoryHandle: 'gym-shirts',
//               leagueHandle: gymLgHandle,
//               teamHandle: null,
//               level: 'league',
//               gymGender: gKey   // remember which gender-specific handle they hit
//             };
//           }
//         }
//       }
//     }

//     var categories = window.ShirtsHierarchy.categories;
//     for (var catHandle in categories) {
//       var cat = categories[catHandle];
//       var leagues = cat.leagues || {};

//       // (1) Handle-based team match: /collections/arsenal → team = arsenal
//       //     Also matches F1 brands like /collections/f1-ferrari
//       for (var lgHandle in leagues) {
//         var lg = leagues[lgHandle];
//         if (lg.teams && lg.teams[handle]) {
//           return { categoryHandle: catHandle, leagueHandle: lgHandle, teamHandle: handle, level: 'team' };
//         }
//       }

//       // (2) League match — supports:
//       //     (a) hierarchy key equals collection handle (Premier League, La Liga, etc.)
//       //     (b) league.handle is a STRING (tag-based leagues like International Kits)
//       //     (c) league.handle is an ARRAY of aliases (multiple collection URLs → same league)
//       for (var lgHandle2 in leagues) {
//         var lg2 = leagues[lgHandle2];
//         var leagueHandles = lg2.handle;
//         var isMatch = false;
//         if (Array.isArray(leagueHandles)) {
//           isMatch = leagueHandles.indexOf(handle) !== -1;
//         } else {
//           isMatch = ((leagueHandles || lgHandle2) === handle);
//         }
//         if (isMatch) {
//           // For tag-based leagues, check URL for team tag
//           var teamHandle = null;
//           if (lg2.handle) {
//             teamHandle = detectTagBasedTeamFromUrl(lg2);
//           }
//           return {
//             categoryHandle: catHandle,
//             leagueHandle: lgHandle2,
//             teamHandle: teamHandle,
//             level: teamHandle ? 'team' : 'league'
//           };
//         }
//       }

//       // (3) Category match: /collections/football-jerseys OR /collections/f1
//       var catParent = cat.handle || catHandle;
//       if (catParent === handle) {
//         return { categoryHandle: catHandle, leagueHandle: null, teamHandle: null, level: 'category' };
//       }
//     }
//     return null;
//   }

//   function detectTagBasedTeamFromUrl(league) {
//     if (!league || !league.teams) return null;
//     try {
//       var params = new URLSearchParams(window.location.search);
//       var urlTags = params.getAll('filter.p.tag');
//       for (var teamKey in league.teams) {
//         var team = league.teams[teamKey];
//         if (!team.tag) continue;
//         for (var i = 0; i < urlTags.length; i++) {
//           if (urlTags[i] === team.tag) return teamKey;
//         }
//       }
//     } catch (e) {}
//     return null;
//   }

//   function detectGenderFromUrl() {
//     try {
//       var wrapper = document.querySelector('.sf-nav-wrapper');
//       var currentHandle = wrapper && wrapper.dataset.currentHandle;
//       if (currentHandle === 'kids-t-shirt') return 'kids';

//       // Gym: detect gender from the current collection handle (men-* or women-*)
//       // OR from the ?filter.p.tag=Women / ?filter.p.tag=Men URL param
//       var gymCat = window.ShirtsHierarchy.categories['gym-shirts'];
//       if (gymCat && gymCat.leagues) {
//         for (var lg in gymCat.leagues) {
//           var gh = gymCat.leagues[lg].genderHandles || {};
//           for (var g in gh) {
//             if (gh[g] === currentHandle) return g;  // men-jackets → 'men'
//           }
//         }
//       }

//       // Casual (and any category with category-level genderHandles):
//       // detect gender from the parent handle mapping
//       for (var casCatH in window.ShirtsHierarchy.categories) {
//         var casCat = window.ShirtsHierarchy.categories[casCatH];
//         if (!casCat.genderHandles) continue;
//         for (var casG in casCat.genderHandles) {
//           if (casCat.genderHandles[casG] === currentHandle) return casG;
//         }
//       }

//       var params = new URLSearchParams(window.location.search);
//       var tags = params.getAll('filter.p.tag');
//       for (var i = 0; i < tags.length; i++) {
//         var t = tags[i].toLowerCase();
//         if (t === 'kids') return 'kids';
//         if (t === 'women') return 'women';
//         // 'men' tag also possible, but 'men' is the default so we only need to detect if explicitly set
//       }
//       // Check current handle for the gym parent — default to men
//       if (currentHandle === (gymCat && gymCat.handle)) return (gymCat.defaultGender || 'men');

//       return 'men';
//     } catch (e) { return 'men'; }
//   }

//   function detectTypeTagFromUrl(location) {
//     try {
//       var cat = location && window.ShirtsHierarchy.categories[location.categoryHandle];
//       // For Casual (typesBySeason), scan ALL seasons' types since we don't know the active season yet
//       var typesToCheck = [];
//       if (cat && cat.typesBySeason) {
//         for (var seasonKey in cat.typesBySeason) {
//           typesToCheck = typesToCheck.concat(cat.typesBySeason[seasonKey]);
//         }
//       } else {
//         typesToCheck = getProductTypes(cat);
//       }
//       var params = new URLSearchParams(window.location.search);
//       var tags = params.getAll('filter.p.tag');
//       for (var i = 0; i < tags.length; i++) {
//         for (var j = 0; j < typesToCheck.length; j++) {
//           if (tags[i] === typesToCheck[j].tag) return typesToCheck[j].tag;
//         }
//       }
//       return null;
//     } catch (e) { return null; }
//   }

//   // Detects active season TAG in the URL (Gym only — reads cat.seasons)
//   function detectSeasonFromUrl(location) {
//     try {
//       var cat = location && window.ShirtsHierarchy.categories[location.categoryHandle];
//       if (!cat || !cat.seasons || !cat.seasons.length) return null;
//       var params = new URLSearchParams(window.location.search);
//       var tags = params.getAll('filter.p.tag');
//       for (var i = 0; i < tags.length; i++) {
//         for (var j = 0; j < cat.seasons.length; j++) {
//           if (tags[i] === cat.seasons[j].tag) return cat.seasons[j].tag;
//         }
//       }
//       return null;
//     } catch (e) { return null; }
//   }

//   // ============ URL BUILDING ============
//   function buildUrl(collectionHandle, gender, typeTag, teamTag, extraTag) {
//     var url = '/collections/' + collectionHandle;
//     var params = [];
//     // Gender tag: only add when the collection ISN'T already gender-specific.
//     // Gender-specific gym collections (men-*, women-*) already restrict to that gender
//     // via their smart-collection rules, so adding the tag would be redundant.
//     var isGenderSpecific = /^(men|women)-/.test(collectionHandle) || collectionHandle === 'kids-t-shirt';
//     if (gender === 'kids' && !isGenderSpecific)  params.push('filter.p.tag=' + encodeURIComponent('Kids'));
//     if (gender === 'women' && !isGenderSpecific) params.push('filter.p.tag=' + encodeURIComponent('Women'));
//     if (teamTag)  params.push('filter.p.tag=' + encodeURIComponent(teamTag));
//     if (typeTag)  params.push('filter.p.tag=' + encodeURIComponent(typeTag));
//     if (extraTag) params.push('filter.p.tag=' + encodeURIComponent(extraTag));
//     if (params.length) url += '?' + params.join('&');
//     return url;
//   }

//   // ============ RENDERERS ============

//   function renderGenderTabs(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="gender"]');
//     if (!row) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // If the category opts out of gender tabs entirely (e.g., Caps — unisex),
//     // hide the whole row. This is different from just hiding individual tabs;
//     // it removes the gender row from the layout completely.
//     if (cat && cat.hideGenderTabs) {
//       row.style.display = 'none';
//       return;
//     }
//     // Make sure the row is visible for other categories (in case a previous
//     // Caps navigation left it hidden — reset to default display)
//     row.style.display = '';

//     // Use category-specific gender config if defined (e.g., Gym uses Men/Women)
//     // Otherwise fall back to Men/Kids defaults (Football, F1)
//     var genderConfig = cat && cat.genderTabs;
//     var genders = genderConfig ? Object.keys(genderConfig) : ['men', 'kids'];

//     // Determine base URL for gender switch
//     var league = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     var team = league && league.teams && league.teams[location.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;

//     // Hide any tabs not in this category's gender set; show/update the ones that are
//     ['men', 'kids', 'women'].forEach(function(g) {
//       var tab = row.querySelector('[data-gender="' + g + '"]');
//       if (!tab) return;
//       if (genders.indexOf(g) === -1) {
//         tab.style.display = 'none';
//         return;
//       }
//       tab.style.display = '';

//       // Update label if this category has a custom label
//       if (genderConfig && genderConfig[g] && genderConfig[g].label) {
//         var labelSpan = tab.querySelector('span') || tab;
//         labelSpan.textContent = genderConfig[g].label;
//       }

//       // Build the URL for this gender tab
//       var url;
//       if (cat && cat.handle && cat.leagues && cat.leagues[location.leagueHandle] && cat.leagues[location.leagueHandle].genderHandles) {
//         // Gym: switch to this gender's variant of the current category — preserve brand + season
//         var lgh = cat.leagues[location.leagueHandle].genderHandles;
//         var gymBrand = null, gymSeason = null;
//         try {
//           var pp = new URLSearchParams(window.location.search);
//           var tt = pp.getAll('filter.p.tag');
//           if (cat.brands) {
//             for (var bi = 0; bi < cat.brands.length; bi++) {
//               if (tt.indexOf(cat.brands[bi].tag) !== -1) { gymBrand = cat.brands[bi].tag; break; }
//             }
//           }
//           if (cat.seasons) {
//             for (var si = 0; si < cat.seasons.length; si++) {
//               if (tt.indexOf(cat.seasons[si].tag) !== -1) { gymSeason = cat.seasons[si].tag; break; }
//             }
//           }
//         } catch (e) {}
//         url = buildUrl(lgh[g] || cat.handle, g, null, gymBrand, gymSeason);
//       } else if (cat && cat.casualMode && cat.genderHandles) {
//         // CASUAL: category-level gender handles. Switch to gender's parent, preserve brand/season/type
//         var casBrand = null, casSeason = null;
//         try {
//           var ccp = new URLSearchParams(window.location.search);
//           var cct = ccp.getAll('filter.p.tag');
//           if (cat.brands) {
//             for (var cbi = 0; cbi < cat.brands.length; cbi++) {
//               if (cct.indexOf(cat.brands[cbi].tag) !== -1) { casBrand = cat.brands[cbi].tag; break; }
//             }
//           }
//           if (cat.seasons) {
//             for (var csi = 0; csi < cat.seasons.length; csi++) {
//               if (cct.indexOf(cat.seasons[csi].tag) !== -1) { casSeason = cat.seasons[csi].tag; break; }
//             }
//           }
//         } catch (e) {}
//         url = buildUrl(cat.genderHandles[g] || cat.handle, g, location.activeType, casBrand, casSeason);
//       } else if (cat && cat.genderTabs) {
//         // Gym without a category picked yet: go to parent
//         url = buildUrl(cat.handle || location.categoryHandle, g, null, null, location.activeSeason);
//       } else {
//         // Football / F1
//         var currentColl;
//         var teamTag = null;
//         if (location.teamHandle) {
//           if (isTagBasedTeam) { currentColl = leagueHandleStr(league); teamTag = team.tag; }
//           else { currentColl = location.teamHandle; }
//         } else if (location.leagueHandle) {
//           currentColl = leagueHandleStr(league) || location.leagueHandle;
//         } else {
//           currentColl = cat.handle || location.categoryHandle;
//         }
//         url = buildUrl(currentColl, g, location.activeType, teamTag);
//       }
//       tab.href = url;
//       tab.classList.toggle('is-active', location.activeGender === g);
//     });
//   }

//   function renderCategories(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="categories"]');
//     var carousel = wrapper.querySelector('[data-carousel="categories"]');
//     if (!row || !carousel) return;
//     var cats = window.ShirtsHierarchy.categories;
//     var handles = Object.keys(cats);

//     // Auto-hide if only 1 category exists (no need for a lone pill)
//     if (handles.length <= 1) {
//       row.style.display = 'none';
//       return;
//     }

//     var items = handles.map(function(h) {
//       var isCurrentCategory = h === location.categoryHandle;
//       // The category pill is highlighted whenever the user is IN this category,
//       // at any depth. It's a "you are here" indicator, not a "you're at root" one.
//       var isActive = isCurrentCategory;
//       var catParent = cats[h].handle || h;
//       return {
//         handle: h,
//         title: cats[h].title,
//         isActive: isActive,
//         isCurrent: isCurrentCategory,
//         url: buildUrl(catParent, location.activeGender, null),
//         style: 'compact'
//       };
//     });
//     paintCarousel(carousel, items);
//     row.style.display = '';
//   }

//   function renderLeagues(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="leagues"]');
//     var carousel = wrapper.querySelector('[data-carousel="leagues"]');
//     if (!row || !carousel) return;
//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // CASUAL MODE: no traditional leagues — render BRANDS here instead.
//     if (cat && cat.casualMode && cat.brands && cat.brands.length) {
//       var casualLabel = row.querySelector('.sf-row-label');
//       if (casualLabel) casualLabel.textContent = cat.rowLabel || 'Brand';

//       // Determine current collection (gender-specific parent)
//       var casualColl;
//       if (cat.genderHandles && cat.genderHandles[location.activeGender]) {
//         casualColl = cat.genderHandles[location.activeGender];
//       } else {
//         casualColl = cat.handle || location.categoryHandle;
//       }

//       // Detect active brand tag
//       var casActiveBrand = null;
//       try {
//         var casParams = new URLSearchParams(window.location.search);
//         var casUrlTags = casParams.getAll('filter.p.tag');
//         for (var cbi = 0; cbi < cat.brands.length; cbi++) {
//           if (casUrlTags.indexOf(cat.brands[cbi].tag) !== -1) { casActiveBrand = cat.brands[cbi].tag; break; }
//         }
//       } catch (e) {}

//       // Build pills: "All" + each brand (preserving season + type-if-still-valid)
//       var casBrandItems = [{
//         handle: '__all_brands__',
//         title: 'All',
//         isActive: !casActiveBrand,
//         url: buildUrl(casualColl, location.activeGender, location.activeType, null, location.activeSeason),
//         style: 'compact'
//       }];
//       cat.brands.forEach(function(b) {
//         casBrandItems.push({
//           handle: b.tag,
//           title: b.title,
//           logo: b.logo,
//           isActive: casActiveBrand === b.tag,
//           url: buildUrl(casualColl, location.activeGender, location.activeType, b.tag, location.activeSeason),
//           style: b.logo ? 'with-icon' : 'compact'
//         });
//       });
//       paintCarousel(carousel, casBrandItems);
//       row.style.display = '';
//       return;
//     }

//     if (!cat || !cat.leagues) { row.style.display = 'none'; return; }

//     // Set row label dynamically (F1 uses "BRAND" instead of "LEAGUE")
//     var label = row.querySelector('.sf-row-label');
//     if (label) label.textContent = cat.rowLabel || 'League';

//     var leagueHandles = Object.keys(cat.leagues);

//     // Special: F1 has one synthetic league ('f1') — hide the league row and
//     // show only the brands as the primary carousel (in the teams row).
//     // This avoids showing a single lonely "F1 Brands" pill.
//     if (leagueHandles.length === 1 && cat.f1 !== false) {
//       var onlyLeague = cat.leagues[leagueHandles[0]];
//       if (onlyLeague && onlyLeague.teams && Object.keys(onlyLeague.teams).length > 1) {
//         row.style.display = 'none';
//         return;
//       }
//     }

//     var items = leagueHandles.map(function(h) {
//       var lg = cat.leagues[h];
//       var collectionHandle;

//       // GYM: leagues have per-gender handles — pick the one matching active gender
//       if (lg.genderHandles) {
//         collectionHandle = lg.genderHandles[location.activeGender] || lg.genderHandles.men || h;
//       } else if (Array.isArray(lg.handle)) {
//         collectionHandle = lg.handle[0];
//       } else {
//         collectionHandle = lg.handle || h;
//       }

//       // For gym, detect active brand tag to preserve when switching type
//       var preservedBrand = null;
//       var preservedSeason = null;
//       if (cat.brands || cat.seasons) {
//         try {
//           var params = new URLSearchParams(window.location.search);
//           var urlTags = params.getAll('filter.p.tag');
//           if (cat.brands) {
//             for (var bi = 0; bi < cat.brands.length; bi++) {
//               if (urlTags.indexOf(cat.brands[bi].tag) !== -1) { preservedBrand = cat.brands[bi].tag; break; }
//             }
//           }
//           if (cat.seasons) {
//             for (var si = 0; si < cat.seasons.length; si++) {
//               if (urlTags.indexOf(cat.seasons[si].tag) !== -1) { preservedSeason = cat.seasons[si].tag; break; }
//             }
//           }
//         } catch (e) {}
//       }

//       return {
//         handle: h,
//         title: lg.title,
//         logo: lg.logo,
//         isActive: h === location.leagueHandle && !location.teamHandle,
//         url: buildUrl(collectionHandle, location.activeGender, null, preservedBrand, preservedSeason),
//         style: lg.logo ? 'with-icon' : 'compact'
//       };
//     });
//     paintCarousel(carousel, items);
//     row.style.display = '';
//   }

//   function renderTeams(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="teams"]');
//     var carousel = wrapper.querySelector('[data-carousel="teams"]');
//     if (!row || !carousel) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // GYM MODE: if the category has `brands` and a league is picked,
//     // render brand tag filters (Nike, Adidas) instead of teams
//     if (cat && cat.brands && cat.brands.length && location.leagueHandle) {
//       var league = cat.leagues[location.leagueHandle];
//       // Determine the current gym collection (gender-specific)
//       var currentColl;
//       if (league.genderHandles) {
//         currentColl = league.genderHandles[location.activeGender] || league.genderHandles.men;
//       } else {
//         currentColl = location.leagueHandle;
//       }

//       // Set row label (BRAND)
//       var lbl = row.querySelector('.sf-row-label');
//       if (lbl) lbl.textContent = cat.teamRowLabel || 'Brand';

//       // Detect which brand tag is currently active
//       var activeBrand = null;
//       try {
//         var params = new URLSearchParams(window.location.search);
//         var urlTags = params.getAll('filter.p.tag');
//         for (var i = 0; i < cat.brands.length; i++) {
//           for (var j = 0; j < urlTags.length; j++) {
//             if (urlTags[j] === cat.brands[i].tag) { activeBrand = cat.brands[i].tag; break; }
//           }
//           if (activeBrand) break;
//         }
//       } catch (e) {}

//       // Make row label clickable if a brand is active (jumps to /collections/nike, etc.)
//       // Find the brand's display name (title) for the button label
//       var brandDisplayName = null;
//       if (activeBrand) {
//         for (var bri = 0; bri < cat.brands.length; bri++) {
//           if (cat.brands[bri].tag === activeBrand) {
//             brandDisplayName = cat.brands[bri].title || activeBrand;
//             break;
//           }
//         }
//       }
//       applyLabelClick(
//         row,
//         getLabelClickUrl(cat, 'teams', location, activeBrand, brandDisplayName),
//         cat.teamRowLabel || 'Brand'
//       );
//       // Build pills: "All" + each brand — preserving active season if set
//       var brandItems = [{
//         handle: '__all_brands__',
//         title: 'All',
//         isActive: !activeBrand,
//         url: buildUrl(currentColl, location.activeGender, null, null, location.activeSeason),
//         style: 'type'
//       }];
//       cat.brands.forEach(function(b) {
//         brandItems.push({
//           handle: b.tag,
//           title: b.title,
//           logo: b.logo,
//           isActive: activeBrand === b.tag,
//           url: buildUrl(currentColl, location.activeGender, null, b.tag, location.activeSeason),
//           style: b.logo ? 'with-icon' : 'type'
//         });
//       });
//       paintCarousel(carousel, brandItems);
//       row.style.display = '';
//       return;
//     }

//     // If the category suppresses the team level entirely, hide the row.
//     if (isTeamLevelSuppressed(cat)) { row.style.display = 'none'; return; }

//     // For F1 (single synthetic league), always show the brands row even
//     // when no league is explicitly picked — it IS the primary filter dimension.
//     var leagueForTeams = null;
//     if (location.leagueHandle) {
//       leagueForTeams = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     } else if (cat && cat.leagues) {
//       var leagueKeys = Object.keys(cat.leagues);
//       if (leagueKeys.length === 1) {
//         leagueForTeams = cat.leagues[leagueKeys[0]];
//         location.leagueHandle = leagueKeys[0]; // implicitly select the sole league
//       }
//     }

//     if (!leagueForTeams || !leagueForTeams.teams || !Object.keys(leagueForTeams.teams).length) {
//       row.style.display = 'none';
//       return;
//     }

//     // Set row label dynamically (F1 uses "BRAND" instead of "TEAM")
//     var label = row.querySelector('.sf-row-label');
//     if (label) {
//       if (cat.teamRowLabel) label.textContent = cat.teamRowLabel;
//       else if (cat.rowLabel === 'BRAND') label.textContent = 'Brand';
//       else label.textContent = 'Team';
//     }

//     var items = Object.keys(leagueForTeams.teams).map(function(h) {
//       var t = leagueForTeams.teams[h];
//       var isThisTeam = h === location.teamHandle;
//       var isActive = isThisTeam && !location.activeType;
//       var url;
//       // Tag-based team (International Kits countries)
//       if (t.tag && leagueForTeams.handle) {
//         url = buildUrl(leagueHandleStr(leagueForTeams), location.activeGender, null, t.tag);
//       } else {
//         // Handle-based team (Arsenal, f1-ferrari, etc.)
//         url = buildUrl(h, location.activeGender, null);
//       }
//       return {
//         handle: h,
//         title: t.title,
//         logo: t.logo,
//         isActive: isActive,
//         isCurrent: isThisTeam,
//         url: url,
//         style: 'with-icon'
//       };
//     });
//     paintCarousel(carousel, items);
//     row.style.display = '';
//   }

//   function renderTypes(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="types"]');
//     var carousel = wrapper.querySelector('[data-carousel="types"]');
//     if (!row || !carousel) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // CASUAL MODE: Season-conditional types (guided flow).
//     // Only show Type row when a season is picked.
//     if (cat && cat.typesBySeason) {
//       if (!location.activeSeason) { row.style.display = 'none'; return; }
//       var casualTypes = getProductTypes(cat, location.activeSeason);
//       if (!casualTypes.length) { row.style.display = 'none'; return; }

//       // Set row label
//       var casualLbl = row.querySelector('.sf-row-label');
//       if (casualLbl) casualLbl.textContent = 'Type';

//       // Determine current collection (gender-specific parent for casual)
//       var casualColl;
//       if (cat.genderHandles && cat.genderHandles[location.activeGender]) {
//         casualColl = cat.genderHandles[location.activeGender];
//       } else {
//         casualColl = cat.handle || location.categoryHandle;
//       }

//       // Detect active brand tag (to preserve when switching type)
//       var casualBrand = null;
//       if (cat.brands) {
//         try {
//           var params = new URLSearchParams(window.location.search);
//           var urlTags = params.getAll('filter.p.tag');
//           for (var bi = 0; bi < cat.brands.length; bi++) {
//             if (urlTags.indexOf(cat.brands[bi].tag) !== -1) { casualBrand = cat.brands[bi].tag; break; }
//           }
//         } catch (e) {}
//       }

//       // Build pills: "All" + each season-specific type (preserving brand + season)
//       var casualItems = [{
//         handle: '__all_types__',
//         title: 'All',
//         isActive: !location.activeType,
//         url: buildUrl(casualColl, location.activeGender, null, casualBrand, location.activeSeason),
//         style: 'type'
//       }];
//       casualTypes.forEach(function(t) {
//         casualItems.push({
//           handle: t.tag,
//           title: t.title,
//           tag: t.tag,
//           isActive: location.activeType === t.tag,
//           url: buildUrl(casualColl, location.activeGender, t.tag, casualBrand, location.activeSeason),
//           style: 'type'
//         });
//       });
//       paintCarousel(carousel, casualItems);
//       // Clickable label: for casual with parent-plus-tag pattern, jumps to catch-all filtered by type
//       var casualTypeName = null;
//       if (location.activeType) {
//         for (var cti = 0; cti < casualTypes.length; cti++) {
//           if (casualTypes[cti].tag === location.activeType) {
//             casualTypeName = casualTypes[cti].title || location.activeType;
//             break;
//           }
//         }
//       }
//       applyLabelClick(
//         row,
//         getLabelClickUrl(cat, 'types', location, location.activeType, casualTypeName),
//         'Type'
//       );
//       row.style.display = '';
//       return;
//     }

//     // Standard mode (Football/F1): types show under a team
//     var types = getProductTypes(cat, location.activeSeason);
//     if (!types.length) { row.style.display = 'none'; return; }

//     // Only show types when a team (leaf) is selected
//     if (!location.teamHandle) { row.style.display = 'none'; return; }

//     var league = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     var team = league && league.teams && league.teams[location.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;
//     var teamCollectionHandle = isTagBasedTeam ? leagueHandleStr(league) : location.teamHandle;
//     var teamTag = isTagBasedTeam ? team.tag : null;

//     var items = [{
//       handle: location.teamHandle,
//       title: 'All',
//       isActive: !location.activeType,
//       url: buildUrl(teamCollectionHandle, location.activeGender, null, teamTag),
//       style: 'type'
//     }];
//     types.forEach(function(t) {
//       items.push({
//         handle: location.teamHandle,
//         title: t.title,
//         tag: t.tag,
//         isActive: location.activeType === t.tag,
//         url: buildUrl(teamCollectionHandle, location.activeGender, t.tag, teamTag),
//         style: 'type'
//       });
//     });
//     paintCarousel(carousel, items);
//     // Clickable KIT label: on F1, jumps to /collections/f1?filter.p.tag=<type>
//     // Find the type's display name for the button
//     var typeDisplayName = null;
//     if (location.activeType) {
//       for (var tdi = 0; tdi < types.length; tdi++) {
//         if (types[tdi].tag === location.activeType) {
//           typeDisplayName = types[tdi].title || location.activeType;
//           break;
//         }
//       }
//     }
//     applyLabelClick(
//       row,
//       getLabelClickUrl(cat, 'types', location, location.activeType, typeDisplayName),
//       'Kit'
//     );
//     row.style.display = '';
//   }

//   // Renders the SEASON row (Gym only). Season is a TAG filter that can be
//   // combined with any other active filter (Type, Brand, Gender).
//   function renderSeasons(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="seasons"]');
//     var carousel = wrapper.querySelector('[data-carousel="seasons"]');
//     if (!row || !carousel) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];
//     if (!cat || !cat.seasons || !cat.seasons.length) { row.style.display = 'none'; return; }

//     // Set row label
//     var lbl = row.querySelector('.sf-row-label');
//     if (lbl) lbl.textContent = 'Season';

//     // Determine current collection (gender-specific for gym at league level, casual at category level)
//     var currentColl;
//     if (location.leagueHandle && cat.leagues && cat.leagues[location.leagueHandle] && cat.leagues[location.leagueHandle].genderHandles) {
//       // Gym: league-level gender handles
//       var gh = cat.leagues[location.leagueHandle].genderHandles;
//       currentColl = gh[location.activeGender] || gh.men;
//     } else if (cat.genderHandles) {
//       // Casual: category-level gender handles
//       currentColl = cat.genderHandles[location.activeGender] || cat.handle || location.categoryHandle;
//     } else {
//       currentColl = cat.handle || location.categoryHandle;
//     }

//     // Determine active brand tag (to preserve when switching season)
//     var activeBrandTag = null;
//     if (cat.brands) {
//       try {
//         var params = new URLSearchParams(window.location.search);
//         var urlTags = params.getAll('filter.p.tag');
//         for (var i = 0; i < cat.brands.length; i++) {
//           for (var j = 0; j < urlTags.length; j++) {
//             if (urlTags[j] === cat.brands[i].tag) { activeBrandTag = cat.brands[i].tag; break; }
//           }
//           if (activeBrandTag) break;
//         }
//       } catch (e) {}
//     }

//     // Helper: given a target season, check if the currently active type is still valid.
//     // For Casual (typesBySeason), a type only belongs to one season, so switching season
//     // must drop the type unless it exists in the target season's type list.
//     function typeStillValid(targetSeasonTag) {
//       if (!location.activeType) return null;
//       if (!cat.typesBySeason) return location.activeType; // non-casual: type always compatible
//       if (!targetSeasonTag) return null; // moving to "All" seasons — drop type (guided flow needs season)
//       var targetTypes = cat.typesBySeason[targetSeasonTag] || [];
//       for (var ti = 0; ti < targetTypes.length; ti++) {
//         if (targetTypes[ti].tag === location.activeType) return location.activeType;
//       }
//       return null; // type doesn't exist in target season → drop it
//     }

//     // Build pills: "All" + each season
//     // Note: brand tag goes in teamTag slot, season goes in extraTag slot
//     // For casual, we ALSO preserve type IF compatible with the target season.
//     var seasonItems = [{
//       handle: '__all_seasons__',
//       title: 'All',
//       isActive: !location.activeSeason,
//       url: buildUrl(currentColl, location.activeGender, typeStillValid(null), activeBrandTag, null),
//       style: 'type'
//     }];
//     cat.seasons.forEach(function(s) {
//       var title = s.emoji ? (s.emoji + ' ' + s.title) : s.title;
//       seasonItems.push({
//         handle: s.tag,
//         title: title,
//         isActive: location.activeSeason === s.tag,
//         url: buildUrl(currentColl, location.activeGender, typeStillValid(s.tag), activeBrandTag, s.tag),
//         style: 'type'
//       });
//     });
//     paintCarousel(carousel, seasonItems);
//     row.style.display = '';
//   }

//   function renderBreadcrumb(wrapper, location) {
//     var el = wrapper.querySelector('.sf-breadcrumb');
//     if (!el) return;
//     var parts = [];
//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];
//     var league = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     var team = league && league.teams && league.teams[location.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;

//     // 1) Gender — use per-category label if defined, else fall back to defaults
//     var currentColl;
//     var teamTag = null;
//     if (location.teamHandle) {
//       if (isTagBasedTeam) { currentColl = leagueHandleStr(league); teamTag = team.tag; }
//       else { currentColl = location.teamHandle; }
//     } else if (location.leagueHandle) {
//       currentColl = leagueHandleStr(league) || location.leagueHandle;
//     } else {
//       currentColl = cat.handle || location.categoryHandle;
//     }

//     // Only include the Gender crumb if the category has gender tabs
//     if (!(cat && cat.hideGenderTabs)) {
//       // Resolve display label for this gender
//       var genderLabel;
//       if (cat && cat.genderTabs && cat.genderTabs[location.activeGender] && cat.genderTabs[location.activeGender].label) {
//         genderLabel = cat.genderTabs[location.activeGender].label;
//       } else if (location.activeGender === 'women') {
//         genderLabel = 'Women';
//       } else if (location.activeGender === 'kids') {
//         genderLabel = 'Kids';
//       } else {
//         genderLabel = 'Men';
//       }
//       parts.push({
//         text: genderLabel,
//         url: buildUrl(currentColl, location.activeGender, location.activeType, teamTag)
//       });
//     }

//     // 2) Category
//     if (cat) parts.push({
//       text: cat.title,
//       url: buildUrl(cat.handle || location.categoryHandle, location.activeGender, null)
//     });

//     // 3) League (skip for F1's synthetic single league — redundant with category)
//     var categoryLeagueKeys = cat && cat.leagues ? Object.keys(cat.leagues) : [];
//     var isSyntheticSingleLeague = categoryLeagueKeys.length === 1;

//     if (location.leagueHandle && league && !isSyntheticSingleLeague) {
//       var lgHandle = leagueHandleStr(league) || location.leagueHandle;
//       parts.push({
//         text: league.title,
//         url: buildUrl(lgHandle, location.activeGender, null)
//       });
//     }

//     // 4) Team
//     if (location.teamHandle && team) {
//       var teamUrl;
//       if (isTagBasedTeam) {
//         teamUrl = buildUrl(leagueHandleStr(league), location.activeGender, null, team.tag);
//       } else {
//         teamUrl = buildUrl(location.teamHandle, location.activeGender, null);
//       }
//       parts.push({ text: team.title, url: teamUrl });
//     }

//     // 5) Product type
//     if (location.activeType) {
//       var types = getProductTypes(cat, location.activeSeason);
//       var match = types.filter(function(p) { return p.tag === location.activeType; })[0];
//       if (match) {
//         var typeUrl;
//         if (isTagBasedTeam) {
//           typeUrl = buildUrl(leagueHandleStr(league), location.activeGender, match.tag, team.tag);
//         } else if (location.teamHandle) {
//           typeUrl = buildUrl(location.teamHandle, location.activeGender, match.tag);
//         } else {
//           typeUrl = buildUrl(cat.handle || location.categoryHandle, location.activeGender, match.tag);
//         }
//         parts.push({ text: match.title, url: typeUrl });
//       }
//     }

//     el.innerHTML = parts.map(function(p, i) {
//       var isLast = i === parts.length - 1;
//       var sep = i > 0 ? '<span class="sf-crumb-sep"> › </span>' : '';
//       return sep + '<a class="sf-crumb' + (isLast ? ' is-current' : '') + '" href="' + p.url + '">' + escapeHtml(p.text) + '</a>';
//     }).join('');
//   }

//   // ============ PAINT & UTILITIES ============

//   function paintCarousel(carousel, items) {
//     carousel.innerHTML = '';
//     items.forEach(function(item) {
//       var link = document.createElement('a');
//       var cls = 'sf-item';
//       if (item.isActive) cls += ' is-active';
//       else if (item.isCurrent) cls += ' is-current';
//       if (item.style === 'with-icon') {
//         cls += ' sf-with-icon';
//       } else if (item.style === 'type') {
//         cls += ' sf-type';
//       } else {
//         cls += ' sf-compact';
//       }
//       link.className = cls;
//       link.href = item.url;
//       link.setAttribute('data-handle', item.handle);
//       if (item.style === 'with-icon') {
//         var logoHtml = item.logo
//           ? '<img class="sf-item-logo-img" src="' + item.logo + '" alt="' + escapeHtml(item.title) + '" loading="lazy" onerror="this.style.display=\'none\'">'
//           : '<span class="sf-item-logo-fallback">' + escapeHtml(item.title.charAt(0)) + '</span>';
//         link.innerHTML =
//           '<div class="sf-item-logo">' + logoHtml + '</div>' +
//           '<div class="sf-item-title">' + escapeHtml(item.title) + '</div>';
//       } else {
//         link.innerHTML = escapeHtml(item.title);
//       }
//       attachClickFeedback(link, item.isActive);
//       carousel.appendChild(link);
//     });
//   }

//   function setupArrows(carousel) {
//     var container = carousel.closest('.sf-carousel-container');
//     if (!container) return;
//     var prev = container.querySelector('.sf-arrow-prev');
//     var next = container.querySelector('.sf-arrow-next');
//     if (!prev || !next) return;
//     function scroll(delta) { carousel.scrollBy({ left: delta, behavior: 'smooth' }); }
//     prev.onclick = function() { scroll(-260); };
//     next.onclick = function() { scroll(260); };
//     function checkOverflow() {
//       var hasOverflow = carousel.scrollWidth > carousel.clientWidth + 4;
//       container.classList.toggle('has-overflow', hasOverflow);
//     }
//     checkOverflow();
//     window.addEventListener('resize', checkOverflow);
//   }

//   function attachClickFeedback(link, alreadyActive) {
//     if (alreadyActive) {
//       link.addEventListener('click', function(e) { e.preventDefault(); });
//       return;
//     }
//     link.addEventListener('click', function() { link.classList.add('is-loading'); });
//   }

//   function scrollIntoView(el) {
//     try { el.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); }
//     catch (e) {}
//   }

//   function escapeHtml(s) {
//     return String(s).replace(/[&<>"']/g, function(c) {
//       return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
//     });
//   }
// })();
// -----------------------------------------------------------------------------
// // shirts-carousel-filter.js
// // Football Shirts filter — Category → League → Team → Product Type
// // Auto-detects if the current collection is in the hierarchy; hides otherwise.

// (function() {
//   'use strict';

//   if (!window.ShirtsHierarchy) return;

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   var currentLocation = null;

//   function init() {
//     var wrapper = document.querySelector('.sf-nav-wrapper');
//     if (!wrapper) return;

//     var currentHandle = wrapper.dataset.currentHandle;
//     if (!currentHandle) return;

//     var location = findInHierarchy(currentHandle);
//     if (!location) {
//       // Not a shirt collection — hide the shirt filter card but keep the
//       // catalog switcher visible so customers can navigate away.
//       // If the SHOE filter is active, hide our catalog switcher to avoid duplication.
//       var shoeWrapper = document.querySelector('.hcf-nav-wrapper');
//       var shoeIsActive = shoeWrapper && shoeWrapper.querySelector('.hcf-item') !== null;

//       var inner = wrapper.querySelector('.sf-nav-inner');
//       if (inner) {
//         Array.prototype.forEach.call(inner.children, function(child) {
//           if (!child.classList || !child.classList.contains('cs-catalog-tabs')) {
//             child.style.display = 'none';
//           }
//         });
//         if (shoeIsActive) {
//           var shirtTabs = inner.querySelector('.cs-catalog-tabs');
//           if (shirtTabs) shirtTabs.style.display = 'none';
//           wrapper.style.display = 'none';
//         }
//       }
//       var stickyBar = document.getElementById('sf-sticky-bar');
//       if (stickyBar) stickyBar.remove();
//       var fab = document.getElementById('sf-fab');
//       if (fab) fab.remove();
//       var expandedOverlay = document.getElementById('sf-expanded-overlay');
//       if (expandedOverlay) expandedOverlay.remove();
//       return;
//     }

//     location.activeGender = detectGenderFromUrl();
//     location.activeType   = detectTypeTagFromUrl(location);
//     location.activeSeason = detectSeasonFromUrl(location);

//     currentLocation = location;

//     renderGenderTabs(wrapper, location);
//     renderCategories(wrapper, location);
//     renderLeagues(wrapper, location);
//     renderTeams(wrapper, location);
//     renderTypes(wrapper, location);
//     renderSeasons(wrapper, location);
//     renderBreadcrumb(wrapper, location);

//     // Add helper class if the deep rows (teams + types) are both hidden
//     var teamsRow = wrapper.querySelector('[data-level="teams"]');
//     var typesRow = wrapper.querySelector('[data-level="types"]');
//     var teamsHidden = !teamsRow || teamsRow.style.display === 'none';
//     var typesHidden = !typesRow || typesRow.style.display === 'none';
//     wrapper.classList.toggle('sf-leagues-only', teamsHidden && typesHidden);

//     wrapper.querySelectorAll('.sf-carousel').forEach(setupArrows);
//     setTimeout(function() {
//       wrapper.querySelectorAll('.sf-item.is-active').forEach(scrollIntoView);
//     }, 100);

//     setupScrollHints(wrapper);
//     setupStickyBar(wrapper, location);
//     setupExpandedOverlay(wrapper);
//     setupFAB(wrapper);
//   }

//   // ============ HELPERS ============

//   // Unwrap league.handle if it's a string OR array of aliases (returns first alias or null)
//   function leagueHandleStr(league) {
//     if (!league) return null;
//     if (Array.isArray(league.handle)) return league.handle[0];
//     return league.handle || null;
//   }

//   // Get the productTypes list for a given category.
//   //   - Football/F1: fixed list from cat.productTypes or global fallback
//   //   - Casual: season-conditional — pass activeSeason as 2nd arg
//   //     Returns [] if season required but not set (guided flow — Type row hidden)
//   function getProductTypes(cat, activeSeason) {
//     if (cat && cat.typesBySeason) {
//       if (!activeSeason) return [];
//       return cat.typesBySeason[activeSeason] || [];
//     }
//     if (cat && cat.productTypes && cat.productTypes.length) return cat.productTypes;
//     return window.ShirtsHierarchy.productTypes || [];
//   }

//   // Is this category's team level suppressed (e.g., F1 has no sub-teams)?
//   function isTeamLevelSuppressed(cat) {
//     return cat && cat.teamRowLabel === null;
//   }

//   // Returns { url, buttonText } for a clickable row label, or null if not applicable.
//   //
//   //   cat         — active category object
//   //   rowLevel    — 'leagues' | 'teams' | 'types'
//   //   location    — current location object
//   //   activeTag   — the currently active tag in this row (or null)
//   //   displayName — the display title matching activeTag (e.g., "Cap" for tag "F1 caps");
//   //                 falls back to activeTag if not provided
//   function getLabelClickUrl(cat, rowLevel, location, activeTag, displayName) {
//     if (!cat || !cat.labelClicks) return null;
//     var cfg = cat.labelClicks[rowLevel];
//     if (!cfg || !activeTag) return null;

//     var url = null;
//     if (cfg.pattern === 'brand-collection') {
//       // Lowercase-hyphenate the tag to produce a collection handle
//       // (e.g., "Nike" → "nike", "Tommy Hilfiger" → "tommy-hilfiger")
//       var handle = activeTag.toLowerCase().replace(/\s+/g, '-');
//       url = '/collections/' + handle;
//     } else if (cfg.pattern === 'handle-map' && cfg.handleMap && cfg.handleMap[activeTag]) {
//       url = '/collections/' + cfg.handleMap[activeTag];
//     } else if (cfg.pattern === 'parent-plus-tag') {
//       var parent = cat.handle || location.categoryHandle;
//       url = '/collections/' + parent + '?filter.p.tag=' + encodeURIComponent(activeTag);
//     }

//     if (!url) return null;

//     // Build button text from format template
//     var name = displayName || activeTag;
//     var format = cfg.buttonTextFormat || 'Shop {name}';
//     var buttonText = format.replace('{name}', name);

//     return { url: url, buttonText: buttonText };
//   }

//   // Apply the "shop X" button to a row label. If clickInfo is null, resets
//   // the label to plain text (defaultLabel).
//   //
//   //   clickInfo   — { url, buttonText } from getLabelClickUrl, or null
//   //   defaultLabel — the plain text to show when no filter is active
//   function applyLabelClick(row, clickInfo, defaultLabel) {
//     var label = row.querySelector('.sf-row-label');
//     if (!label) return;

//     if (clickInfo && clickInfo.url) {
//       // Render as burgundy pill button — impossible to miss
//       label.innerHTML = '';
//       var btn = document.createElement('a');
//       btn.className = 'sf-label-btn';
//       btn.href = clickInfo.url;
//       btn.textContent = clickInfo.buttonText;
//       btn.setAttribute('aria-label', clickInfo.buttonText);
//       label.appendChild(btn);
//       label.classList.add('sf-label-has-btn');
//     } else {
//       // Plain text label (no active filter)
//       label.textContent = defaultLabel;
//       label.classList.remove('sf-label-has-btn');
//     }
//   }

//   // ============ MOBILE SCROLL HINTS (COMBO: fade + peek + delayed arrow) ============
//   function setupScrollHints(wrapper) {
//     if (window.matchMedia && !window.matchMedia('(max-width: 768px)').matches) return;

//     setTimeout(function() {
//       var rows = wrapper.querySelectorAll('.sf-row-content');
//       var anyOverflowed = false;
//       var alreadyPeeked = false;
//       try { alreadyPeeked = sessionStorage.getItem('sf_peek_played') === '1'; } catch (e) {}

//       rows.forEach(function(rowContent) {
//         var carousel = rowContent.querySelector('.sf-carousel');
//         if (!carousel) return;

//         var overflows = carousel.scrollWidth > carousel.clientWidth + 4;
//         if (!overflows) return;

//         anyOverflowed = true;
//         rowContent.classList.add('sf-has-overflow');

//         if (!rowContent.querySelector('.sf-scroll-arrow')) {
//           var arrow = document.createElement('div');
//           arrow.className = 'sf-scroll-arrow';
//           arrow.innerHTML = '<svg width="14" height="14" viewBox="0 0 20 20" fill="none"><path d="M8 4L14 10L8 16" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
//           rowContent.appendChild(arrow);
//         }

//         if (!alreadyPeeked) {
//           carousel.classList.add('sf-peek');
//           setTimeout(function() { carousel.classList.remove('sf-peek'); }, 3000);
//         }

//         var arrowTimer = setTimeout(function() {
//           if (!rowContent.classList.contains('sf-scrolled')) {
//             rowContent.classList.add('sf-show-arrow');
//             setTimeout(function() {
//               rowContent.classList.remove('sf-show-arrow');
//             }, 6000);
//           }
//         }, 2000);

//         var onScroll = function() {
//           rowContent.classList.add('sf-scrolled');
//           rowContent.classList.remove('sf-show-arrow');
//           clearTimeout(arrowTimer);
//           if (carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4) {
//             rowContent.classList.remove('sf-has-overflow');
//           }
//           carousel.removeEventListener('scroll', onScroll);
//           carousel.addEventListener('scroll', function() {
//             var atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4;
//             rowContent.classList.toggle('sf-has-overflow', !atEnd);
//           }, { passive: true });
//         };
//         carousel.addEventListener('scroll', onScroll, { passive: true });
//       });

//       if (anyOverflowed && !alreadyPeeked) {
//         try { sessionStorage.setItem('sf_peek_played', '1'); } catch (e) {}
//       }
//     }, 250);
//   }

//   // ============ STICKY BAR / EXPANDED OVERLAY / FAB ============

//   function setupStickyBar(wrapper, location) {
//     var stickyBar = document.getElementById('sf-sticky-bar');
//     var stickyPath = document.getElementById('sf-sticky-path');
//     var stickyBack = document.getElementById('sf-sticky-back');
//     var stickyScrollTop = document.getElementById('sf-sticky-scroll-top');
//     if (!stickyBar || !wrapper) return;

//     var pathTextEl = stickyBar.querySelector('.sf-sticky-path-text');
//     if (pathTextEl) pathTextEl.textContent = buildStickyPathText(location);

//     var backTarget = getBackTarget(location);
//     if (backTarget) {
//       stickyBack.disabled = false;
//       stickyBack.onclick = function() { window.location.href = backTarget; };
//     } else {
//       stickyBack.disabled = true;
//     }

//     if (stickyScrollTop) {
//       stickyScrollTop.onclick = function() {
//         wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
//       };
//     }

//     if (stickyPath) stickyPath.onclick = openExpandedOverlay;

//     var ticking = false;
//     function updateVisibility() {
//       var wrapperBottom = wrapper.getBoundingClientRect().bottom;
//       if (wrapperBottom < 0) {
//         stickyBar.classList.add('is-visible');
//         stickyBar.setAttribute('aria-hidden', 'false');
//       } else {
//         stickyBar.classList.remove('is-visible');
//         stickyBar.setAttribute('aria-hidden', 'true');
//       }
//       ticking = false;
//     }
//     window.addEventListener('scroll', function() {
//       if (!ticking) {
//         window.requestAnimationFrame(updateVisibility);
//         ticking = true;
//       }
//     }, { passive: true });
//     updateVisibility();
//   }

//   function buildStickyPathText(loc) {
//     if (!loc) return 'All Jerseys';
//     var parts = [];
//     parts.push(loc.activeGender === 'kids' ? 'Kids' : 'Men');
//     var cat = window.ShirtsHierarchy.categories[loc.categoryHandle];
//     if (cat) parts.push(cat.title);
//     if (loc.leagueHandle) {
//       var lg = cat && cat.leagues && cat.leagues[loc.leagueHandle];
//       // For F1's synthetic 'f1' league, don't add "F1 Brands" — redundant with category
//       if (lg && loc.leagueHandle !== 'f1') parts.push(lg.title);
//     }
//     if (loc.teamHandle) {
//       var lg2 = cat && cat.leagues && cat.leagues[loc.leagueHandle];
//       var t = lg2 && lg2.teams && lg2.teams[loc.teamHandle];
//       if (t) parts.push(t.title);
//     }
//     if (loc.activeType) {
//       var types = getProductTypes(cat, loc.activeSeason);
//       var match = types.filter(function(p) { return p.tag === loc.activeType; })[0];
//       if (match) parts.push(match.title);
//     }
//     return parts.join(' › ');
//   }

//   function getBackTarget(loc) {
//     if (!loc) return null;
//     var cat = window.ShirtsHierarchy.categories[loc.categoryHandle];
//     var league = cat && cat.leagues && cat.leagues[loc.leagueHandle];
//     var team = league && league.teams && league.teams[loc.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;

//     // Type filter active → clear type
//     if (loc.activeType && loc.teamHandle) {
//       if (isTagBasedTeam) {
//         return buildUrl(leagueHandleStr(league), loc.activeGender, null, team.tag);
//       }
//       return buildUrl(loc.teamHandle, loc.activeGender, null);
//     }
//     // Team active → go up to league
//     if (loc.teamHandle && loc.leagueHandle) {
//       if (isTagBasedTeam) {
//         return buildUrl(leagueHandleStr(league), loc.activeGender, null);
//       }
//       return buildUrl(loc.leagueHandle, loc.activeGender, null);
//     }
//     // League active → go up to category
//     if (loc.leagueHandle && loc.categoryHandle) {
//       return buildUrl(loc.categoryHandle, loc.activeGender, null);
//     }
//     return null;
//   }

//   function setupExpandedOverlay(wrapper) {
//     var overlay = document.getElementById('sf-expanded-overlay');
//     if (!overlay) return;
//     var backdrop = overlay.querySelector('.sf-expanded-backdrop');
//     var closeBtn = document.getElementById('sf-expanded-close');
//     if (closeBtn) closeBtn.onclick = closeExpandedOverlay;
//     if (backdrop) backdrop.onclick = closeExpandedOverlay;
//     document.addEventListener('keydown', function(e) {
//       if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
//         closeExpandedOverlay();
//       }
//     });
//   }

//   function openExpandedOverlay() {
//     var overlay = document.getElementById('sf-expanded-overlay');
//     var content = document.getElementById('sf-expanded-content');
//     var wrapper = document.querySelector('.sf-nav-wrapper');
//     if (!overlay || !content || !wrapper) return;

//     content.innerHTML = '';
//     wrapper.querySelectorAll('.sf-row').forEach(function(row) {
//       if (row.style.display === 'none') return;
//       var clone = row.cloneNode(true);
//       content.appendChild(clone);
//     });

//     overlay.classList.add('is-open');
//     overlay.setAttribute('aria-hidden', 'false');
//     document.body.style.overflow = 'hidden';
//   }

//   function closeExpandedOverlay() {
//     var overlay = document.getElementById('sf-expanded-overlay');
//     if (!overlay) return;
//     overlay.classList.remove('is-open');
//     overlay.setAttribute('aria-hidden', 'true');
//     document.body.style.overflow = '';
//   }

//   function setupFAB(wrapper) {
//     var fab = document.getElementById('sf-fab');
//     if (!fab || !wrapper) return;
//     fab.onclick = function() {
//       wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     };
//     var ticking = false;
//     function update() {
//       var wrapperBottom = wrapper.getBoundingClientRect().bottom;
//       if (wrapperBottom < -300) fab.classList.add('is-visible');
//       else fab.classList.remove('is-visible');
//       ticking = false;
//     }
//     window.addEventListener('scroll', function() {
//       if (!ticking) {
//         window.requestAnimationFrame(update);
//         ticking = true;
//       }
//     }, { passive: true });
//     update();
//   }

//   // ============ LOCATION DETECTION ============

//   function findInHierarchy(handle) {
//     // Special case: kids-t-shirt is the Kids gender landing page.
//     if (handle === 'kids-t-shirt') {
//       return { categoryHandle: 'football-jerseys', leagueHandle: null, teamHandle: null, level: 'category' };
//     }

//     // CATEGORY-LEVEL GENDER HANDLES (Casual):
//     // Check for category-level gender handles (e.g., men-casual-out-fit → casual-shirts)
//     for (var cCatHandle in window.ShirtsHierarchy.categories) {
//       var cCat = window.ShirtsHierarchy.categories[cCatHandle];
//       if (!cCat.genderHandles) continue;
//       for (var cGender in cCat.genderHandles) {
//         if (cCat.genderHandles[cGender] === handle) {
//           return {
//             categoryHandle: cCatHandle,
//             leagueHandle: null,
//             teamHandle: null,
//             level: 'category'
//           };
//         }
//       }
//     }

//     // GYM detection: check for gender-specific handles (men-jackets, women-tops, etc.)
//     // Uses the gymCatCategory's leagues where each has a genderHandles map.
//     var gymCat = window.ShirtsHierarchy.categories['gym-shirts'];
//     if (gymCat && gymCat.leagues) {
//       for (var gymLgHandle in gymCat.leagues) {
//         var gymLg = gymCat.leagues[gymLgHandle];
//         if (!gymLg.genderHandles) continue;
//         for (var gKey in gymLg.genderHandles) {
//           if (gymLg.genderHandles[gKey] === handle) {
//             // Matched a men-* or women-* collection → gym category + this league is active
//             return {
//               categoryHandle: 'gym-shirts',
//               leagueHandle: gymLgHandle,
//               teamHandle: null,
//               level: 'league',
//               gymGender: gKey   // remember which gender-specific handle they hit
//             };
//           }
//         }
//       }
//     }

//     var categories = window.ShirtsHierarchy.categories;
//     for (var catHandle in categories) {
//       var cat = categories[catHandle];
//       var leagues = cat.leagues || {};

//       // (1) Handle-based team match: /collections/arsenal → team = arsenal
//       //     Also matches F1 brands like /collections/f1-ferrari
//       for (var lgHandle in leagues) {
//         var lg = leagues[lgHandle];
//         if (lg.teams && lg.teams[handle]) {
//           return { categoryHandle: catHandle, leagueHandle: lgHandle, teamHandle: handle, level: 'team' };
//         }
//       }

//       // (2) League match — supports:
//       //     (a) hierarchy key equals collection handle (Premier League, La Liga, etc.)
//       //     (b) league.handle is a STRING (tag-based leagues like International Kits)
//       //     (c) league.handle is an ARRAY of aliases (multiple collection URLs → same league)
//       for (var lgHandle2 in leagues) {
//         var lg2 = leagues[lgHandle2];
//         var leagueHandles = lg2.handle;
//         var isMatch = false;
//         if (Array.isArray(leagueHandles)) {
//           isMatch = leagueHandles.indexOf(handle) !== -1;
//         } else {
//           isMatch = ((leagueHandles || lgHandle2) === handle);
//         }
//         if (isMatch) {
//           // For tag-based leagues, check URL for team tag
//           var teamHandle = null;
//           if (lg2.handle) {
//             teamHandle = detectTagBasedTeamFromUrl(lg2);
//           }
//           return {
//             categoryHandle: catHandle,
//             leagueHandle: lgHandle2,
//             teamHandle: teamHandle,
//             level: teamHandle ? 'team' : 'league'
//           };
//         }
//       }

//       // (3) Category match: /collections/football-jerseys OR /collections/f1
//       var catParent = cat.handle || catHandle;
//       if (catParent === handle) {
//         return { categoryHandle: catHandle, leagueHandle: null, teamHandle: null, level: 'category' };
//       }
//     }
//     return null;
//   }

//   function detectTagBasedTeamFromUrl(league) {
//     if (!league || !league.teams) return null;
//     try {
//       var params = new URLSearchParams(window.location.search);
//       var urlTags = params.getAll('filter.p.tag');
//       for (var teamKey in league.teams) {
//         var team = league.teams[teamKey];
//         if (!team.tag) continue;
//         for (var i = 0; i < urlTags.length; i++) {
//           if (urlTags[i] === team.tag) return teamKey;
//         }
//       }
//     } catch (e) {}
//     return null;
//   }

//   function detectGenderFromUrl() {
//     try {
//       var wrapper = document.querySelector('.sf-nav-wrapper');
//       var currentHandle = wrapper && wrapper.dataset.currentHandle;
//       if (currentHandle === 'kids-t-shirt') return 'kids';

//       // Gym: detect gender from the current collection handle (men-* or women-*)
//       // OR from the ?filter.p.tag=Women / ?filter.p.tag=Men URL param
//       var gymCat = window.ShirtsHierarchy.categories['gym-shirts'];
//       if (gymCat && gymCat.leagues) {
//         for (var lg in gymCat.leagues) {
//           var gh = gymCat.leagues[lg].genderHandles || {};
//           for (var g in gh) {
//             if (gh[g] === currentHandle) return g;  // men-jackets → 'men'
//           }
//         }
//       }

//       // Casual (and any category with category-level genderHandles):
//       // detect gender from the parent handle mapping
//       for (var casCatH in window.ShirtsHierarchy.categories) {
//         var casCat = window.ShirtsHierarchy.categories[casCatH];
//         if (!casCat.genderHandles) continue;
//         for (var casG in casCat.genderHandles) {
//           if (casCat.genderHandles[casG] === currentHandle) return casG;
//         }
//       }

//       var params = new URLSearchParams(window.location.search);
//       var tags = params.getAll('filter.p.tag');
//       for (var i = 0; i < tags.length; i++) {
//         var t = tags[i].toLowerCase();
//         if (t === 'kids') return 'kids';
//         if (t === 'women') return 'women';
//         // 'men' tag also possible, but 'men' is the default so we only need to detect if explicitly set
//       }
//       // Check current handle for the gym parent — default to men
//       if (currentHandle === (gymCat && gymCat.handle)) return (gymCat.defaultGender || 'men');

//       return 'men';
//     } catch (e) { return 'men'; }
//   }

//   function detectTypeTagFromUrl(location) {
//     try {
//       var cat = location && window.ShirtsHierarchy.categories[location.categoryHandle];
//       // For Casual (typesBySeason), scan ALL seasons' types since we don't know the active season yet
//       var typesToCheck = [];
//       if (cat && cat.typesBySeason) {
//         for (var seasonKey in cat.typesBySeason) {
//           typesToCheck = typesToCheck.concat(cat.typesBySeason[seasonKey]);
//         }
//       } else {
//         typesToCheck = getProductTypes(cat);
//       }
//       var params = new URLSearchParams(window.location.search);
//       var tags = params.getAll('filter.p.tag');
//       for (var i = 0; i < tags.length; i++) {
//         for (var j = 0; j < typesToCheck.length; j++) {
//           if (tags[i] === typesToCheck[j].tag) return typesToCheck[j].tag;
//         }
//       }
//       return null;
//     } catch (e) { return null; }
//   }

//   // Detects active season TAG in the URL (Gym only — reads cat.seasons)
//   function detectSeasonFromUrl(location) {
//     try {
//       var cat = location && window.ShirtsHierarchy.categories[location.categoryHandle];
//       if (!cat || !cat.seasons || !cat.seasons.length) return null;
//       var params = new URLSearchParams(window.location.search);
//       var tags = params.getAll('filter.p.tag');
//       for (var i = 0; i < tags.length; i++) {
//         for (var j = 0; j < cat.seasons.length; j++) {
//           if (tags[i] === cat.seasons[j].tag) return cat.seasons[j].tag;
//         }
//       }
//       return null;
//     } catch (e) { return null; }
//   }

//   // ============ URL BUILDING ============
//   function buildUrl(collectionHandle, gender, typeTag, teamTag, extraTag) {
//     var url = '/collections/' + collectionHandle;
//     var params = [];
//     // Gender tag: only add when the collection ISN'T already gender-specific.
//     // Gender-specific gym collections (men-*, women-*) already restrict to that gender
//     // via their smart-collection rules, so adding the tag would be redundant.
//     var isGenderSpecific = /^(men|women)-/.test(collectionHandle) || collectionHandle === 'kids-t-shirt';
//     if (gender === 'kids' && !isGenderSpecific)  params.push('filter.p.tag=' + encodeURIComponent('Kids'));
//     if (gender === 'women' && !isGenderSpecific) params.push('filter.p.tag=' + encodeURIComponent('Women'));
//     if (teamTag)  params.push('filter.p.tag=' + encodeURIComponent(teamTag));
//     if (typeTag)  params.push('filter.p.tag=' + encodeURIComponent(typeTag));
//     if (extraTag) params.push('filter.p.tag=' + encodeURIComponent(extraTag));
//     if (params.length) url += '?' + params.join('&');
//     return url;
//   }

//   // ============ RENDERERS ============

//   function renderGenderTabs(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="gender"]');
//     if (!row) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // Use category-specific gender config if defined (e.g., Gym uses Men/Women)
//     // Otherwise fall back to Men/Kids defaults (Football, F1)
//     var genderConfig = cat && cat.genderTabs;
//     var genders = genderConfig ? Object.keys(genderConfig) : ['men', 'kids'];

//     // Determine base URL for gender switch
//     var league = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     var team = league && league.teams && league.teams[location.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;

//     // Hide any tabs not in this category's gender set; show/update the ones that are
//     ['men', 'kids', 'women'].forEach(function(g) {
//       var tab = row.querySelector('[data-gender="' + g + '"]');
//       if (!tab) return;
//       if (genders.indexOf(g) === -1) {
//         tab.style.display = 'none';
//         return;
//       }
//       tab.style.display = '';

//       // Update label if this category has a custom label
//       if (genderConfig && genderConfig[g] && genderConfig[g].label) {
//         var labelSpan = tab.querySelector('span') || tab;
//         labelSpan.textContent = genderConfig[g].label;
//       }

//       // Build the URL for this gender tab
//       var url;
//       if (cat && cat.handle && cat.leagues && cat.leagues[location.leagueHandle] && cat.leagues[location.leagueHandle].genderHandles) {
//         // Gym: switch to this gender's variant of the current category — preserve brand + season
//         var lgh = cat.leagues[location.leagueHandle].genderHandles;
//         var gymBrand = null, gymSeason = null;
//         try {
//           var pp = new URLSearchParams(window.location.search);
//           var tt = pp.getAll('filter.p.tag');
//           if (cat.brands) {
//             for (var bi = 0; bi < cat.brands.length; bi++) {
//               if (tt.indexOf(cat.brands[bi].tag) !== -1) { gymBrand = cat.brands[bi].tag; break; }
//             }
//           }
//           if (cat.seasons) {
//             for (var si = 0; si < cat.seasons.length; si++) {
//               if (tt.indexOf(cat.seasons[si].tag) !== -1) { gymSeason = cat.seasons[si].tag; break; }
//             }
//           }
//         } catch (e) {}
//         url = buildUrl(lgh[g] || cat.handle, g, null, gymBrand, gymSeason);
//       } else if (cat && cat.casualMode && cat.genderHandles) {
//         // CASUAL: category-level gender handles. Switch to gender's parent, preserve brand/season/type
//         var casBrand = null, casSeason = null;
//         try {
//           var ccp = new URLSearchParams(window.location.search);
//           var cct = ccp.getAll('filter.p.tag');
//           if (cat.brands) {
//             for (var cbi = 0; cbi < cat.brands.length; cbi++) {
//               if (cct.indexOf(cat.brands[cbi].tag) !== -1) { casBrand = cat.brands[cbi].tag; break; }
//             }
//           }
//           if (cat.seasons) {
//             for (var csi = 0; csi < cat.seasons.length; csi++) {
//               if (cct.indexOf(cat.seasons[csi].tag) !== -1) { casSeason = cat.seasons[csi].tag; break; }
//             }
//           }
//         } catch (e) {}
//         url = buildUrl(cat.genderHandles[g] || cat.handle, g, location.activeType, casBrand, casSeason);
//       } else if (cat && cat.genderTabs) {
//         // Gym without a category picked yet: go to parent
//         url = buildUrl(cat.handle || location.categoryHandle, g, null, null, location.activeSeason);
//       } else {
//         // Football / F1
//         var currentColl;
//         var teamTag = null;
//         if (location.teamHandle) {
//           if (isTagBasedTeam) { currentColl = leagueHandleStr(league); teamTag = team.tag; }
//           else { currentColl = location.teamHandle; }
//         } else if (location.leagueHandle) {
//           currentColl = leagueHandleStr(league) || location.leagueHandle;
//         } else {
//           currentColl = cat.handle || location.categoryHandle;
//         }
//         url = buildUrl(currentColl, g, location.activeType, teamTag);
//       }
//       tab.href = url;
//       tab.classList.toggle('is-active', location.activeGender === g);
//     });
//   }

//   function renderCategories(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="categories"]');
//     var carousel = wrapper.querySelector('[data-carousel="categories"]');
//     if (!row || !carousel) return;
//     var cats = window.ShirtsHierarchy.categories;
//     var handles = Object.keys(cats);

//     // Auto-hide if only 1 category exists (no need for a lone pill)
//     if (handles.length <= 1) {
//       row.style.display = 'none';
//       return;
//     }

//     var items = handles.map(function(h) {
//       var isCurrentCategory = h === location.categoryHandle;
//       // The category pill is highlighted whenever the user is IN this category,
//       // at any depth. It's a "you are here" indicator, not a "you're at root" one.
//       var isActive = isCurrentCategory;
//       var catParent = cats[h].handle || h;
//       return {
//         handle: h,
//         title: cats[h].title,
//         isActive: isActive,
//         isCurrent: isCurrentCategory,
//         url: buildUrl(catParent, location.activeGender, null),
//         style: 'compact'
//       };
//     });
//     paintCarousel(carousel, items);
//     row.style.display = '';
//   }

//   function renderLeagues(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="leagues"]');
//     var carousel = wrapper.querySelector('[data-carousel="leagues"]');
//     if (!row || !carousel) return;
//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // CASUAL MODE: no traditional leagues — render BRANDS here instead.
//     if (cat && cat.casualMode && cat.brands && cat.brands.length) {
//       var casualLabel = row.querySelector('.sf-row-label');
//       if (casualLabel) casualLabel.textContent = cat.rowLabel || 'Brand';

//       // Determine current collection (gender-specific parent)
//       var casualColl;
//       if (cat.genderHandles && cat.genderHandles[location.activeGender]) {
//         casualColl = cat.genderHandles[location.activeGender];
//       } else {
//         casualColl = cat.handle || location.categoryHandle;
//       }

//       // Detect active brand tag
//       var casActiveBrand = null;
//       try {
//         var casParams = new URLSearchParams(window.location.search);
//         var casUrlTags = casParams.getAll('filter.p.tag');
//         for (var cbi = 0; cbi < cat.brands.length; cbi++) {
//           if (casUrlTags.indexOf(cat.brands[cbi].tag) !== -1) { casActiveBrand = cat.brands[cbi].tag; break; }
//         }
//       } catch (e) {}

//       // Build pills: "All" + each brand (preserving season + type-if-still-valid)
//       var casBrandItems = [{
//         handle: '__all_brands__',
//         title: 'All',
//         isActive: !casActiveBrand,
//         url: buildUrl(casualColl, location.activeGender, location.activeType, null, location.activeSeason),
//         style: 'compact'
//       }];
//       cat.brands.forEach(function(b) {
//         casBrandItems.push({
//           handle: b.tag,
//           title: b.title,
//           logo: b.logo,
//           isActive: casActiveBrand === b.tag,
//           url: buildUrl(casualColl, location.activeGender, location.activeType, b.tag, location.activeSeason),
//           style: b.logo ? 'with-icon' : 'compact'
//         });
//       });
//       paintCarousel(carousel, casBrandItems);
//       row.style.display = '';
//       return;
//     }

//     if (!cat || !cat.leagues) { row.style.display = 'none'; return; }

//     // Set row label dynamically (F1 uses "BRAND" instead of "LEAGUE")
//     var label = row.querySelector('.sf-row-label');
//     if (label) label.textContent = cat.rowLabel || 'League';

//     var leagueHandles = Object.keys(cat.leagues);

//     // Special: F1 has one synthetic league ('f1') — hide the league row and
//     // show only the brands as the primary carousel (in the teams row).
//     // This avoids showing a single lonely "F1 Brands" pill.
//     if (leagueHandles.length === 1 && cat.f1 !== false) {
//       var onlyLeague = cat.leagues[leagueHandles[0]];
//       if (onlyLeague && onlyLeague.teams && Object.keys(onlyLeague.teams).length > 1) {
//         row.style.display = 'none';
//         return;
//       }
//     }

//     var items = leagueHandles.map(function(h) {
//       var lg = cat.leagues[h];
//       var collectionHandle;

//       // GYM: leagues have per-gender handles — pick the one matching active gender
//       if (lg.genderHandles) {
//         collectionHandle = lg.genderHandles[location.activeGender] || lg.genderHandles.men || h;
//       } else if (Array.isArray(lg.handle)) {
//         collectionHandle = lg.handle[0];
//       } else {
//         collectionHandle = lg.handle || h;
//       }

//       // For gym, detect active brand tag to preserve when switching type
//       var preservedBrand = null;
//       var preservedSeason = null;
//       if (cat.brands || cat.seasons) {
//         try {
//           var params = new URLSearchParams(window.location.search);
//           var urlTags = params.getAll('filter.p.tag');
//           if (cat.brands) {
//             for (var bi = 0; bi < cat.brands.length; bi++) {
//               if (urlTags.indexOf(cat.brands[bi].tag) !== -1) { preservedBrand = cat.brands[bi].tag; break; }
//             }
//           }
//           if (cat.seasons) {
//             for (var si = 0; si < cat.seasons.length; si++) {
//               if (urlTags.indexOf(cat.seasons[si].tag) !== -1) { preservedSeason = cat.seasons[si].tag; break; }
//             }
//           }
//         } catch (e) {}
//       }

//       return {
//         handle: h,
//         title: lg.title,
//         logo: lg.logo,
//         isActive: h === location.leagueHandle && !location.teamHandle,
//         url: buildUrl(collectionHandle, location.activeGender, null, preservedBrand, preservedSeason),
//         style: lg.logo ? 'with-icon' : 'compact'
//       };
//     });
//     paintCarousel(carousel, items);
//     row.style.display = '';
//   }

//   function renderTeams(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="teams"]');
//     var carousel = wrapper.querySelector('[data-carousel="teams"]');
//     if (!row || !carousel) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // GYM MODE: if the category has `brands` and a league is picked,
//     // render brand tag filters (Nike, Adidas) instead of teams
//     if (cat && cat.brands && cat.brands.length && location.leagueHandle) {
//       var league = cat.leagues[location.leagueHandle];
//       // Determine the current gym collection (gender-specific)
//       var currentColl;
//       if (league.genderHandles) {
//         currentColl = league.genderHandles[location.activeGender] || league.genderHandles.men;
//       } else {
//         currentColl = location.leagueHandle;
//       }

//       // Set row label (BRAND)
//       var lbl = row.querySelector('.sf-row-label');
//       if (lbl) lbl.textContent = cat.teamRowLabel || 'Brand';

//       // Detect which brand tag is currently active
//       var activeBrand = null;
//       try {
//         var params = new URLSearchParams(window.location.search);
//         var urlTags = params.getAll('filter.p.tag');
//         for (var i = 0; i < cat.brands.length; i++) {
//           for (var j = 0; j < urlTags.length; j++) {
//             if (urlTags[j] === cat.brands[i].tag) { activeBrand = cat.brands[i].tag; break; }
//           }
//           if (activeBrand) break;
//         }
//       } catch (e) {}

//       // Make row label clickable if a brand is active (jumps to /collections/nike, etc.)
//       // Find the brand's display name (title) for the button label
//       var brandDisplayName = null;
//       if (activeBrand) {
//         for (var bri = 0; bri < cat.brands.length; bri++) {
//           if (cat.brands[bri].tag === activeBrand) {
//             brandDisplayName = cat.brands[bri].title || activeBrand;
//             break;
//           }
//         }
//       }
//       applyLabelClick(
//         row,
//         getLabelClickUrl(cat, 'teams', location, activeBrand, brandDisplayName),
//         cat.teamRowLabel || 'Brand'
//       );
//       // Build pills: "All" + each brand — preserving active season if set
//       var brandItems = [{
//         handle: '__all_brands__',
//         title: 'All',
//         isActive: !activeBrand,
//         url: buildUrl(currentColl, location.activeGender, null, null, location.activeSeason),
//         style: 'type'
//       }];
//       cat.brands.forEach(function(b) {
//         brandItems.push({
//           handle: b.tag,
//           title: b.title,
//           logo: b.logo,
//           isActive: activeBrand === b.tag,
//           url: buildUrl(currentColl, location.activeGender, null, b.tag, location.activeSeason),
//           style: b.logo ? 'with-icon' : 'type'
//         });
//       });
//       paintCarousel(carousel, brandItems);
//       row.style.display = '';
//       return;
//     }

//     // If the category suppresses the team level entirely, hide the row.
//     if (isTeamLevelSuppressed(cat)) { row.style.display = 'none'; return; }

//     // For F1 (single synthetic league), always show the brands row even
//     // when no league is explicitly picked — it IS the primary filter dimension.
//     var leagueForTeams = null;
//     if (location.leagueHandle) {
//       leagueForTeams = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     } else if (cat && cat.leagues) {
//       var leagueKeys = Object.keys(cat.leagues);
//       if (leagueKeys.length === 1) {
//         leagueForTeams = cat.leagues[leagueKeys[0]];
//         location.leagueHandle = leagueKeys[0]; // implicitly select the sole league
//       }
//     }

//     if (!leagueForTeams || !leagueForTeams.teams || !Object.keys(leagueForTeams.teams).length) {
//       row.style.display = 'none';
//       return;
//     }

//     // Set row label dynamically (F1 uses "BRAND" instead of "TEAM")
//     var label = row.querySelector('.sf-row-label');
//     if (label) {
//       if (cat.teamRowLabel) label.textContent = cat.teamRowLabel;
//       else if (cat.rowLabel === 'BRAND') label.textContent = 'Brand';
//       else label.textContent = 'Team';
//     }

//     var items = Object.keys(leagueForTeams.teams).map(function(h) {
//       var t = leagueForTeams.teams[h];
//       var isThisTeam = h === location.teamHandle;
//       var isActive = isThisTeam && !location.activeType;
//       var url;
//       // Tag-based team (International Kits countries)
//       if (t.tag && leagueForTeams.handle) {
//         url = buildUrl(leagueHandleStr(leagueForTeams), location.activeGender, null, t.tag);
//       } else {
//         // Handle-based team (Arsenal, f1-ferrari, etc.)
//         url = buildUrl(h, location.activeGender, null);
//       }
//       return {
//         handle: h,
//         title: t.title,
//         logo: t.logo,
//         isActive: isActive,
//         isCurrent: isThisTeam,
//         url: url,
//         style: 'with-icon'
//       };
//     });
//     paintCarousel(carousel, items);
//     row.style.display = '';
//   }

//   function renderTypes(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="types"]');
//     var carousel = wrapper.querySelector('[data-carousel="types"]');
//     if (!row || !carousel) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];

//     // CASUAL MODE: Season-conditional types (guided flow).
//     // Only show Type row when a season is picked.
//     if (cat && cat.typesBySeason) {
//       if (!location.activeSeason) { row.style.display = 'none'; return; }
//       var casualTypes = getProductTypes(cat, location.activeSeason);
//       if (!casualTypes.length) { row.style.display = 'none'; return; }

//       // Set row label
//       var casualLbl = row.querySelector('.sf-row-label');
//       if (casualLbl) casualLbl.textContent = 'Type';

//       // Determine current collection (gender-specific parent for casual)
//       var casualColl;
//       if (cat.genderHandles && cat.genderHandles[location.activeGender]) {
//         casualColl = cat.genderHandles[location.activeGender];
//       } else {
//         casualColl = cat.handle || location.categoryHandle;
//       }

//       // Detect active brand tag (to preserve when switching type)
//       var casualBrand = null;
//       if (cat.brands) {
//         try {
//           var params = new URLSearchParams(window.location.search);
//           var urlTags = params.getAll('filter.p.tag');
//           for (var bi = 0; bi < cat.brands.length; bi++) {
//             if (urlTags.indexOf(cat.brands[bi].tag) !== -1) { casualBrand = cat.brands[bi].tag; break; }
//           }
//         } catch (e) {}
//       }

//       // Build pills: "All" + each season-specific type (preserving brand + season)
//       var casualItems = [{
//         handle: '__all_types__',
//         title: 'All',
//         isActive: !location.activeType,
//         url: buildUrl(casualColl, location.activeGender, null, casualBrand, location.activeSeason),
//         style: 'type'
//       }];
//       casualTypes.forEach(function(t) {
//         casualItems.push({
//           handle: t.tag,
//           title: t.title,
//           tag: t.tag,
//           isActive: location.activeType === t.tag,
//           url: buildUrl(casualColl, location.activeGender, t.tag, casualBrand, location.activeSeason),
//           style: 'type'
//         });
//       });
//       paintCarousel(carousel, casualItems);
//       // Clickable label: for casual with parent-plus-tag pattern, jumps to catch-all filtered by type
//       var casualTypeName = null;
//       if (location.activeType) {
//         for (var cti = 0; cti < casualTypes.length; cti++) {
//           if (casualTypes[cti].tag === location.activeType) {
//             casualTypeName = casualTypes[cti].title || location.activeType;
//             break;
//           }
//         }
//       }
//       applyLabelClick(
//         row,
//         getLabelClickUrl(cat, 'types', location, location.activeType, casualTypeName),
//         'Type'
//       );
//       row.style.display = '';
//       return;
//     }

//     // Standard mode (Football/F1): types show under a team
//     var types = getProductTypes(cat, location.activeSeason);
//     if (!types.length) { row.style.display = 'none'; return; }

//     // Only show types when a team (leaf) is selected
//     if (!location.teamHandle) { row.style.display = 'none'; return; }

//     var league = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     var team = league && league.teams && league.teams[location.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;
//     var teamCollectionHandle = isTagBasedTeam ? leagueHandleStr(league) : location.teamHandle;
//     var teamTag = isTagBasedTeam ? team.tag : null;

//     var items = [{
//       handle: location.teamHandle,
//       title: 'All',
//       isActive: !location.activeType,
//       url: buildUrl(teamCollectionHandle, location.activeGender, null, teamTag),
//       style: 'type'
//     }];
//     types.forEach(function(t) {
//       items.push({
//         handle: location.teamHandle,
//         title: t.title,
//         tag: t.tag,
//         isActive: location.activeType === t.tag,
//         url: buildUrl(teamCollectionHandle, location.activeGender, t.tag, teamTag),
//         style: 'type'
//       });
//     });
//     paintCarousel(carousel, items);
//     // Clickable KIT label: on F1, jumps to /collections/f1?filter.p.tag=<type>
//     // Find the type's display name for the button
//     var typeDisplayName = null;
//     if (location.activeType) {
//       for (var tdi = 0; tdi < types.length; tdi++) {
//         if (types[tdi].tag === location.activeType) {
//           typeDisplayName = types[tdi].title || location.activeType;
//           break;
//         }
//       }
//     }
//     applyLabelClick(
//       row,
//       getLabelClickUrl(cat, 'types', location, location.activeType, typeDisplayName),
//       'Kit'
//     );
//     row.style.display = '';
//   }

//   // Renders the SEASON row (Gym only). Season is a TAG filter that can be
//   // combined with any other active filter (Type, Brand, Gender).
//   function renderSeasons(wrapper, location) {
//     var row = wrapper.querySelector('[data-level="seasons"]');
//     var carousel = wrapper.querySelector('[data-carousel="seasons"]');
//     if (!row || !carousel) return;

//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];
//     if (!cat || !cat.seasons || !cat.seasons.length) { row.style.display = 'none'; return; }

//     // Set row label
//     var lbl = row.querySelector('.sf-row-label');
//     if (lbl) lbl.textContent = 'Season';

//     // Determine current collection (gender-specific for gym at league level, casual at category level)
//     var currentColl;
//     if (location.leagueHandle && cat.leagues && cat.leagues[location.leagueHandle] && cat.leagues[location.leagueHandle].genderHandles) {
//       // Gym: league-level gender handles
//       var gh = cat.leagues[location.leagueHandle].genderHandles;
//       currentColl = gh[location.activeGender] || gh.men;
//     } else if (cat.genderHandles) {
//       // Casual: category-level gender handles
//       currentColl = cat.genderHandles[location.activeGender] || cat.handle || location.categoryHandle;
//     } else {
//       currentColl = cat.handle || location.categoryHandle;
//     }

//     // Determine active brand tag (to preserve when switching season)
//     var activeBrandTag = null;
//     if (cat.brands) {
//       try {
//         var params = new URLSearchParams(window.location.search);
//         var urlTags = params.getAll('filter.p.tag');
//         for (var i = 0; i < cat.brands.length; i++) {
//           for (var j = 0; j < urlTags.length; j++) {
//             if (urlTags[j] === cat.brands[i].tag) { activeBrandTag = cat.brands[i].tag; break; }
//           }
//           if (activeBrandTag) break;
//         }
//       } catch (e) {}
//     }

//     // Helper: given a target season, check if the currently active type is still valid.
//     // For Casual (typesBySeason), a type only belongs to one season, so switching season
//     // must drop the type unless it exists in the target season's type list.
//     function typeStillValid(targetSeasonTag) {
//       if (!location.activeType) return null;
//       if (!cat.typesBySeason) return location.activeType; // non-casual: type always compatible
//       if (!targetSeasonTag) return null; // moving to "All" seasons — drop type (guided flow needs season)
//       var targetTypes = cat.typesBySeason[targetSeasonTag] || [];
//       for (var ti = 0; ti < targetTypes.length; ti++) {
//         if (targetTypes[ti].tag === location.activeType) return location.activeType;
//       }
//       return null; // type doesn't exist in target season → drop it
//     }

//     // Build pills: "All" + each season
//     // Note: brand tag goes in teamTag slot, season goes in extraTag slot
//     // For casual, we ALSO preserve type IF compatible with the target season.
//     var seasonItems = [{
//       handle: '__all_seasons__',
//       title: 'All',
//       isActive: !location.activeSeason,
//       url: buildUrl(currentColl, location.activeGender, typeStillValid(null), activeBrandTag, null),
//       style: 'type'
//     }];
//     cat.seasons.forEach(function(s) {
//       var title = s.emoji ? (s.emoji + ' ' + s.title) : s.title;
//       seasonItems.push({
//         handle: s.tag,
//         title: title,
//         isActive: location.activeSeason === s.tag,
//         url: buildUrl(currentColl, location.activeGender, typeStillValid(s.tag), activeBrandTag, s.tag),
//         style: 'type'
//       });
//     });
//     paintCarousel(carousel, seasonItems);
//     row.style.display = '';
//   }

//   function renderBreadcrumb(wrapper, location) {
//     var el = wrapper.querySelector('.sf-breadcrumb');
//     if (!el) return;
//     var parts = [];
//     var cat = window.ShirtsHierarchy.categories[location.categoryHandle];
//     var league = cat && cat.leagues && cat.leagues[location.leagueHandle];
//     var team = league && league.teams && league.teams[location.teamHandle];
//     var isTagBasedTeam = team && team.tag && league && league.handle;

//     // 1) Gender
//     var currentColl;
//     var teamTag = null;
//     if (location.teamHandle) {
//       if (isTagBasedTeam) { currentColl = leagueHandleStr(league); teamTag = team.tag; }
//       else { currentColl = location.teamHandle; }
//     } else if (location.leagueHandle) {
//       currentColl = leagueHandleStr(league) || location.leagueHandle;
//     } else {
//       currentColl = cat.handle || location.categoryHandle;
//     }
//     parts.push({
//       text: location.activeGender === 'kids' ? 'Kids' : 'Men',
//       url: buildUrl(currentColl, location.activeGender, location.activeType, teamTag)
//     });

//     // 2) Category
//     if (cat) parts.push({
//       text: cat.title,
//       url: buildUrl(cat.handle || location.categoryHandle, location.activeGender, null)
//     });

//     // 3) League (skip for F1's synthetic single league — redundant with category)
//     var categoryLeagueKeys = cat && cat.leagues ? Object.keys(cat.leagues) : [];
//     var isSyntheticSingleLeague = categoryLeagueKeys.length === 1;

//     if (location.leagueHandle && league && !isSyntheticSingleLeague) {
//       var lgHandle = leagueHandleStr(league) || location.leagueHandle;
//       parts.push({
//         text: league.title,
//         url: buildUrl(lgHandle, location.activeGender, null)
//       });
//     }

//     // 4) Team
//     if (location.teamHandle && team) {
//       var teamUrl;
//       if (isTagBasedTeam) {
//         teamUrl = buildUrl(leagueHandleStr(league), location.activeGender, null, team.tag);
//       } else {
//         teamUrl = buildUrl(location.teamHandle, location.activeGender, null);
//       }
//       parts.push({ text: team.title, url: teamUrl });
//     }

//     // 5) Product type
//     if (location.activeType) {
//       var types = getProductTypes(cat, location.activeSeason);
//       var match = types.filter(function(p) { return p.tag === location.activeType; })[0];
//       if (match) {
//         var typeUrl;
//         if (isTagBasedTeam) {
//           typeUrl = buildUrl(leagueHandleStr(league), location.activeGender, match.tag, team.tag);
//         } else if (location.teamHandle) {
//           typeUrl = buildUrl(location.teamHandle, location.activeGender, match.tag);
//         } else {
//           typeUrl = buildUrl(cat.handle || location.categoryHandle, location.activeGender, match.tag);
//         }
//         parts.push({ text: match.title, url: typeUrl });
//       }
//     }

//     el.innerHTML = parts.map(function(p, i) {
//       var isLast = i === parts.length - 1;
//       var sep = i > 0 ? '<span class="sf-crumb-sep"> › </span>' : '';
//       return sep + '<a class="sf-crumb' + (isLast ? ' is-current' : '') + '" href="' + p.url + '">' + escapeHtml(p.text) + '</a>';
//     }).join('');
//   }

//   // ============ PAINT & UTILITIES ============

//   function paintCarousel(carousel, items) {
//     carousel.innerHTML = '';
//     items.forEach(function(item) {
//       var link = document.createElement('a');
//       var cls = 'sf-item';
//       if (item.isActive) cls += ' is-active';
//       else if (item.isCurrent) cls += ' is-current';
//       if (item.style === 'with-icon') {
//         cls += ' sf-with-icon';
//       } else if (item.style === 'type') {
//         cls += ' sf-type';
//       } else {
//         cls += ' sf-compact';
//       }
//       link.className = cls;
//       link.href = item.url;
//       link.setAttribute('data-handle', item.handle);
//       if (item.style === 'with-icon') {
//         var logoHtml = item.logo
//           ? '<img class="sf-item-logo-img" src="' + item.logo + '" alt="' + escapeHtml(item.title) + '" loading="lazy" onerror="this.style.display=\'none\'">'
//           : '<span class="sf-item-logo-fallback">' + escapeHtml(item.title.charAt(0)) + '</span>';
//         link.innerHTML =
//           '<div class="sf-item-logo">' + logoHtml + '</div>' +
//           '<div class="sf-item-title">' + escapeHtml(item.title) + '</div>';
//       } else {
//         link.innerHTML = escapeHtml(item.title);
//       }
//       attachClickFeedback(link, item.isActive);
//       carousel.appendChild(link);
//     });
//   }

//   function setupArrows(carousel) {
//     var container = carousel.closest('.sf-carousel-container');
//     if (!container) return;
//     var prev = container.querySelector('.sf-arrow-prev');
//     var next = container.querySelector('.sf-arrow-next');
//     if (!prev || !next) return;
//     function scroll(delta) { carousel.scrollBy({ left: delta, behavior: 'smooth' }); }
//     prev.onclick = function() { scroll(-260); };
//     next.onclick = function() { scroll(260); };
//     function checkOverflow() {
//       var hasOverflow = carousel.scrollWidth > carousel.clientWidth + 4;
//       container.classList.toggle('has-overflow', hasOverflow);
//     }
//     checkOverflow();
//     window.addEventListener('resize', checkOverflow);
//   }

//   function attachClickFeedback(link, alreadyActive) {
//     if (alreadyActive) {
//       link.addEventListener('click', function(e) { e.preventDefault(); });
//       return;
//     }
//     link.addEventListener('click', function() { link.classList.add('is-loading'); });
//   }

//   function scrollIntoView(el) {
//     try { el.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); }
//     catch (e) {}
//   }

//   function escapeHtml(s) {
//     return String(s).replace(/[&<>"']/g, function(c) {
//       return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
//     });
//   }
// })();



